{
  "material.outdated.title": "Questo materiale è stato aggiornato",
  "material.outdated.description": "Copia le risposte non ancora inviate, poi aggiorna questa pagina nel browser per continuare.",
  "material.autosave.saved": "Salvato",
  "material.autosave.description": "Le modifiche vengono salvate automaticamente.",
  "material.autosave.saving": "Salvataggio …",
  "material.autosave.failed": "Non salvato",
  "ai.assistant.sharing.title": "Condividi materiale",
  "ai.assistant.sharing.recipients": "Condividi con",
  "ai.assistant.sharing.hide.title": "Nascondi materiale",
  "ai.assistant.sharing.hide.recipients": "Nascondi a",
  "ai.assistant.sharing.hide.confirm": "Nascondi",
  "ai.assistant.sharing.hide.confirmed": "Nascosto",
  "ai.assistant.sharing.all_students": "Tutti gli studenti di questo corso",
  "ai.assistant.sharing.pending": "La visibilità di questi materiali cambia solo dopo la tua conferma.",
  "ai.assistant.sharing.confirmed": "Condiviso",
  "ai.assistant.sharing.discarded": "Modifica annullata",
  "ai.assistant.sharing.error": "Non è stato possibile aggiornare la visibilità. Riprova.",
  "ai.assistant.composer.attachment_size_limit": "Ogni file deve avere una dimensione massima di {{size}} MiB. Scegli un file più piccolo.",
  "course_students.access_cards.login_instruction": "Apri {{url}} e inserisci il tuo codice.",
  "course_students.access_cards.course_scope_hint": "Questi codici consentono agli alunni e alle alunne di accedere a tutti i materiali condivisi nel corso «{{courseName}}».",
  "ai.assistant.student_note.loading": "Caricamento della documentazione …",
  "ai.assistant.student_note.discarded": "Questa bozza è stata scartata o non è più disponibile.",
  "ai.assistant.student_note.student": "Studente",
  "ai.assistant.student_note.edit": "Modifica la documentazione o lo studente",
  "ai.assistant.student_note.discard": "Scarta la bozza",
  "ai.assistant.student_note.open_student": "Apri la scheda dello studente",
  "ai.assistant.student_note.error": "Impossibile caricare o aggiornare la documentazione. Riprova.",
  "ai.assistant.student_note.retry": "Riprova",
  "ai.assistant.student_privacy.protected": "Protetto",
  "ai.assistant.student_privacy.hint": "Il nome viene sostituito automaticamente con uno pseudonimo casuale",
  "auth.signup_v2.continue_with_provider": "Continua con {{provider}}",
  "auth.signup_v2.marketing_title": "La piattaforma didattica\nche pensa insieme a te.",
  "auth.signup_v2.marketing_description": "Pianificazione, materiali, compiti e documentazione in un unico luogo – collegati da un assistente IA che collabora e realizza le tue idee.",
  "auth.signup_v2.start_free": "Inizia gratis",
  "integration.google.description": "Accedi a Teachino con il tuo account Google.",
  "integration.authenticate_google.description": "Accedi a Teachino con il tuo account Google.",
  "onboarding.iam_banner.title": "Attiva la tua licenza Teachino gratuita con IAM",
  "onboarding.iam_banner.description": "WebUntis è già collegato. Accedi con il tuo account IAM (CGIE) per completare la configurazione e attivare la tua licenza gratuita.",
  "onboarding.iam_banner.connect": "Accedi con IAM",
  "onboarding.webuntis_banner.title": "Collega il tuo orario per importare i corsi da WebUntis",
  "onboarding.webuntis_banner.step_open": "Apri WebUntis in una nuova scheda, accedi e seleziona «Teachino» nel menu principale. Se la voce non compare, chiedi alla tua amministrazione di attivarla.",
  "onboarding.webuntis_banner.step_connect": "Conferma il collegamento al tuo account Teachino.",
  "onboarding.webuntis_banner.step_ready": "Qui troverai i tuoi corsi, il tuo orario e i tuoi studenti di WebUntis.",
  "onboarding.webuntis_banner.tutorial": "Visualizza la guida completa",
  "onboarding.webuntis_banner.dismiss": "Nascondi",
  "generic_prompt": "Prompt",
  "timetable.course_first_banner.feedback": "Attendiamo il tuo feedback: hallo@teachino.io",
  "integration.authenticate_europathek.description": "La connessione tra Teachino e la EUROPATHEK consente l'iscrizione automatica su Teachino.",
  "integration.europathek.description": "Per docenti: collega Teachino con la EUROPATHEK.",
  "feature_course.onboarding.progress.aria_label": "Progresso del onboarding",
  "feature_course.onboarding.step_label.country": "Paese",
  "feature_course.onboarding.step_label.school_type": "Tipo di scuola",
  "feature_course.onboarding.step_label.subject": "Materia",
  "feature_course.onboarding.step_label.class_level": "Classe",
  "feature_course.onboarding.step_label.summary": "Riepilogo",
  "feature_course.onboarding.step_label.unknown": "Sconosciuto",
  "feature_course.onboarding.country.title": "Benvenuto in Teachino",
  "feature_course.onboarding.country.description": "Iniziamo con alcune brevi domande per adattare Teachino alla tua giornata scolastica.",
  "feature_course.onboarding.country.other_option": "Altro paese",
  "feature_course.onboarding.country.other_input_label": "Paese",
  "feature_course.onboarding.country.other_placeholder": "Inserisci il tuo paese",
  "feature_course.onboarding.state.title": "Regione",
  "feature_course.onboarding.state.other_option": "Altra regione",
  "feature_course.onboarding.state.other_input_label": "Regione",
  "feature_course.onboarding.state.other_placeholder": "Inserisci la tua regione",
  "feature_course.onboarding.school_type.title": "Quale tipo di scuola?",
  "feature_course.onboarding.school_type.description": "L'IA adatta i risultati alla tua scuola",
  "feature_course.onboarding.school_type.other_option": "Altro tipo di scuola",
  "feature_course.onboarding.school_type.other_input_label": "Tipo di scuola",
  "feature_course.onboarding.school_type.other_placeholder": "Inserisci il tuo tipo di scuola",
  "feature_course.onboarding.subject.title": "Con quale materia vuoi iniziare?",
  "feature_course.onboarding.subject.description": "Puoi aggiungere altre materie successivamente.",
  "feature_course.onboarding.subject_group.languages": "Lingue",
  "feature_course.onboarding.subject_group.natural_sciences": "Scienze naturali",
  "feature_course.onboarding.subject_group.social_studies": "Studi sociali",
  "feature_course.onboarding.subject_group.vocational": "Professionale",
  "feature_course.onboarding.subject_group.mandatory": "Materie obbligatorie",
  "feature_course.onboarding.subject_group.other": "Altre materie",
  "feature_course.onboarding.subject.other_option": "Altra materia",
  "feature_course.onboarding.subject.other_placeholder": "Inserisci la tua materia",
  "feature_course.onboarding.subject.other_label": "Inserisci la materia",
  "feature_course.onboarding.class_level.title": "In quale classe insegni {{subject}}?",
  "feature_course.onboarding.class_level.description": "Puoi aggiungere ulteriori classi successivamente.",
  "feature_course.onboarding.class_level.other_option": "Altra classe",
  "feature_course.onboarding.class_level.other_input_label": "Classe",
  "feature_course.onboarding.class_level.other_placeholder": "Inserisci la tua classe",
  "feature_course.onboarding.summary.title": "Quasi pronto!",
  "feature_course.onboarding.summary.description": "Verifica e adatta il tuo corso",
  "feature_course.onboarding.summary.more_courses_hint": "Potrai creare altri corsi in qualsiasi momento in seguito.",
  "feature_course.onboarding.summary.course_name_label": "Nome del corso",
  "feature_course.onboarding.summary.class_name_label": "Classe",
  "feature_course.onboarding.summary.class_name_label_example": "Classe (ad es. {{example}})",
  "feature_course.onboarding.summary.subject_name_label": "Materia",
  "feature_course.onboarding.summary.course_name_preview": "Il nome del tuo corso",
  "feature_course.onboarding.summary.color_label": "Colore",
  "feature_course.onboarding.fallback.step": "Passaggio {{step}}: {{label}}",
  "feature_course.onboarding.fallback.not_implemented": "Questo passaggio non è ancora implementato.",
  "feature_course.onboarding.fallback.content_area": "Area dei contenuti",
  "feature_course.onboarding.debug.title": "Informazioni di debug",
  "feature_course.onboarding.debug.no_selections": "Nessuna selezione effettuata.",
  "feature_course.onboarding.debug.toggle": "Mostra debug",
  "feature_course.onboarding.action.create_course": "Crea corso",
  "feature_course.onboarding.common.other": "Altro",
  "feature_course.onboarding.common.type_own_value": "Inserisci il tuo valore",
  "editor.image_selector.libraries.search": "Cerca libro",
  "material.block_menu.listening": "Testo audio",
  "material.tab_share_preview": "Anteprima & Condivisione",
  "material.share.visibility_hint": "Gli studenti vedono il materiale solo dopo che è stato sbloccato con l'occhio.",
  "material.editor.multiple_choice.validation.min_answers": "Per favore, specifica almeno due risposte.",
  "material.editor.multiple_choice.validation.correct_answer": "Per favore, contrassegna almeno una risposta corretta.",
  "material.editor.multiple_choice.feedback.correct": "Ottimo! Tutto corretto.",
  "material.editor.multiple_choice.feedback.partially": "Parzialmente corretto. Controlla le selezioni e riprova.",
  "material.editor.multiple_choice.feedback.incorrect": "Non ancora corretto. Controlla le selezioni e riprova.",
  "material.editor.multiple_choice.state.correct_selected": "Correttamente selezionato",
  "material.editor.multiple_choice.state.incorrect_selected": "Selezionato erroneamente",
  "material.editor.multiple_choice.state.missed_correct": "Risposta corretta non selezionata",
  "material.editor.listening.badge": "Testo audio",
  "material.editor.listening.placeholder": "Digita il testo da leggere",
  "material.editor.listening.edit_open": "Modifica testo",
  "material.editor.listening.edit_close": "Nascondi modifica testo",
  "material.editor.listening.generating": "Generazione audio in corso...",
  "material.editor.listening.empty_state": "Digita un testo per generare l'audio.",
  "material.editor.listening.audio_unavailable": "Audio non disponibile",
  "material.editor.listening.listen": "Ascolta",
  "material.editor.listening.stop": "Ferma",
  "material.editor.listening.generation_failed": "Impossibile generare audio.",
  "material.editor.listening.retry": "Riprova",
  "material.editor.gap_text.placeholder": "Inserisci qui il tuo testo",
  "material.editor.gap_text.hint": "Seleziona del testo per creare una lacuna, oppure clicca su una parola evidenziata e scegli «Rimuovi lacuna»",
  "material.editor.gap_text.validation.min_gaps": "Contrassegna almeno una parola come lacuna",
  "material.editor.gap_text.word_bank_for_students": "Banca parole per alunni/e",
  "material.editor.gap_text.word_bank_off": "No",
  "material.editor.gap_text.word_bank_on": "Sì",
  "material.editor.gap_text.word_bank": "Banca parole",
  "material.editor.gap_text.word_bank_drop_return": "Trascina qui per restituire la parola",
  "material.editor.gap_text.word_bank_all_used": "Tutte le parole utilizzate",
  "material.editor.gap_text.actions": "Azioni testo con lacune",
  "material.editor.gap_text.mark_as_gap": "Contrassegna come lacuna",
  "material.editor.gap_text.remove_gap": "Rimuovi lacuna",
  "material.editor.gap_text.evaluation.correct": "Corretto",
  "material.editor.gap_text.evaluation.capitalization": "Controlla le maiuscole e minuscole",
  "material.editor.gap_text.evaluation.incorrect": "Errato",
  "generic_link_copied_to_clipboard": "Link copiato negli appunti",
  "generic_loading": "Caricamento in corso...",
  "auth_verify_resend_success": "Una nuova email è stata inviata a te.",
  "library.recent_materials.empty_state.title": "Nessun materiale creato ancora.",
  "library.recent_materials.empty_state.description": "Non appena crei il tuo primo materiale, apparirà qui. I materiali possono includere compiti interattivi con feedback IA, immagini, link, file e molto altro.",
  "library.recent_materials.empty_state.cta": "Crea materiale",
  "item_detail.file_replace": "Sostituisci file",
  "onboarding.skip": "Salta",
  "editor.tools.video.caption.label": "Descrizione video",
  "editor.tools.video.caption.placeholder": "Descrivi il video",
  "material.block_menu.text": "Testo",
  "material.block_menu.open_question": "Domande aperte",
  "material.block_menu.questions_reproduction": "Genera domande sulla riproduzione",
  "material.block_menu.questions_reorganisation": "Genera domande sulla riorganizzazione",
  "material.block_menu.questions_reflection": "Genera domande sulla riflessione",
  "material.block_menu.multiple_choice": "Domanda a scelta multipla",
  "material.block_menu.matching": "Esercizio di abbinamento",
  "material.editor.matching.badge": "Esercizio di abbinamento",
  "material.editor.matching.instruction_placeholder": "Scrivi qui la consegna, ad es. «Trova le traduzioni corrette».",
  "material.editor.matching.no_instruction": "Nessuna consegna",
  "material.editor.matching.left_placeholder": "Termine (a sinistra)",
  "material.editor.matching.right_placeholder": "Termine corrispondente (a destra)",
  "material.editor.matching.add_pair": "Aggiungi coppia",
  "material.editor.matching.reorder": "Sposta",
  "material.editor.matching.connect_hint": "Collega i termini che corrispondono: traccia una linea da sinistra a destra oppure tocca un termine e poi l'altro.",
  "material.editor.matching.print_hint": "Abbina ogni scheda a sinistra alla scheda corrispondente a destra. Traccia una linea tra le due schede.",
  "material.editor.matching.submit": "Invia",
  "material.editor.matching.redo": "Modifica gli abbinamenti",
  "material.editor.matching.reset": "Reimposta",
  "material.editor.matching.validation.min_pairs": "Aggiungi almeno due coppie complete.",
  "material.editor.matching.feedback.correct": "Ottimo! Tutte le coppie sono corrette.",
  "material.editor.matching.feedback.partially": "Parzialmente corretto. Controlla gli abbinamenti e riprova.",
  "material.editor.matching.feedback.incorrect": "Non ancora corretto. Controlla gli abbinamenti e riprova.",
  "material.editor.matching.state.correct": "Abbinato correttamente",
  "material.editor.matching.state.incorrect": "Abbinato in modo errato",
  "material.editor.matching.state.missing": "Non abbinato",
  "material.editor.matching.correct_answer": "Risposta corretta",
  "material.editor.matching.shuffle_hint": "Nota: per alunni/e la colonna di destra viene mescolata automaticamente.",
  "material.editor.matching.read_hint": "Tieni premuto un termine per leggere il testo completo.",
  "material.editor.matching.peek_label": "Testo completo",
  "material.block_menu.gap_text": "Cloze",
  "material.block_menu.gap_text_generate": "Genera cloze",
  "material.block_menu.flashcards": "Flashcard",
  "material.block_menu.flashcards_add": "Aggiungi flashcard",
  "material.block_menu.flashcards_generate": "Genera flashcard",
  "material.tab_share": "Condividi",
  "material.ai_suggestions.custom_prompt": "Inserisci prompt",
  "material.ai_edit.title": "Rivedi materiale con IA",
  "material.ai_edit.paywall.description": "Sottoscrivi una licenza ora per rivedere materiali didattici con l'IA.",
  "material.ai_create.title": "Crea materiale con IA",
  "material.ai_edit.placeholder": "Scrivi come l'IA dovrebbe revisionare il materiale",
  "material.ai_edit.suggestions_title": "Suggerimenti",
  "material.ai.edit.suggestion_1_label": "Semplificare",
  "material.ai_edit.suggestion_1": "Semplifica l'intero materiale",
  "material.ai.edit.suggestion_2_label": "Cambia focus",
  "material.ai_edit.suggestion_2": "Cambia il focus del materiale in:",
  "material.ai.edit.suggestion_3_label": "Tradurre",
  "material.ai_edit.suggestion_3": "Traduci il materiale in:",
  "material.ai.edit.suggestion_4_label": "Compiti interattivi",
  "material.ai_edit.suggestion_4": "Aggiungi compiti interattivi pertinenti al materiale.",
  "material.ai.edit.suggestion_5_label": "Approfondire",
  "material.ai_edit.suggestion_5": "Approfondisci il contenuto del materiale.",
  "material.ai.edit.suggestion_6_label": "Accorciare",
  "material.ai_edit.suggestion_6": "Riduci il materiale all'essenziale.",
  "material.ai.edit.suggestion_7_label": "Aggiungere compiti",
  "material.ai_edit.suggestion_7": "Aggiungi ulteriori compiti con i seguenti operatori:",
  "material.ai.edit.suggestion_8_label": "Compiti extra",
  "material.ai_edit.suggestion_8": "Aggiungi compiti extra di riflessione per alunni/e che finiscono prima.",
  "material.ai.edit.suggestion_9_label": "Migliora struttura",
  "material.ai_edit.suggestion_9": "Rendi il materiale più chiaro utilizzando intestazioni chiare, sezioni logiche e paragrafi.",
  "material.ai.edit.suggestion_10_label": "Riassumi",
  "material.ai_edit.suggestion_10": "Crea un breve riassunto dei punti chiave alla fine.",
  "material.ai.edit.suggestion_11_label": "Rigenerare",
  "material.ai_edit.suggestion_11": "Crea nuovamente l'intero materiale.",
  "material.ai.create.suggestion_1_label": "Scheda di lavoro",
  "material.ai.create.suggestion_1": "Crea una scheda di lavoro sul tema:",
  "material.ai.create.suggestion_2_label": "Svolgimento della lezione",
  "material.ai.create.suggestion_2": "Crea lo svolgimento di una lezione sul tema:",
  "material.ai.create.suggestion_3_label": "Esercizio interattivo",
  "material.ai.create.suggestion_3": "Crea un esercizio interattivo sul tema:",
  "material.ai.create.suggestion_4_label": "Introduzione alla lezione",
  "material.ai.create.suggestion_4": "Crea un'introduzione motivante e orientata agli studenti sul tema:",
  "material.ai.create.suggestion_5_label": "Idee per la prossima lezione",
  "material.ai.create.suggestion_5": "Sviluppa idee per la prossima lezione.",
  "material.ai.create.suggestion_6_label": "Obiettivi di apprendimento",
  "material.ai.create.suggestion_6": "Formula obiettivi di apprendimento sul tema:",
  "material.ai_state.generated": "Materiale generato",
  "material.ai_state.undo": "Annulla",
  "material.ai_state.save_as_new": "Salva come nuovo materiale",
  "material.ai_state.accept": "Salva",
  "material.ai_save_as_new.description": "Il risultato sarà salvato come nuovo materiale. Ciò consente di creare versioni differenziate di un materiale, ad esempio.",
  "material.ai_save_as_new.name_label": "Nome del nuovo materiale",
  "material.ai_save_as_new.name_placeholder": "Nome del nuovo materiale",
  "material.ai_save_as_new.copy_suffix": " (Copia)",
  "material.ai_save_as_new.success_title": "Nuovo materiale salvato",
  "material.ai_save_as_new.success_message": "Il nuovo materiale è stato creato e aperto.",
  "material.pdf_export": "Salva / stampa PDF",
  "material.pdf_export_beautiful": "PDF elegante",
  "material.docx_export": "Word (.docx)",
  "material.docx_export_with_notes": "Word (.docx) con note",
  "material.search_placeholder": "Cerca materiali",
  "material.generate": "Genera materiale con IA",
  "material.editor.text.generate_questions": "Genera domande sul testo",
  "material.editor.text.simplify": "Semplifica testo",
  "material.editor.text.label": "Blocco di testo",
  "material.editor.text.placeholder": "Digita il testo",
  "material.editor.callout.label": "Pro memoria",
  "material.editor.callout.placeholder": "Scrivi qui",
  "material.save_conflict.title": "E disponibile una versione piu recente del materiale",
  "material.save_conflict.close": "Chiudi",
  "material.save_conflict.reload": "Ricarica materiale",
  "material.save_conflict.body_updated": "Questo materiale è stato aggiornato dopo l'apertura di questo editor.",
  "material.save_conflict.body_reload_warning": "Ricaricando verrà caricata la versione più recente del materiale. Le modifiche non salvate in questa versione obsoleta andranno perse.",
  "material.editor.details.summary_label": "Titolo del menu a discesa",
  "material.editor.details.summary_placeholder": "Titolo",
  "material.editor.details.content_label": "Contenuto del menu a discesa",
  "material.editor.details.placeholder": "Scrivi qui",
  "material.editor.block.ai_suggestion": "Suggerimento IA",
  "material.editor.block.reject": "Rifiuta",
  "material.editor.block.accept": "Accetta",
  "material.editor.block.teacher_only": "Visibile solo agli docenti",
  "material.editor.block.adjust_results": "Adatta risultati",
  "material.editor.block.prompt_placeholder": "Inserisci prompt",
  "material.editor.block_number.image": "B{{number}}",
  "material.editor.assignment_open_question.placeholder": "Digita qui la domanda",
  "material.editor.assignment_open_question.hint_loading": "Consiglio in caricamento",
  "material.editor.assignment_open_question.badge": "Compito con feedback IA",
  "material.editor.assignment_open_question.guidance_hint": "Inserisci qui criteri di feedback o una risposta modello.",
  "material.editor.assignment_open_question.guidance_hint_short": "Inserisci qui i criteri di feedback",
  "material.editor.assignment_open_question.guidance_input_placeholder": "Inserisci qui i criteri di feedback",
  "material.editor.assignment_open_question.guidance_collapsed_empty": "Non ancora definiti",
  "material.editor.assignment_open_question.preview_cta": "Prova feedback IA",
  "material.editor.assignment_open_question.preview_title": "Prova la domanda dal punto di vista dei tuoi alunni/e",
  "material.editor.assignment_open_question.language_assessment.label": "Criteri per il feedback IA sulla lingua",
  "material.editor.assignment_open_question.language_assessment.description": "Attiva o disattiva le opzioni desiderate.",
  "material.editor.assignment_open_question.language_assessment.chip.grammar_spelling": "Grammatica e ortografia",
  "material.editor.assignment_open_question.language_assessment.chip.allow_all_languages": "Consenti tutte le lingue",
  "material.editor.assignment_open_question.language_assessment.feedback_label": "Lingua",
  "material.editor.assignment_open_question.help.cta": "Leggi la guida completa",
  "material.editor.assignment_open_question.help.title": "Guida: Utilizzare l'IA in classe",
  "material.editor.assignment_open_question.help.link": "Guida: Utilizzare l'IA in classe",
  "material.editor.multiple_choice.badge": "Domanda a scelta multipla",
  "material.editor.multiple_choice.choice_type": "Tipo di scelta",
  "material.editor.multiple_choice.single_choice": "Scelta singola",
  "material.editor.multiple_choice.multiple_choice": "Scelta multipla",
  "material.editor.multiple_choice.option_placeholder": "Risposta {{index}}",
  "material.editor.multiple_choice.allow_multiple": "Consentire selezioni multiple",
  "material.editor.multiple_choice.add_option": "Aggiungi risposta",
  "material.editor.multiple_choice.randomized_order_hint": "L'ordine delle risposte viene randomizzato per alunni/e.",
  "material.editor.multiple_choice.no_question": "L'docente non ha ancora formulato una domanda.",
  "material.editor.multiple_choice.answer_option_default": "Opzione di risposta",
  "material.editor.multiple_choice.correct": "Corretto",
  "material.editor.multiple_choice.info.title": "Alunni/e ricevono consigli dall'IA",
  "material.editor.multiple_choice.info.description": "Se viene scelta la risposta sbagliata, alunni/e ricevono un consiglio.",
  "material.editor.multiple_choice.preview_cta": "Prova",
  "material.editor.image.search_other": "Cerca un'altra immagine",
  "material.editor.image.upload_other": "Carica un'altra immagine",
  "material.editor.image.generate": "Genera immagine",
  "material.editor.image.no_results": "Nessun risultato trovato.",
  "material.editor.image.alternative_for": "Immagini alternative per \"{{keywords}}\"",
  "material.editor.image.source_label": "Fonte:",
  "material.editor.image.author_label": "Autore:",
  "material.editor.image.suggestions_title": "Suggerimenti alternativi <br />",
  "material.editor.file.uploading": "Caricamento file in corso",
  "material.editor.file.upload_error": "File non caricato.",
  "material.editor.file.retry": "Riprova",
  "material.editor.file.upload": "Carica file",
  "material.editor.link.enter": "Inserisci link",
  "material.editor.link.invalid": "Inserisci un link valido, per favore.",
  "material.editor.link.remove_preview": "Rimuovi anteprima",
  "material.save_as_new_dialog.title": "Salva come nuovo materiale",
  "material.save_as_new_dialog.description": "Inserisci il nome per il nuovo materiale.",
  "material.save_as_new_dialog.placeholder": "Inserisci il nome",
  "material.save_as_new_dialog.confirm": "Salva come nuovo materiale",
  "material.chat.age_select.tooltip": "Età di alunni/e: l'IA adatta la difficoltà e i metodi all'età dei tuoi alunni/e",
  "material.chat.language_select.tooltip": "In quale lingua l'IA deve generare risultati?",
  "ipi.system_prompt.label": "Prompt di sistema (se vuoto, si utilizza il prompt standard)",
  "ipi.system_prompt.placeholder": "Il Prompt principale",
  "ipi.usage.remaining_1": "Ancora una richiesta possibile",
  "ipi.prompt.too_generic": "La tua richiesta è troppo generica. Fornisci un argomento specifico, una materia o un focus tematico (ad es. \"Foglio di lavoro sulla fotosintesi\" o \"Spiegazione della Rivoluzione Francese\"). Così posso creare materiale adatto per te.",
  "ipi.prompt.rejected_by_agent": "Per favore, fai una domanda su un argomento scolastico adatto per l'insegnamento o l'apprendimento.",
  "ipi.prompt.generic_error": "Qualcosa è andato storto. Riprova per favore.",
  "ipi.prompt_history.title": "Cronologia prompt",
  "ipi.prompt_history.open": "Apri la cronologia prompt",
  "ipi.prompt_history.empty_state": "Non hai ancora usato alcun prompt.",
  "ipi.prompt_history.select": "Usa prompt",
  "ipi.prompt.failed": "Materiale non generato. Riprova per favore.",
  "ipi.more_tools.title": "Altri strumenti IA",
  "ipi.material.done_description_after": ", per adattare il materiale.",
  "ipi.inspiration.heading": "Ispirazione",
  "ipi.inspiration.try_example": "Prova esempio",
  "ipi.inspiration.examples.1.subject": "Educazione digitale",
  "ipi.inspiration.examples.1.title": "Intelligenza artificiale",
  "ipi.inspiration.examples.1.prompt": "Crea un foglio di lavoro in cui alunni/e lavorano passo passo per capire cos'è l'IA, quali vantaggi, svantaggi e pericoli comporta. Alunni/e hanno poche conoscenze su questo tema.",
  "ipi.inspiration.examples.2.subject": "Educazione digitale",
  "ipi.inspiration.examples.2.title": "Social media",
  "ipi.inspiration.examples.2.prompt": "Crea un foglio di lavoro sul tema dei social media. Tratta opportunità, rischi e regole per un uso responsabile. Alunni/e conoscono i pericoli di base di Internet e utilizzano diverse app (principalmente TikTok e Instagram).",
  "ipi.inspiration.examples.3.subject": "Interdisciplinare",
  "ipi.inspiration.examples.3.title": "Sostenibilità",
  "ipi.inspiration.examples.3.prompt": "Crea un foglio di lavoro sul tema della sostenibilità da diverse prospettive.",
  "ipi.inspiration.examples.4.subject": "Inglese",
  "ipi.inspiration.examples.4.title": "Fake-News",
  "ipi.inspiration.examples.4.prompt": "Crea un testo di lettura lungo con domande di comprensione interattive e domande di riflessione sul tema delle fake-news.",
  "ipi.rework": "Rivedi",
  "help_center.materials.title": "Crea e modifica materiale",
  "help_center.materials.sub_title": "Un sottotitolo",
  "help_center.materials.description": "In Teachino, puoi creare materiale didattico di alta qualità con pochi clic. È più facile con l'IA sulla homepage. Basta inserire un argomento e aggiungere dettagli, come l'età e la lingua, in cui salvare il materiale o aggiungere una fonte, ad esempio, un PDF o un link a cui l'IA si riferisce, e sei pronto. In pochi secondi, l'IA crea materiale adatto con immagini, testi e compiti. Più dettagli dai all'IA, migliore sarà il risultato.",
  "help_center.materials.faq1.question": "Come posso creare un materiale?",
  "help_center.materials.faq1.answer": "Per creare un materiale, vai alla homepage e inserisci un argomento.",
  "navigation.profile_settings": "Impostazioni profilo",
  "navigation.profile.trial_days_left": "{{days}} giorni di prova rimasti",
  "navigation.profile.grace_days_left": "{{days}} giorni Pro rimasti",
  "material.tab_edit": "Modifica",
  "material.tab_preview": "Anteprima",
  "material.tab_evaluate": "Valuta",
  "ipi.material.done_description": "Non è esattamente ciò che ti serve? Usa l’IA ",
  "ipi.hints.improvements": "Consiglio: Aggiungi dettagli desiderati come <strong>focus</strong>, <strong>obiettivo di apprendimento</strong>, <strong>conoscenza precedente</strong>, <strong>durata</strong>, <strong>modalità sociale</strong>, <strong>ambito di richiesta</strong>, <strong>stile linguistico</strong>.",
  "ipi.feedback.thank_you": "Grazie per il tuo feedback!",
  "ipi.feedback.regenerate": "Clicca su \"Rigenera\" per provarlo ancora.",
  "ipi.add_source.add_youtube": "Inserisci il link YouTube",
  "ipi.add_topic_description": "In quale cartella vuoi creare il materiale? L’IA usa la cartella come contesto aggiuntivo.",
  "ipi.regenerate": "Rigenera",
  "ipi.regenerate.title": "Rigenera materiale",
  "ipi.improve.hint.title": "Suggerimenti",
  "ipi.improve.hint.1_label": "🧠 Troppo difficile?",
  "ipi.improve.hint.1_cta": "Adatta l'età",
  "ipi.improve.hint.2_label": "✍️ Troppo vago?",
  "ipi.improve.hint.2_cta": "Menziona il focus",
  "ipi.improve.hint.3_label": "🎯 Impreciso?",
  "ipi.improve.hint.3_cta": "Aggiungi obiettivo di apprendimento",
  "ipi.improve.hint.4_label": "🗣️ Lingua sbagliata?",
  "ipi.improve.hint.4_cta": "Seleziona lingua.",
  "editor.tools.code.note": "Nota dell'insegnante",
  "editor.tools.youtube": "Youtube",
  "material.editor.assignments": "Compiti interattivi",
  "material.editor.assignments_ai_hint": "Con IA per studenti",
  "material.editor.interactive_tag": "Interattivo",
  "material.editor.interactive_ai_tag": "Interattivo con IA",
  "course_create_topic_placeholder": "Digitare nuova cartella",
  "course_plan_now": "Pianificare",
  "topic.lesson_goals.placeholder": "Scrivi qualcosa ...",
  "topic.lesson_goals_description": "L'IA può generare nuovi obiettivi o ottimizzare il tuo testo. Quando crei materiali per {{topicName}} con l'IA, questi obiettivi di apprendimento e competenze verranno inclusi.",
  "course.print": "Stampare",
  "course.settings": "Impostazioni",
  "course.settings_ai": "Impostazioni IA",
  "course.search": "Cerca in {{courseName}}",
  "course.search.empty": "Nessun materiale corrispondente nel corso trovato",
  "course.search.empty_description": "Vuoi aggiungere materiali dalla biblioteca al corso? Allora seleziona in alto a destra \"Aggiungi\" > \"Aggiungi dalla biblioteca\".",
  "topic_summary_item_0": "Nessun materiale",
  "topic_summary_item_1": "1 materiale",
  "topic_summary_item_many": "{{number}} materiali",
  "item_detail.new_snippet_link_url_heading": "Nuovo link",
  "item_detail.edit_snippet_link_url_heading": "Modifica link",
  "item_detail.new_snippet_link_title_heading": "Nome del link",
  "item_detail.snippet_text": "Testo",
  "item_detail.snippet_link": "Link",
  "item_detail.snippet_note": "Nota",
  "item_detail.snippet_file": "File",
  "item_detail.snippet_file_choose": "Scegli file",
  "item_detail.snippet_external_file": "OneDrive",
  "item_detail.snippet_image": "Immagine",
  "item_detail.snippet_ai": "IA",
  "item_detail.snippet_external_content_class_notes": "Nota di classe",
  "item_detail.snippet_external_content_notes": "OneNote",
  "item_detail.snippet_external_content_file": "OneDrive",
  "item_detail.snippet_link.link_placeholder": "Inserisci link",
  "item_detail.snippet_link.title_placeholder": "Nome (opzionale)",
  "item_detail.snippet_text_description": "Spiegazioni, riferimenti al libro di testo",
  "item_detail.snippet_link_description": "a siti web, video, file in cloud",
  "item_detail.snippet_note_description": "Note private, suggerimenti didattici, non visibili agli studenti",
  "item_detail.snippet_file_description": "Fogli di lavoro, presentazioni, immagini ...",
  "item_detail.snippet_external_file_description": "Collegare file e cartelle",
  "item_detail.snippet_image_description": "Foto, grafici",
  "item_detail.snippet_ai_description": "Generare domande, obiettivi di apprendimento, glossario ecc. con IA",
  "item_detail.minute_0": "Minuti",
  "item_detail.minute_1": "Minuto",
  "item_detail.minute_many": "Minuti",
  "item_detail.snippet_include_link_preview": "Includi anteprima del link",
  "item_detail.note_warning": "Visibile solo agli insegnanti",
  "item_detail.confirm_delete_item_pre": " ",
  "item_detail.confirm_delete_item_post": "e eliminare tutti i blocchi associati?",
  "item_detail.force_delete_text_pre": "Questo materiale è stato pianificato nei seguenti corsi:",
  "item_detail.force_delete_text_post": "Vuoi comunque eliminarlo?",
  "item_detail.file_upload_message": "Puoi trascinare i file qui o",
  "item_detail.image_upload_message": "Puoi trascinare le immagini qui o",
  "item_detail.file_upload_button_text": " selezionare",
  "item_detail.file_upload_processing": "Caricamento dei file",
  "item_detail.file_upload_success": "Caricamento riuscito",
  "item_detail.maximum_file_label": "Dim. max: {{fileSize}}",
  "item_detail.file_unacceptable_type": "Tipo di file non accettato",
  "item_detail.file_too_large": "File troppo grande",
  "item_detail.file_empty": "I file vuoti non possono essere caricati.",
  "item_detail.file_changed": "I disegni non verranno salvati. Usare solo per presentazioni!",
  "item_detail.file_start_edit_mode": "Disegnare",
  "item_detail.file_download": "Scarica file",
  "item_detail.delete_snippet_title": "Elimina blocco",
  "item_detail.delete_snippet_description": "Vuoi davvero eliminare questo blocco?",
  "item_detail.delete_snippet_description_dynamic": "Sei sicuro di voler eliminare {{name}}?",
  "item_detail.delete_snippet_warning": "Questa azione non può essere annullata.",
  "item_detail.add_to_lesson": "Aggiungere alla lezione",
  "item_detail.remove_from_lesson": "Rimuovi dalla lezione",
  "item_detail.added_to_lesson": "Aggiunto alla lezione",
  "item_detail.presentation": "Presentare",
  "item_detail.add_material": "Aggiungere materiale",
  "item_detail.edit_details": "Modificare dettagli",
  "item_detail.back_to_content": "Torna al materiale",
  "item_detail.add_description": "Aggiungere descrizione",
  "delete_topic.delete_message_pre": "Vuoi",
  "delete_topic.delete_message_post": "rimuovere da questo corso? Il tema e i materiali saranno ancora disponibili nella biblioteca.",
  "delete_topic.delete_button": "Rimuovere",
  "course_students.share.title": "Studenti",
  "course_students.share.sub_title": "Condividi l'accesso a Teachino con un link o codice QR con gli studenti",
  "course_students.share.description": "Puoi condividere questo link con gli studenti (o genitori).",
  "course_students.share.create_link": "Crea link.",
  "course_students.share.show_qr_code": "Codice QR e link",
  "course_students.preview.description": "Gli studenti vedono solo i materiali che hai reso accessibili a loro. Li riconosci dall'icona dell'occhio.",
  "course_students.preview.description_2": "Le note non possono essere viste dagli studenti.",
  "course_students.share.expiration": "Questo link è valido per l'intero anno scolastico.",
  "course_students.share.generate_new": "Revocare link",
  "course_students.share.invalidate.confirm_title": "Link sarà bloccato",
  "course_students.share.invalidate.confirm_description": "Questo link non può più essere usato. Puoi successivamente crearne uno nuovo e condividerlo.",
  "course_students.share.invalidate.description": "Questo link è invalido. Per favore, chiedi al tuo insegnante un nuovo link.",
  "course_students.share_link": "Visualizzazione studente",
  "course_students.mapping_not_unique_title": "Esistono più corsi associati a questa lezione in Teachino.",
  "course_students.mapping_not_unique_description": "Quale corso desideri aprire?",
  "course_students.share_item.title": "Condividi materiale con alunni/e",
  "course_students.share_item.description_not_visible": "Una volta che hai attivato il materiale, puoi condividere un codice QR o link con gli studenti. Inoltre, i tuoi studenti vedranno il materiale nella visualizzazione studenti.",
  "course_students.share_item.description": "Scansiona il codice o copia il link",
  "course_students.share_item.make_visible": "Attivare",
  "course_students.preview.header": "Condividi questo link con i tuoi studenti",
  "course_students.preview.preview": "Anteprima",
  "course_students.preview.preview_description": "Ecco come appare il corso per i tuoi studenti",
  "course_students.access_cards.print_filename_all_students": "Tutti gli studenti",
  "course_students.accounts.title": "Alunni/e",
  "course_students.accounts.loading": "Caricamento di alunni/e",
  "course_students.accounts.empty": "Non hai ancora aggiunto alunni/e. Aggiungili per consentire loro di accedere al corso.",
  "course_students.accounts.empty_connect_webuntis": "Collega il tuo corso a WebUntis per importare gli studenti.",
  "course_students.accounts.table.name": "Nome",
  "course_students.accounts.table.code": "Codice",
  "course_students.accounts.table.last_active": "Ultima attività",
  "course_students.privacy_banner.message": "I dati personali di alunni/e possono essere inseriti solo dopo la stipula di un contratto per il trattamento dei dati (AVV). Fino ad allora puoi fare delle prove con alunni/e di test 01-30.",
  "course_students.privacy_banner.sign": "Far firmare il contratto AVV alla direzione scolastica",
  "course_students.privacy_banner.learn_more": "Scopri di più",
  "course_students.accounts.table.no_activity": "Nessuna attività finora",
  "course_students.accounts.table.qr": "QR",
  "course_students.accounts.actions.open_qr": "Apri QR",
  "course_students.accounts.actions.show_code": "Mostra codice",
  "course_students.accounts.actions.print_code": "Stampa codice",
  "course_students.accounts.actions.regenerate_code": "Rigenera codice",
  "course_students.accounts.actions.delete": "Elimina",
  "course_students.accounts.actions.print_all": "Tutti/e gli/le alunni/e",
  "course_students.accounts.actions.add_students": "Aggiungi alunni/e",
  "course_students.accounts.actions.copy_access_link": "Copia link di accesso",
  "course_students.accounts.actions.print_access_code": "Stampa codice di accesso",
  "course_students.accounts.actions.rename": "Rinomina alunno/a",
  "course_students.accounts.actions.print_codes": "Stampa i codici di accesso",
  "course_students.accounts.actions.manage_groups": "Gestisci gruppi di studio",
  "course_students.accounts.actions.assign_groups": "Assegna",
  "course_students.accounts.import.title": "Sincronizza con {{integration}}",
  "course_students.accounts.import.description": "Importa gli studenti da {{course}}. Gli studenti esistenti rimangono invariati.",
  "course_students.accounts.import.action": "Sincronizza studenti",
  "course_students.accounts.import.created": "{{count}} nuovi studenti importati da {{integration}}.",
  "course_students.accounts.import.no_new": "Non sono stati trovati nuovi studenti in {{integration}}.",
  "course_students.accounts.import.provider_error": "Non è stato possibile caricare gli studenti da {{integration}}. Riprova.",
  "course_students.accounts.import.error": "Non è stato possibile sincronizzare gli studenti con {{integration}}.",
  "course_students.accounts.import.source_tag": "Da {{integration}}",
  "course_students.accounts.import.new_available": "{{count}} nuovi studenti possono essere importati.",
  "course_students.accounts.import.auto_failed": "Il corso è stato collegato, ma non è stato possibile importare automaticamente alunni/e. Riprova la sincronizzazione in \"Modifica corso\" > \"Gestisci alunni/e\".",
  "course_students.accounts.student_code.title": "Accesso per {{studentName}}",
  "course_students.accounts.add_students.description": "Inserisci i nomi di alunni/e – scrivi un nome per riga.",
  "course_students.accounts.add_students.name_too_long": "Un nome studente può avere al massimo {{maxLength}} caratteri.",
  "course_students.accounts.add_students.placeholder": "Anna\nBoris\nChris\n...",
  "course_students.accounts.add_students.test_students_intro": "Verranno creati questi accessi di prova:",
  "course_students.accounts.add_students.test_students_kept": "Alunni/e già presenti ({{count}}) restano invariati: i loro codici di accesso e i loro dati non cambiano.",
  "course_students.accounts.add_students.create_count_one": "Crea {{count}} accesso",
  "course_students.accounts.add_students.create_count_many": "Crea {{count}} accessi",
  "course_students.accounts.delete_student.title": "Elimina alunno/a",
  "course_students.accounts.delete_student.confirm": "Vuoi davvero eliminare \"{{studentName}}\"?",
  "course_students.accounts.data_footprint.answers_one": "{{count}} risposta",
  "course_students.accounts.data_footprint.answers_many": "{{count}} risposte",
  "course_students.accounts.data_footprint.grades_one": "{{count}} voto",
  "course_students.accounts.data_footprint.grades_many": "{{count}} voti",
  "course_students.accounts.data_footprint.notes_one": "{{count}} nota",
  "course_students.accounts.data_footprint.notes_many": "{{count}} note",
  "course_students.accounts.delete_student.data_intro": "Questi dati verranno eliminati:",
  "course_students.accounts.delete_student.data_unknown": "Tutte le consegne, le risposte e i voti verranno eliminati.",
  "course_students.accounts.delete_student.permanent_hint": "L’operazione non può essere annullata. Puoi ricreare il nome in seguito: l’accesso sarà vuoto e avrà un nuovo codice.",
  "course_students.accounts.delete_student.confirm_checkbox": "Sì, ho capito che questi dati verranno eliminati.",
  "course_students.accounts.delete_student.deleted_toast": "“{{studentName}}” è stato eliminato.",
  "course_students.accounts.feature_banner.aria_label": "Account studenti",
  "course_students.accounts.feature_banner.title": "Accesso personale per gli studenti",
  "course_students.accounts.feature_banner.description": "Tutti gli studenti ricevono un codice personale e possono accedere ai materiali in qualsiasi momento, incluse le proprie risposte e consegne. Come insegnante puoi rendere visibili i materiali per singoli studenti.",
  "course_students.accounts.feature_banner.activate": "Attiva accessi studenti",
  "course_students.accounts.school_license_promo.title": "Accessi personalizzati per gli studenti",
  "course_students.accounts.school_license_promo.description": "Condividi i materiali in modo mirato con singoli studenti. Gli studenti vedono tutti i loro materiali, incluse le risposte, in un accesso personale. La funzione è inclusa nella licenza scolastica Teachino.",
  "course_students.accounts.personalized_access.title": "Accessi personalizzati per gli studenti",
  "course_students.accounts.personalized_access.description": "Gli studenti accedono con un codice personale. I materiali possono essere resi visibili per singoli studenti.",
  "course_students.accounts.disable.title": "Disattivare gli accessi personalizzati?",
  "course_students.accounts.disable.message": "Gli studenti non potranno più accedere con il loro codice personale.",
  "course_students.accounts.disable.info": "Gli account studenti creati in questo corso restano e potrai riattivare l'accesso in seguito.",
  "course_students.accounts.disable.confirm": "Disattiva",
  "course_students.accounts.login_share.title": "Come gli studenti ottengono l'accesso:",
  "course_students.accounts.login_share.step_create": "Crea gli studenti nel corso",
  "course_students.accounts.login_share.step_personal_code": "Tutti gli studenti ricevono un codice personale.",
  "course_students.accounts.login_share.step_print": "Stampa i codici e distribuiscili",
  "course_students.accounts.login_share.step_open_prefix": "Gli studenti aprono",
  "course_students.accounts.login_share.step_enter_code": "e inseriscono il loro codice",
  "course_students.accounts.login_share.step_visible_materials": "Gli studenti vedono i materiali resi visibili per loro, incluse tutte le loro risposte",
  "course_students.accounts.preview.description": "Ecco come alunni/e vedono questo materiale. Puoi provare qui compiti interattivi e chatbot.",
  "course_students.accounts.visibility.all_students": "Tutti gli alunni e tutte le alunne",
  "course_students.groups.title": "Gruppi di studio",
  "course_students.groups.create": "Crea gruppo di studio",
  "course_students.groups.edit": "Modifica gruppo di studio",
  "course_students.groups.delete": "Elimina gruppo di studio",
  "course_students.groups.assign": "Assegna gruppi di studio",
  "course_students.groups.empty": "Nessun gruppo di studio creato",
  "course_students.groups.empty_in_group": "Nessun alunno/a in questo gruppo di studio",
  "course_students.groups.new_group": "Nuovo gruppo di studio",
  "course_students.groups.student_label": "Alunno/a",
  "course_students.groups.table_column": "Gruppi di apprendimento",
  "course_students.groups.description": "Crea gruppi per alunni/e con esigenze di apprendimento, bisogni di supporto o punti di forza simili",
  "course_students.groups.create.description": "Crea un gruppo di studio e seleziona opzionalmente subito i primi alunni/e.",
  "course_students.groups.edit.description": "Modifica nome e colore del gruppo di studio e scegli quali alunni/e devono farne parte.",
  "course_students.groups.assign.description": "Scegli i gruppi di studio a cui assegnare questo alunno/a.",
  "course_students.groups.manage_members.title": "Gestisci studenti",
  "course_students.groups.manage_members.description": "Scegli quali alunni/e devono far parte di questo gruppo di studio.",
  "course_students.groups.manage_members.empty": "Nessuno studente in questo corso",
  "course_students.groups.assign.empty": "Nessun gruppo di studio in questo corso",
  "course_students.groups.name_placeholder": "es. Gruppo di studio A",
  "course_students.groups.name_placeholder_edit": "es. particolarmente motivati, tedesco come seconda lingua",
  "course_students.groups.delete_confirm": "Vuoi davvero eliminare il gruppo di studio \"{{groupName}}\"? Alunni/e non verranno eliminati.",
  "student_accounts.page_title": "Accesso studenti",
  "student_accounts.login.code_label": "Codice",
  "student_accounts.login.code_placeholder": "XXXXX-XXXXX",
  "student_accounts.login.submit": "Accedi",
  "student_accounts.login.logging_in": "Accesso in corso…",
  "student_accounts.login.heading": "Apri i materiali in Teachino",
  "student_accounts.login.description": "Inserisci il codice che hai ricevuto dal tuo docente.",
  "student_accounts.login.teacher_cta": "Sei un docente? Accedi qui",
  "student_accounts.login.code_invalid": "Il codice non è valido. Controllalo e riprova.",
  "student_accounts.login.code_invalid_characters": "Il codice può contenere solo lettere e numeri.",
  "student_accounts.login.code_length": "Il codice deve avere esattamente 10 caratteri",
  "student_accounts.login.error_generic": "Si è verificato un errore durante l'accesso. Riprova.",
  "student_accounts.logout.dialog_title": "Il tuo accesso a Teachino",
  "student_accounts.logout.logged_in_as": "Sei connesso come",
  "student_accounts.logout.switch_course_title": "Cambia corso o esci",
  "student_accounts.logout.switch_course_message": "Se vuoi accedere a un altro corso o qualcun altro deve continuare su questo dispositivo, clicca su Esci. Potrai accedere di nuovo in seguito con il tuo codice di accesso personale.",
  "student_accounts.access_card.website": "Sito web",
  "student_accounts.access_card.personal_code": "Codice di accesso personale",
  "student_accounts.access_card.code_copied": "Codice copiato",
  "material.student_visibility.title": "Visibilità per alunni/e",
  "material.student_visibility.summary_all": "Materiale visibile a tutti/e gli/le alunni/e",
  "material.student_visibility.summary_partial": "Materiale visibile a {{visible}} di {{total}} alunni/e",
  "material.student_visibility.toggle_all_hint": "Questo interruttore rende il materiale visibile a tutti/e gli/le alunni/e",
  "material.student_visibility.add_students_prefix": "Puoi aggiungere studenti nel corso in",
  "material.student_visibility.add_students_suffix": "aggiungerli.",
  "material.student_visibility.show_for_groups": "Mostra per alunni/e nei gruppi di studio",
  "material.student_visibility.guest_readonly_hint": "Come ospite puoi vedere la visibilità ma non modificarla.",
  "course_settings.collaboration.empty": "Nessun docente invitato",
  "link.copied.title": "Link copiato",
  "link.open.new_tab": "Apri in una nuova scheda",
  "link.copied.description": "Ora puoi inviare il link",
  "emoji.name": "Simbolo",
  "emoji.title": "Scegli simbolo",
  "emoji.search": "Cerca",
  "emoji.not_found": "Nessuna icona trovata",
  "emoji.category.search": "Risultati di ricerca",
  "emoji.category.recent": "Icone utili",
  "emoji.category.people": "Faccine & Persone",
  "emoji.category.nature": "Animali & Natura",
  "emoji.category.foods": "Cibo & Bevande",
  "emoji.category.activity": "Attività",
  "emoji.category.places": "Luoghi",
  "emoji.category.objects": "Oggetti",
  "emoji.category.symbols": "Simboli",
  "emoji.category.flags": "Bandiere",
  "emoji.category.custom": "Altro",
  "emoji.skin.choose": "Scegli un colore pelle predefinito",
  "emoji.skin.1": "1",
  "interactive_assignment.overview.legend.partially_correct": "Parzialmente corretto",
  "interactive_assignment.overview.legend.correct": "Corretto",
  "interactive_assignment.overview.legend.started": "In lavorazione",
  "interactive_assignment.overview.legend.attempts_and_hints": "1. numero: numero di tentativi · 2. numero: numero di suggerimenti usati",
  "interactive_assignment.overview.show_hints_and_attempts": "Visualizza tentativi e suggerimenti",
  "interactive_assignment.overview.one_attempt": "Un tentativo.",
  "interactive_assignment.overview.many_attempts": "Tentativi",
  "interactive_assignment.no_courses.title": "Clicca su \"Condividi\" per condividere questo materiale con i tuoi alunni/e.",
  "interactive_assignment.no_courses_description": "Una volta che i tuoi alunni/e lavorano al materiale, vedrai qui la valutazione per ogni alunno/a e domanda.",
  "editor.file.description.placeholder": "Aggiungere descrizione",
  "pathfindr.annotation_tool.welcome_modal.title": "Ciao",
  "pathfindr.annotation_tool.welcome_modal.text": "Qui puoi visualizzare e disegnare sui documenti.",
  "pathfindr.annotation_tool.welcome_modal.button": "Avanti",
  "pathfindr.annotation_tool.permission_modal.title": "Autorizzazione richiesta",
  "pathfindr.annotation_tool.permission_modal.text": "Devi consentire l'accesso alla tua camera e al tuo schermo per registrare la tua sessione.",
  "pathfindr.annotation_tool.permission_modal.button_permission": "Concedi autorizzazione",
  "pathfindr.annotation_tool.permission_modal.button_no_permission": "Prosegui senza registrazione",
  "pathfindr.annotation_tool.permission_modal.no_browser_support_title": "Nessun supporto del browser",
  "pathfindr.annotation_tool.permission_modal.no_browser_support_text": "Il tuo browser non supporta la registrazione dello schermo. Le ragioni comuni includono impostazioni di sicurezza mancanti, un browser obsoleto o mancanza di supporto su smartphone.",
  "pathfindr.annotation_tool.uploading_modal.title": "Caricamento in corso...",
  "pathfindr.annotation_tool.success_modal.title": "Evviva!",
  "pathfindr.annotation_tool.success_modal.text": "I tuoi file sono stati caricati",
  "pathfindr.annotation_tool.error_modal.title": "Errore",
  "pathfindr.annotation_tool.error_modal.text": "Il file non può essere visualizzato in questo momento. Si prega di scaricare il file con il pulsante di download sul tuo dispositivo per aprirlo.",
  "pathfindr.annotation_tool.error_modal.button_download_video": "Scarica video",
  "pathfindr.annotation_tool.error_modal.button_download_pdf": "Scarica PDF",
  "pathfindr.annotation_tool.error_modal.button_retry": "Riprova",
  "pathfindr.annotation_tool.navbar.button_done": "Fatto",
  "pathfindr.annotation_tool.navbar.uploading_text": "Caricamento in corso...",
  "pathfindr.annotation_tool.navbar.button_cancel": "Annulla",
  "pathfindr.annotation_tool.navbar.helper_text_not_ready": "Registra una sessione o modifica il documento",
  "pathfindr.annotation_tool.navbar.helper_text_ready": "Pronto per il caricamento",
  "pathfindr.annotation_tool.access_token_unvalid": "Questa è una versione di prova, solo per test e dimostrazioni!",
  "download_page_title": "Download di Teachino",
  "dashboard.title": "Pagina iniziale",
  "dashboard.greeting.morning": "Buongiorno, {{name}}",
  "dashboard.greeting.afternoon": "Buon pomeriggio, {{name}}",
  "dashboard.greeting.evening": "Buonasera, {{name}}",
  "dashboard.greeting.night": "Buonanotte, {{name}}",
  "dashboard.greeting.free": "Stai usando la versione gratuita di Teachino.",
  "dashboard.greeting.trial": "Il tuo periodo di prova gratuito terminerà presto.",
  "dashboard.library.title": "La tua biblioteca",
  "dashboard.library.topics": "I tuoi temi",
  "dashboard.library.topics_empty": "I temi sono unità tematiche, come i capitoli nel libro di testo. Una volta creati, utilizzabili sempre.",
  "dashboard.library.materials": "I tuoi materiali",
  "dashboard.library.materials_empty": "Contenuti delle lezioni: link, fogli di lavoro, note, ... Ordinati in temi e modificabili con IA.",
  "dashboard.library.open_all_topics": "Apri biblioteca",
  "dashboard.library.create_material": "Crea materiale",
  "dashboard.library.create_topic": "Crea tema",
  "dashboard.ai.title": "La tua assistenza IA",
  "dashboard.ai.frequently_used": "Funzioni IA popolari",
  "dashboard.ai.ai_for_files": "IA per file",
  "dashboard.ai.ai_for_youtube": "IA per video di Youtube",
  "dashboard.ai.ai_for_images": "IA per immagini",
  "dashboard.ai.lesson_planning": "Pianificare le lezioni con IA",
  "dashboard.ai.create_topic": "Pianificazione tema",
  "dashboard.ai.create_period": "Creare pianificazione",
  "dashboard.ai.use_with_students": "Usare IA con studenti",
  "dashboard.ai.my_assignments": "Apri i miei compiti IA",
  "dashboard.ai.find_template": "Trova compito IA",
  "dashboard.ai.show_all": "Mostra tutte le funzioni IA",
  "dashboard.timetable.title": "Il tuo orario",
  "dashboard.timetable.sub_title": "Le tue prossime lezioni",
  "dashboard.timetable.open_timetable": "Apri orario",
  "dashboard.timetable.empty_text": "Tutto sotto controllo: Inserisci il tuo orario per gestire le lezioni e le cose da fare in modo ordinato!",
  "dashboard.timetable.timetable_cta": "Inserisci orario",
  "dashboard.timetable.webuntis_cta": "Carica orario da WebUntis",
  "dashboard.onboarding.title": "I tuoi primi passi con Teachino",
  "dashboard.onboarding.step_1": "1. Crea un tema e un materiale",
  "dashboard.onboarding.step_2": "2. Modifica il materiale con IA",
  "dashboard.onboarding.step_3": "3. Crea i tuoi corsi",
  "language.de": "Tedesco",
  "language.en": "Inglese",
  "language.it": "Italiano",
  "language.es": "Spagnolo",
  "language.fr": "Francese",
  "language.pt": "Portoghese",
  "language.tr": "Turco",
  "language.po": "Polacco",
  "language.nl": "Olandese",
  "language.se": "Svedese",
  "language.ru": "Russo",
  "language.sl": "Sloveno",
  "language.cs": "Ceco",
  "language.lb": "Lussemburghese",
  "language.ro": "Rumeno",
  "language.rs": "Serbo",
  "language.hr": "Croato",
  "language.ur": "Urdu",
  "language.hi": "Hindi",
  "language.sq": "Albanese",
  "language.ar": "Arabo",
  "ipi.page_title": "Crea materiale con IA",
  "ipi.title": "Descrivi un tema e ricevi materiale adatto",
  "ipi.sub_title": "L'IA crea materiale didattico interattivo che puoi modificare e condividere con i tuoi studenti.",
  "ipi.usage.title": "Quota IA",
  "ipi.usage.summary": "{{used}} di {{limit}} richieste utilizzate negli ultimi {{windowDays}} giorni",
  "ipi.usage.remaining": "Restano {{remaining}} richieste disponibili",
  "ipi.usage.limit_reached": "Hai esaurito la quota disponibile. Riprova più tardi.",
  "ipi.paywall.description": "Genera materiali didattici con l'IA – schede interattive, compiti e idee per le lezioni.",
  "ipi.usage.upgrade_cta": "Passa al piano Pro",
  "ipi.prompt.too_short": "Inserisci un prompt più lungo.",
  "ipi.prompt.placeholder": "Digita un tema e i dettagli desiderati (focus, obiettivo didattico, conoscenze pregresse, ...)",
  "ipi.link.thena.title": "Assistente IA (Thena)",
  "ipi.link.thena.description": "Chat IA per l'ambiente scolastico",
  "ipi.link.student_ai.title": "IA per studenti",
  "katex.fractions": "Frazioni",
  "katex.exponents": "Esponenti",
  "katex.subscripts": "Indici (subscript)",
  "katex.roots": "Radici",
  "katex.summation": "Simbolo sommatoria",
  "katex.product": "Simbolo prodotto",
  "katex.limit": "Limite",
  "katex.integral": "Integrale",
  "katex.infinity": "Infinito",
  "katex.pi": "Numero pi",
  "katex.delta": "Delta (variazione)",
  "katex.vector": "Vettori (grassetto o con freccia)",
  "katex.equality": "Uguale / Non uguale",
  "katex.shortFraction": "Frazione breve (inlinea)",
  "katex.scaledBrackets": "Parentesi scalabili automaticamente",
  "katex.arrows": "Frecce",
  "katex.sets": "Simboli di insiemi",
  "katex.emptysetNumbersets": "Insieme vuoto / Insiemi numerici",
  "katex.absoluteValue": "Valore assoluto",
  "katex.matrices": "Matrici",
  "katex.systemOfEquations": "Sistemi di equazioni",
  "katex.fractionInExponent": "Frazione nell'esponente",
  "katex.dots": "Punti (continuazione)",
  "katex.overline": "Barra sopra (media)",
  "katex.binomial": "Coefficiente binomiale",
  "katex.logarithm": "Logaritmo",
  "katex.trigonometric": "Funzioni trigonometriche",
  "katex.derivative": "Derivata",
  "katex.partialDerivative": "Derivata parziale",
  "katex.gradient": "Nabla / Gradiente",
  "katex.sumWithConditions": "Somma con condizioni sotto",
  "katex.textInMath": "Testo in formula matematica",
  "katex.exponential": "Funzione esponenziale",
  "katex.bracketedFraction": "Frazione con parentesi",
  "katex.approxIneq": "Circa uguale / Disuguale",
  "katex.doubleArrows": "Doppie frecce (equivalenza)",
  "katex.brackets": "Parentesi quadre / Graffe",
  "katex.spacing": "Spaziatura in modalità matematica",
  "katex.enter_equation": "Inserisci formula (LaTeX)",
  "katex.preview": "Anteprima",
  "katex.preview.empty": "Una volta inserita una formula, vedrai un'anteprima qui.",
  "katex.show_all_tips": "Mostra tutti i consigli",
  "katex.hide_all_tips": "Mostra meno consigli",
  "info": "Info",
  "error": "Errore",
  "success": "Modifiche salvate",
  "generic_created_at": "Creato il {{date}}",
  "generic_error": "Si è verificato un errore. Riprova.",
  "generic_name": "Nome",
  "generic_error_network": "Qualcosa è andato storto. Verifica la tua connessione Internet e riprova.",
  "generic_slogan": "Pianificazione annuale. Pianificazione settimanale. Materiali.\nUn'app. Semplice e chiara.",
  "generic_back": "Indietro",
  "generic_confirm": "Conferma",
  "generic_and": "e",
  "generic_save": "Salva",
  "generic_cancel": "Annulla",
  "generic_retry": "Riprova",
  "generic_delete": "Elimina",
  "generic_edit": "Modifica",
  "generic_done": "Fatto",
  "generic_topic": "Cartella",
  "generic_topics": "Cartelle",
  "generic_folder": "Cartella",
  "generic_folders": "Cartelle",
  "generic_sub_folder": "Sottocartella",
  "generic_sub_folders": "Sottocartelle",
  "generic_item": "Materiale",
  "generic_material": "Materiale",
  "generic_materials": "Materiali",
  "generic_file_name": "Nome del file",
  "generic_file_description": "Descrizione del file",
  "generic_items": "Materiali",
  "generic_title": "Titolo",
  "generic_continue": "Continua",
  "generic.copy_link": "Copia link",
  "generic_copy": "Copia",
  "generic_add": "Aggiungi",
  "generic_next": "Avanti",
  "generic_close": "Chiudi",
  "generic_course": "Corso",
  "generic_courses": "Corsi",
  "generic_template": "Raccolta",
  "generic_duplicate": "Duplica",
  "generic_move": "Sposta",
  "generic_preview": "Anteprima",
  "generic_form_error_required": "Il campo è richiesto",
  "homepage_title": "Home",
  "generic_first_name": "Nome",
  "generic_first_name_placeholder": "Maria",
  "generic_last_name": "Cognome",
  "generic_last_name_placeholder": "Rossi",
  "generic_email": "Indirizzo e-mail",
  "generic_email_placeholder": "mio@email.it",
  "generic_schoolyear": "Anno scolastico",
  "generic_subject": "Materia",
  "generic_class": "Classe",
  "generic_clear_date": "Nessuna data",
  "generic_duration": "Durata",
  "generic_duration_in_minutes": "Durata (in minuti)",
  "generic_vacation": "Vacanze",
  "generic_choose": "Scegli",
  "generic_search": "Cerca",
  "generic_options": "Opzioni",
  "generic_new_badge": "Nuovo!",
  "generic_empty_state": "Nessun dato trovato",
  "generic_substitution": "Sostituzione",
  "generic_archived": "Eliminato",
  "generic_text_copied_to_clipboard": "Testo copiato negli appunti",
  "generic_select_placeholder": "Seleziona un'opzione...",
  "generic_upgrade": "Aggiorna",
  "generic_class_level": "Livello scolastico",
  "generic_form_error.not_a_number": "Inserisci un numero",
  "generic_add_image": "Aggiungi immagine",
  "generic_error_url_invalid": "URL non valido",
  "generic_sus_long": "Alunni/e",
  "generic_n_years": "{{years}} anni",
  "generic_create": "Crea",
  "generic_beta": "Beta",
  "pro_feature_badge.tooltip": "Funzionalità disponibile durante il periodo di prova o con una licenza a pagamento",
  "generic_optional": "(opzionale)",
  "generic_sus_short": "Alunni ed alunne",
  "generic_form_error.max_line_length": "Riga troppo lunga (max. {{maxLength}} caratteri): \"{{line}}\"",
  "generic_drop_files_here": "Rilascia il tuo file qui",
  "teachino_ai": "IA di Teachino",
  "navigation.timetable": "Orario didattico",
  "navigation.agenda": "Agenda",
  "navigation.timetable_week": "Orario didattico",
  "navigation.timetable_list": "Lista",
  "navigation.library": "Materiali",
  "navigation.help": "Aiuto & Feedback",
  "navigation.profile": "Profilo",
  "navigation.log_out": "Esci",
  "navigation.imprint": "Note legali",
  "navigation.terms": "Termini di utilizzo",
  "navigation.privacy": "Privacy",
  "navigation.courses": "Corsi",
  "navigation.status": "Stato del server",
  "navigation.licenses": "Licenza & Aggiorna",
  "navigation.ai": "IA",
  "navigation.new_course": "Nuovo corso",
  "navigation.help_and_support": "Aiuto e supporto",
  "navigation.feedback": "Feedback",
  "auth_password": "Password",
  "auth_button_login": "Accedi",
  "auth_forgot_password": "Password dimenticata?",
  "auth_signup_tos": "Termini di utilizzo",
  "auth_verify_title": "Conferma l'indirizzo e-mail",
  "auth_verify_description_1": "Inserisci il codice che abbiamo appena inviato a ",
  "auth_verify_description_2": ".",
  "auth_verify_typo": "Errore di battitura?",
  "auth_verify_spam": "Codice non ricevuto? Controlla la tua cartella spam.",
  "auth_verify_resend": "Invia nuovamente e-mail",
  "auth_verify_resend_change": "Cambia indirizzo e-mail",
  "auth_verify_resend_save": "Salva indirizzo e-mail",
  "auth_verify_change_error_duplicate": "Questo indirizzo e-mail è già registrato su Teachino.",
  "auth_verify_change_login": "Accedi con password",
  "auth_verify_code_error": "Questo codice è invalido o scaduto.",
  "auth_verify_code_empty": "Per favore, inserisci il codice che hai ricevuto via e-mail.",
  "auth_verify_code_error_expired": "Questo codice non è più valido.",
  "auth_verify_code_request_new_code": "Richiedi nuovo codice",
  "auth_verify_limit_exceeded": "Negli ultimi minuti sono state richieste molte e-mail. Attendi un momento prima di richiederne altre.",
  "auth_new_password": "Scegli una password",
  "auth_password_requirement_letter": "una lettera",
  "auth_password_requirement_number": "un numero",
  "auth_password_requirement_length": "{{number}} caratteri",
  "auth_reset_code_title": "Se {{email}} è registrata su Teachino, ti abbiamo inviato un codice per reimpostare la password.",
  "auth_reset_password_title": "Inserisci il tuo indirizzo e-mail per reimpostare la password.",
  "auth_reset_password_button": "Reimposta la password",
  "auth_reset_password_new_password": "Per favore, scegli una nuova password.",
  "auth_reset_password_code": "Codice di conferma",
  "auth_login.title": "Bentornato/a!",
  "auth.signup_v2.page_title": "Continua con Teachino",
  "auth.signup_v2.trust_privacy": "Conforme alla protezione dei dati",
  "auth.signup_v2.trust_ph_salzburg": "Sviluppato con la PH Salzburg",
  "auth.signup_v2.role_label": "Ruolo",
  "auth.signup_v2.teacher_section": "Sono docente",
  "auth.signup_v2.student_section": "Sono studente/ssa",
  "auth.signup_v2.signup_title": "Crea il tuo account gratuito",
  "auth.signup_v2.signup_description": "Non esiste ancora un account Teachino per {{email}}. Inserisci il tuo nome e scegli una password.",
  "auth_login.send_login_link_instead": "Invia invece un link di accesso",
  "auth_login.password_required": "Inserisci la tua password.",
  "auth_login.wrong_password": "La password non è corretta. Riprova oppure fatti inviare un link di accesso.",
  "auth.signup_v2.invalid_email": "Inserisci un indirizzo e-mail valido.",
  "auth.signup_v2.name_required": "Inserisci nome e cognome.",
  "auth.signup_v2.password_invalid": "Scegli una password che soddisfi tutti i requisiti.",
  "auth.signup_v2.show_password": "Mostra password",
  "auth.signup_v2.hide_password": "Nascondi password",
  "auth.signup_v2.code_password_hint": "Per sicurezza, inserisci di nuovo la tua password.",
  "auth.signup_v2.newsletter_opt_in": "Desidero ricevere informazioni utili su Teachino via e-mail",
  "auth.signup_v2.luxembourg_title": "Vieni dal Lussemburgo?",
  "auth.signup_v2.luxembourg_body": "Teachino è gratuito per te. Accedi con IAM per attivare la tua licenza.",
  "auth.signup_v2.luxembourg_iam_login": "Accedi con IAM",
  "auth.signup_v2.luxembourg_without_iam": "Continua senza IAM",
  "auth.signup_v2.request_error": "Non è stato possibile inviare il codice. Riprova più tardi.",
  "auth.signup_v2.or_continue_with": "oppure accedi tramite un portale",
  "auth.signup_v2.choose_page_title": "Prova Teachino",
  "auth.signup_v2.intent_title": "Cosa vuoi fare con Teachino?",
  "auth.signup_v2.intent_description": "Scegli tutto ciò che ti interessa.",
  "auth.signup_v2.intent_option_record_grades": "Documentare i voti",
  "auth.signup_v2.intent_option_record_participation": "Documentare la partecipazione",
  "auth.signup_v2.intent_option_plan_lessons": "Pianificare singole lezioni",
  "auth.signup_v2.intent_option_plan_school_year": "Pianificazione annuale",
  "auth.signup_v2.intent_option_organize_materials": "Organizzare i materiali",
  "auth.signup_v2.intent_option_create_materials": "Creare materiali",
  "auth.signup_v2.intent_option_use_ai_with_students": "Usare l'IA con alunni/e",
  "auth.signup_v2.intent_option_share_with_colleagues": "Condividere materiali con colleghi/colleghe",
  "auth.signup_v2.intent_skip": "Salta",
  "auth.signup_v2.legal_prefix": "Al primo accesso, accetti i seguenti documenti:",
  "auth.signup_v2.code_page_title": "Inserisci il codice di accesso",
  "auth.signup_v2.code_title": "Controlla la tua e-mail",
  "auth.signup_v2.code_description": "Abbiamo inviato un codice di sei cifre a {{email}}.",
  "auth.signup_v2.code_description_generic": "Ti abbiamo inviato un codice di sei cifre via e-mail.",
  "auth.signup_v2.code_label": "Codice di verifica",
  "auth.signup_v2.code_error_invalid": "Questo codice non è valido. Controllalo e riprova.",
  "auth.signup_v2.code_error_expired": "Questo codice è scaduto. Richiedi un nuovo codice.",
  "auth.signup_v2.code_error_network": "Non è stato possibile verificare il codice. Riprova.",
  "profile.general.title": "Aggiorna i dati personali",
  "profile.email-subscription.title": "Notifiche via e-mail",
  "profile.email-subscription.success_message": "Impostazioni salvate",
  "profile.email.title": "Aggiorna indirizzo e-mail",
  "profile.password.title": "Aggiorna password",
  "profile.password.old_password": "Password attuale",
  "profile.password.new_password": "Nuova password",
  "profile.password.new_password_2": "Conferma nuova password",
  "profile.password.wrong_title": "Password errata",
  "profile.password.wrong_description": "Verifica la password attuale. La nuova password non è stata salvata.",
  "profile.password.success_title": "Password modificata",
  "profile.password.success_description": "Puoi ora accedere con la tua nuova password.",
  "auth_login.pending_integration_hint": "Accedi una volta con il tuo indirizzo e-mail e la password. Potrai poi collegare {{displayName}} al tuo account Teachino e la prossima volta basterà accedere con {{displayName}}.",
  "auth_login.code.sent_to": "Abbiamo inviato un codice di accesso a {{email}}. Inseriscilo qui oppure clicca sul link nell’e-mail.",
  "auth_login.code.sent_generic": "Inserisci il codice di accesso ricevuto via e-mail.",
  "profile.password.by_code_hint": "Ti sei registrato senza password o hai dimenticato quella attuale? Imposta una nuova password con un codice che ti inviamo via e-mail.",
  "profile.password.by_code_request": "Invia codice via e-mail",
  "profile.password.by_code_sent": "Abbiamo inviato un codice a {{email}}.",
  "profile.password.by_code_save": "Salva password",
  "profile.data.success_title": "Dati salvati",
  "profile.data.success_description": "I tuoi dati personali sono stati salvati.",
  "profile.language": "Lingua",
  "profile.curriculum.title": "Paese e profilo scolastico",
  "profile.curriculum.description": "Queste impostazioni vengono usate per adattare materie, livelli di classe e risultati IA.",
  "profile.curriculum.success_title": "Profilo aggiornato",
  "profile.curriculum.success_description": "Paese, regione e tipo di scuola sono stati salvati.",
  "profile.export_library_action": "Avvia esportazione",
  "profile.export_library": "Esporta e scarica materiali",
  "profile.export_library_description": "Con questa funzione puoi esportare tutti i materiali dalla tua libreria e scaricarli sul tuo computer.",
  "profile.export_library_tech_details": "Per grandi quantità di dati, l'esportazione può richiedere alcuni minuti o ore. Quando l'esportazione sarà pronta per il download, riceverai un'e-mail. L'esportazione può essere avviata solo una volta ogni 12 ore.",
  "profile.export_library_success": "Esportazione avviata! Quando i tuoi dati saranno pronti per il download, riceverai un'e-mail.",
  "profile.delete_account.title": "Elimina account",
  "profile.delete_account.description": "Elimina definitivamente il tuo account Teachino. Tutte le integrazioni verranno disconnesse e i dati dell'account non potranno essere ripristinati.",
  "profile.delete_account.action": "Elimina account",
  "profile.delete_account.confirm_title": "Eliminare il tuo account?",
  "profile.delete_account.confirm_description": "Questa azione non può essere annullata. Le tue integrazioni verranno disconnesse, verrai disconnesso e riceverai un'e-mail di conferma.",
  "profile.delete_account.confirm_pro_license": "La tua licenza Pro individuale verrà terminata quando eliminerai il tuo account.",
  "profile.delete_account.confirm_instruction": "Per confermare, inserisci l'indirizzo e-mail mostrato qui sotto.",
  "profile.delete_account.email_mismatch": "L'indirizzo e-mail non corrisponde.",
  "profile.delete_account.reason_question": "Perché elimini il tuo account?",
  "profile.delete_account.reason_hint": "La tua risposta è facoltativa e ci aiuta a migliorare Teachino.",
  "profile.delete_account.reason.too_expensive": "Teachino è troppo costoso per me",
  "profile.delete_account.reason.missing_feature": "Mi manca una funzione",
  "profile.delete_account.reason.too_complicated": "Teachino è troppo complicato per me",
  "profile.delete_account.reason.no_time_or_not_needed": "Non ho tempo o non ne ho bisogno",
  "profile.delete_account.reason.switched_to_other_tool": "Sono passato/a a un altro strumento",
  "profile.delete_account.reason.privacy_concerns": "Ho dubbi sulla protezione dei dati",
  "profile.delete_account.reason.duplicate_account": "Ho già un altro account Teachino",
  "profile.delete_account.reason.other": "Altro",
  "profile.delete_account.reason_text_label": "Vuoi dirci qualcos'altro?",
  "profile.delete_account.reason_text_placeholder": "Il tuo feedback (facoltativo)",
  "profile.checklist.show": "Mostra di nuovo i suggerimenti nella pagina iniziale",
  "profile.checklist.success": "La lista di suggerimenti verrà mostrata di nuovo nella pagina iniziale",
  "course_name": "Nome",
  "course_short_name": "Nome breve",
  "course_create_title": "Crea nuovo corso",
  "course_create_success_title": "{{name}} creato!",
  "course_create_color": "Scegli colore",
  "course_create_char_limit_error": "Il nome del corso non può superare {{limit}} caratteri",
  "course_create_short_name_char_limit_error": "Il nome breve non può superare {{limit}} caratteri",
  "course_create_name_required": "Per favore, inserisci un nome per il corso.",
  "course.plan": "Pianificazione",
  "course.page.title": "I tuoi corsi",
  "course.page.description": "Crea un corso per ogni classe e materia che insegni. Ad esempio: \"8A Geografia\".",
  "library.generic_materials": "Materiali generali",
  "library.generic_materials.description": "Tutti i materiali non assegnati a nessuna cartella",
  "library.topics.description.title": "Organizza i materiali in cartelle per avere una migliore visione d'insieme.",
  "library.topics.description.description_1": "Apri un materiale e scegli la cartella nei dettagli.",
  "library.topics.description.description_2": "Le cartelle corrispondono alle sezioni dell'anno scolastico, ad es. un argomento o capitolo più ampio.",
  "library.create_course.title_course": "Crea nuovo corso",
  "library.create_course.title_template": "Crea nuova raccolta",
  "library.create_course.title_from_template": "Crea corso da raccolta",
  "library.create_course.placeholder_name_course": "Es. 1A Matematica",
  "library.create_course.placeholder_short_name_course": "Es. 1AM",
  "library.create_course.placeholder_name_template": "Geografia Facoltà Anno 1",
  "library.create_course.button_course": "Crea nuovo corso",
  "library.create_course.button_template": "Crea nuova raccolta",
  "library.new_items.empty_state.description": "Carica materiali esistenti o crea nuovi direttamente in Teachino.",
  "library.items_selected_1": "1 Materiale",
  "library.items_selected_many": "{{number}} Materiali",
  "library.topics_selected_1": "1 Cartella",
  "library.topics_selected_many": "{{number}} Cartelle",
  "library.new_items.empty_state.cta": "Crea materiale",
  "library.all_topics.empty_state.title": "Ancora nessuna cartella creata.",
  "library.all_topics.empty_state.description": "I tuoi materiali sono organizzati in cartelle su Teachino. Quando crei una cartella, questa appare qui e puoi riutilizzarla in ogni anno scolastico e classe parallela.",
  "library.all_topics.empty_state.cta": "Crea cartella",
  "library.search.all_topics.no_results": "La ricerca per \"{{search}}\" non ha trovato risultati corrispondenti",
  "library.my_topics": "Tutte le cartelle",
  "library.unsorted_topics": "Cartelle non ordinate",
  "library.unsorted_topics.empty_state.title": "Ottimo lavoro! 🧹🧽",
  "library.unsorted_topics.empty_state.description_0": "Non hai cartelle non ordinate.",
  "library.unsorted_topics.empty_state.description_1": "Amiamo l'ordine e anche tu, evidentemente!",
  "library.topic_details.no_courses": "Questa cartella non è ancora assegnata a un corso.",
  "library.topic.cannot_bulk_delete.title": "Capitoli non possono essere eliminati",
  "library.topic.cannot_bulk_delete.description": "La cartella \"{{topic}}\" non può essere eliminata.",
  "library.topic.cannot_bulk_duplicate.title": "Capitoli non possono essere duplicati",
  "library.topic.cannot_bulk_duplicate.description": "La cartella \"{{topic}}\" non può essere duplicata.",
  "library.sort.default": "Ordine proprio",
  "library.sort.created": "Per data di creazione",
  "library.sort.date": "Per data",
  "library.sort.alphabetically": "Alfabetico",
  "course_settings.all_settings": "Tutte le impostazioni",
  "course_settings.tabs.general.title": "Impostazioni generali",
  "course_settings.tabs.general.description": "Nome, aspetto, collaborazione e stato del corso",
  "course_settings.tabs.ai.title": "Impostazioni IA",
  "course_settings.tabs.ai.description": "Contesto del corso e istruzioni IA aggiuntive",
  "course_settings.tabs.students.description": "Alunni/e, codici di accesso e gruppi di studio",
  "course_settings.tabs.students.section_description": "Gestisci alunni/e e i loro codici di accesso",
  "course_settings.details.title": "Dettagli",
  "course_settings.details.sub_title": "Nome, nome breve, colore, anno scolastico",
  "course_settings.close_title": "Elimina corso",
  "course_settings.close_description": "Il corso non sarà più visualizzato per la pianificazione. I materiali rimarranno accessibili tramite la voce \"Corsi eliminati\" nella libreria.",
  "course_settings.close_warning": "Eliminare \"{{courseName}}\"?",
  "course_settings.close_button": "Elimina corso",
  "course_settings.close.success_title": "Corso eliminato",
  "course_settings.close.success_description": "Il corso \"{{courseName}}\" è stato eliminato.",
  "course_settings.collaboration.title": "Collaborazione",
  "course_settings.collaboration.sub_title": "Collaborare con altri insegnanti",
  "course_settings.collaboration.description_1": "Insegnare insieme è più divertente! Invita i tuoi colleghi/colleghe a condividere materiali e pianificare lezioni insieme!",
  "course_settings.collaboration.invite.title": "Invita colleghi/colleghe a {{courseName}}",
  "course_settings.collaboration.invite.cta": "Invita colleghi/colleghe",
  "course_settings.collaboration.invite.description": "Seleziona i permessi che il tuo collega dovrebbe ricevere.",
  "course_settings.collaboration.invite.access.read_only": "Sola lettura",
  "course_settings.collaboration.invite.access.read_only_description": "Può vedere il corso e copiare i materiali, ma non modificarli.",
  "course_settings.collaboration.invite.access.write": "Modifica",
  "course_settings.collaboration.invite.access.write_description": "Può modificare i materiali condivisi del corso e collaborare direttamente nel corso.",
  "course_settings.collaboration.invite.role_title": "Invita {{roleName}} a {{courseName}}",
  "course_settings.collaboration.invite.link.title": "Invia link di invito",
  "course_settings.collaboration.invite.link.description": "Copia il link e invialo ai colleghi/colleghe con cui vuoi collaborare. Il link è valido per 7 giorni.",
  "course_settings.collaboration.invite.search.title": "Cerca collega",
  "course_settings.collaboration.invite.search.description": "Gli insegnanti all'interno della stessa licenza scolastica possono essere invitati direttamente.",
  "course_settings.collaboration.invite.search.cta": "Invita",
  "course_settings.collaboration.invite.search.placeholder": "Inserisci un nome per cercare",
  "course_settings.collaboration.invite.search.success": "Collega aggiunto al corso.",
  "course_settings.collaboration.leave.cta": "Lascia collaborazione",
  "course_settings.collaboration.role.owner": "Creatore",
  "course_settings.collaboration.role.teacher": "Modificatore",
  "course_settings.collaboration.role.teacher_description": "Può modificare i materiali di tutti i membri e duplicarli nella propria biblioteca.",
  "course_settings.collaboration.role.co_teacher": "Co-modificatore",
  "course_settings.collaboration.role.co_teacher_description": "Può aggiungere e modificare i propri materiali. Può copiare tutte le cartelle e tutti i materiali.",
  "course_settings.collaboration.role.guest": "Ospite",
  "course_settings.collaboration.role.guest_description": "Può vedere cartelle e materiali e duplicarli nella propria biblioteca.",
  "course_settings.collaboration.role.sub_teacher": "Supplente",
  "course_settings.collaboration.remove_teacher": "Rimuovi collega",
  "course_settings.collaboration.remove_teacher_description": "{{collaboratorName}} non può più accedere a {{courseName}}.",
  "course_settings.collaboration.remove_myself": "Lascia collaborazione",
  "course_settings.collaboration.remove_myself_description": "Perdi accesso a {{courseName}} e ai materiali lì salvati.",
  "course_settings.collaboration.member_since": "Membro dal {{date}}",
  "course_invite.title": "{{courseOwner}} ti invita a collaborare.",
  "course_invite.description": "Con Teachino potete raccogliere i vostri materiali in un unico luogo e pianificare le lezioni insieme.",
  "course_invite.accept": "Accetta invito",
  "course_invite.signup_accept": "Crea account & Accetta invito",
  "course_invite.login_accept": "Accedi & Accetta invito",
  "course_invite.already_member": "Condividi il link a questa pagina con i tuoi colleghi/colleghe per pianificare insieme le lezioni.",
  "course_invite.open_course": "Apri corso",
  "course_invite.open_collection": "Apri raccolta",
  "course_invite.expired": "Questo link è scaduto.",
  "course_invite.expired_call_to_action": "Per favore, chiedi a {{courseOwner}} un nuovo link.",
  "tenant_invite.title": "La piattaforma didattica che pensa insieme a te.",
  "tenant_invite.description": "Materiali, pianificazione, apprendimento interattivo e documentazione in un unico luogo – collegati da un assistente IA che pensa insieme a te e ti supporta.",
  "tenant_invite.accept": "Accetta l'invito",
  "tenant_invite.signup_accept": "Crea un account e accetta l'invito",
  "tenant_invite.login_accept": "Accedi e accetta l'invito",
  "tenant_invite.already_member": "Fai già parte di questa scuola.",
  "tenant_invite.continue": "Vai a Teachino",
  "tenant_invite.expired": "Questo link di invito è scaduto.",
  "tenant_invite.expired_call_to_action": "Per favore, chiedi a {{tenantName}} un nuovo link.",
  "course_plan.create_topic": "Crea nuova cartella",
  "course_plan.create_material_in_topic": "Crea nuovo materiale in {{topicName}}",
  "course_plan.add_topic": "Aggiungi cartella",
  "course_plan.add_from_library": "Aggiungi cartella da un altro corso",
  "course_plan.unorganised_topic": "Materiali senza cartella",
  "create_item.confirm_delete_snippet": "Materiale non sarà salvato!",
  "course_plan.manage_content_button": "Apri pianificazione annuale",
  "course_plan.empty_state_1": "Inizia a pianificare",
  "course_plan.empty_state_2": "Scegli materiali dal corso o creane di nuovi.",
  "course_plan.primary_note.title": "Nota per questa lezione",
  "course_plan.primary_note.mobile.button_empty": "Tocca qui per annotare cose amministrative che riguardano solo questa lezione.",
  "course_plan.items.title": "Materiali della lezione",
  "course_plan.drag_drop_tutorial": "Trascina i materiali nella lezione qui",
  "topic.name": "Nome della cartella",
  "topic.action.edit": "Modifica cartella",
  "topic.action.sort": "Ordina cartelle",
  "topic.lesson_goals": "Obiettivi di apprendimento e competenze",
  "topic.delete": "Elimina cartella e materiali",
  "topic.read_only": "🔒 Non puoi modificare questa cartella. Puoi copiare i materiali in un altro corso.",
  "topic_instance.create.create_topic": "Cartella",
  "topic_instance.create.create_topic_save": "Crea",
  "topic_instance.create.add_to_multiple_courses_closed": "Aggiungi a più corsi",
  "topic_instance.create.add_to_course_0": "Aggiungi a un corso",
  "topic_instance.create.add_to_course_1": "Aggiungi a un corso",
  "topic_instance.create.add_to_course_many": "Aggiungi a {{number}} corsi",
  "topic_instance.create.add_to_course_with_name": "Aggiungi a {{course}}",
  "topic_instance.create.add_to_course_disabled": "Aggiungi a corso",
  "topic_instance.add_course_modal.title": "Aggiungi cartella al corso",
  "topic_instance.add_course_modal.description": "Scegli i corsi a cui aggiungere {{topic}}:",
  "item.tooltip.past_dates": "Insegnato il: {{dates}}",
  "item.tooltip.future_dates": "Pianificato per: {{dates}}",
  "item.menu.make_visible": "Mostra ad alunni ed alunne",
  "item.menu.make_not_visible": "Nascondi ad alunni ed alunne",
  "item.menu.hidden_for_class": "Nascosto per alunni ed alunne",
  "item.menu.visible_for_class": "Visibile per alunni ed alunne",
  "item.menu.item_made_visible": "Materiale ora visibile per alunni ed alunne",
  "item.menu.item_made_not_visible": "Materiale non più visibile per alunni ed alunne",
  "item.menu.edit_item": "Rinomina materiale",
  "item.name": "Nome",
  "page_title_reset_password": "Reimposta password",
  "page_title_verify_password": "Conferma password",
  "page_title_login": "Accedi",
  "page_title_logout": "Disconnetti",
  "page_title_signup": "Registrati",
  "page_title_verify_email": "Conferma e-mail",
  "page_title_course_create": "Crea corso",
  "calendar_week": "Settimana",
  "edit_note_error": "Impossibile salvare nota",
  "remove_note_error": "Impossibile rimuovere nota",
  "note_placeholder": "Inserisci nota",
  "weekday_date_picker_reader_text": "Scegli data",
  "weekday_move_to": "Sposta a {{date}}",
  "note_empty_error": "Per favore, aggiungi materiali alla tua nota",
  "offline_mode": "Modalità offline",
  "online_mode": "Online",
  "back_online": "Sei di nuovo online!",
  "offline_text": "Sei offline, la funzionalità è limitata.",
  "today": "Oggi",
  "view_menu_options": "Mostra opzioni menu",
  "item_detail.duration_heading": "Durata",
  "item_detail.duration.error_le_0": "La durata minima è di un minuto",
  "item_detail.add_duration": "Aggiungi durata",
  "item_detail.edit_duration": "Modifica durata",
  "course_students.privacy_banner.austria_message": "Per utilizzare i dati di alunni/e in Austria, accedi tramite il Bildungsportal (BIP). In alternativa, la direzione scolastica può firmare il contratto per il trattamento dei dati.",
  "course_students.privacy_banner.connect_bip": "Accedi con BIP",
  "course_students.privacy_banner.read_more": "Continua a leggere",
  "course_students.accounts.import.license_missing_title": "Importazione di alunni/e non disponibile",
  "course_students.accounts.import.license_missing_description": "La tua scuola ha bisogno di una licenza scolastica Teachino che includa gli account alunni/e per importare automaticamente alunni/e dall'integrazione collegata. Rivolgiti alla direzione scolastica o a Teachino.",
  "course_students.accounts.import.license_missing_toast": "Il corso è stato collegato. Alunni/e non sono stati importati: la tua scuola ha bisogno di una licenza scolastica Teachino che includa gli account alunni/e.",
  "student_accounts.login.choose_method": "Come vuoi continuare?",
  "student_accounts.login.received_code": "Ho ricevuto un codice dal mio insegnante",
  "course_students.reusable_share.course_title": "Condividi il link del corso",
  "course_students.reusable_share.course_description": "Condividi questo link o codice QR. Gli alunni accedono con il proprio codice personale.",
  "course_students.reusable_share.material_title": "Condividi il link del materiale",
  "course_students.reusable_share.material_description": "Condividi questo link o codice QR per portare gli alunni direttamente al materiale dopo l’accesso.",
  "course_students.reusable_share.show_qr_code": "Mostra codice QR",
  "course_students.reusable_share.copy_public_tooltip": "Gli studenti possono registrarsi autonomamente tramite questo link. Ricevono poi un codice di accesso personale.",
  "course_students.reusable_share.copy_code_tooltip": "Gli studenti possono aprire questo link e accedere con il proprio codice di accesso personale.",
  "course_students.reusable_share.qr_description": "Questo codice QR rimanda al corso.",
  "course_students.reusable_share.qr_code_description": "Gli studenti possono utilizzare questo codice QR per accedere con il proprio codice di accesso personale.",
  "course_students.reusable_share.qr_public_description": "Gli studenti possono utilizzare questo codice QR per registrarsi autonomamente. Ricevono poi un codice di accesso personale.",
  "course_students.reusable_share.student_codes": "Codici di accesso dei tuoi studenti",
  "course_students.reusable_share.material_disabled": "Rendi il materiale visibile ad almeno un alunno prima di condividerlo.",
  "course_students.self_registration.title": "Attiva la registrazione autonoma degli studenti",
  "course_students.self_registration.description": "Gli studenti aprono il link e inseriscono il proprio nome o le proprie iniziali. Ricevono un codice per accedere di nuovo in seguito.",
  "course_students.self_registration.toggle_label": "Consenti la registrazione autonoma",
  "course_students.self_registration.link_description": "Invia questo link ai tuoi alunni.",
  "course_students.self_registration.saved": "Impostazione salvata",
  "course_students.self_registration.material_banner": "Gli alunni con questo link possono creare il proprio account. Riceveranno un codice di accesso per accedere nuovamente al corso in seguito.",
  "student_accounts.self_registration.no_code": "Non ho ancora un codice",
  "student_accounts.self_registration.description": "Inserisci il tuo nome o le tue iniziali.",
  "student_accounts.self_registration.name_label": "Il tuo nome",
  "student_accounts.self_registration.name_placeholder": "Inserisci il tuo nome",
  "student_accounts.self_registration.submit": "Crea account",
  "student_accounts.self_registration.error": "Non è stato possibile creare l’account. Riprova.",
  "student_accounts.self_registration.code_title": "Questo è il tuo codice",
  "student_accounts.self_registration.code_description": "Tieni al sicuro questo codice. Ti servirà quando tornerai.",
  "student_accounts.self_registration.code_warning": "Scrivilo oppure chiedi a un adulto di aiutarti a salvarlo.",
  "student_accounts.self_registration.code_teacher_note": "Il tuo insegnante può gestire i codici.",
  "student_accounts.self_registration.continue": "Avanti",
  "course_students.merge.action": "Unisci questo account duplicato",
  "course_students.merge.title": "Unisci account duplicato",
  "course_students.merge.description": "{{sourceName}} ({{sourceCode}}) verrà eliminato. Scegli l’account che deve conservare i dati uniti.",
  "course_students.merge.target_label": "Account da conservare",
  "course_students.merge.target_placeholder": "Scegli l’account da conservare",
  "course_students.merge.newest_wins_hint": "Tutti i dati vengono trasferiti nell’account selezionato. Il nome e il codice restano invariati. In caso di conflitto viene mantenuto il valore più recente.",
  "course_students.merge.confirm": "Unisci ed elimina il duplicato",
  "course_students.merge.success": "{{sourceName}} è stato unito a {{targetName}}",
  "emoji.skin.2": "2",
  "emoji.skin.3": "3",
  "emoji.skin.4": "4",
  "emoji.skin.5": "5",
  "emoji.skin.6": "6",
  "emoji.remove": "Rimuovi simbolo",
  "action": "Azioni",
  "error_page.title": "Qualcosa è andato storto",
  "error_page.title_404": "Pagina non trovata",
  "error_page.button": "Torna alla pagina iniziale",
  "public.empty_material.student": "Questo materiale è vuoto. Verrà popolato quando il/la docente aggiungerà contenuti.",
  "public.hidden_material.student.title": "Questo materiale non ti è ancora stato condiviso.",
  "public.hidden_material.student.description": "Non appena il tuo docente lo condividerà, apparirà nella panoramica del corso.",
  "public.logged_in_as": "Stai modificando il materiale come {{studentNickname}}. Non sei tu? Clicca qui per disconnetterti.",
  "public.recently_shared": "Condivisi di recente",
  "student_course.empty.title": "Nessun materiale per ora",
  "student_course.empty.description": "Il tuo insegnante non ha ancora condiviso nulla con te. Torna più tardi.",
  "library.empty": "La tua biblioteca non contiene ancora materiali.",
  "library.topic_count_0": "Nessuna cartella",
  "library.topic_details.empty_state": "Riempi la cartella con materiali",
  "library.topic.move_to_folder": "Sposta in cartella",
  "library.topic.move_to_folder.modal.move_one_description": "Sposta \"{{topic}}\"",
  "library.topic.move_to_folder.modal.move_many_description": "Sposta {{number}} cartelle",
  "library.topic.move_to_folder.modal.confirm": "Sposta in \"{{folder}}\"",
  "library.topic.move_to_folder.toast.success": "Cartella spostata con successo",
  "library.topic.copy_to_folder": "Duplica in cartella",
  "library.topic.copy_to_folder.modal.move_one_description": "Duplica \"{{topic}}\"",
  "library.topic.copy_to_folder.modal.move_many_description": "Duplica {{number}} cartelle",
  "library.topic.copy_to_folder.modal.confirm": "Duplica in \"{{folder}}\"",
  "library.topic.copy_to_folder.toast.success": "Cartella duplicata con successo",
  "library.topic.rename.toast.success": "Cartella rinominata",
  "library.folder.rename.toast.success": "Cartella rinominata",
  "library.folder.feature_description": "Organizza le cartelle in cartelle",
  "library.topic.goals_updated.toast.success": "Obiettivi e competenze salvati",
  "library.topic.goals.empty_button": "Inserisci obiettivi e competenze",
  "library.topic.add_to_course": "Aggiungi al corso",
  "library.topics.add_to_courses.bulk.description": "{{count}} cartelle verranno aggiunte ai corsi selezionati.",
  "library.topics.add_to_courses.toast.success": "Cartelle aggiunte ai corsi",
  "library.topic.courses_school_year_filter": "Anno scolastico {{schoolYear}}",
  "library.topic.create_with_name": "Crea nuova cartella {{name}}",
  "library.topic.create.title": "Crea nuova cartella",
  "library.topic.create.label": "Nome della cartella",
  "library.topic.create.button": "Crea cartella",
  "library.topic.create.error": "Per favore inserisci un nome per la cartella.",
  "library.topic.create.description": "Le cartelle sono unità tematiche, come i capitoli del libro di testo.<br />Nel passo successivo puoi aggiungere materiali alla cartella.",
  "library.topic.create.examples": "<strong>Esempi:</strong> \"Teorema di Pitagora\", \"Cambiamento climatico\", \"Simple Past\"",
  "library.create_topic.empty_state.title": "Crea ora la tua prima cartella! 📚📝",
  "library.create_topic.empty_state.description": "In Teachino strutturi i tuoi materiali in cartelle. Servono come argomenti generali, ad esempio i capitoli del libro di testo",
  "library.create_topic.empty_state.input_placeholder": "Ad esempio \"Formazione dei ghiacciai\" o \"Introduzione al teorema di Pitagora\"",
  "library.show_archived_courses": "Mostra corsi eliminati",
  "library.hide_archived_courses": "Nascondi corsi eliminati",
  "library.add_from_library": "Aggiungi cartella da un altro corso",
  "library.add_from_library_closed_courses": "Corsi eliminati",
  "library.add_from_library_closed_courses_empty": "I corsi degli anni scolastici passati appariranno qui.",
  "library.add_from_library.header": "{{number}} cartelle trovate",
  "library.add_from_library.show_all": "Mostra tutte le cartelle",
  "library.add_from_library.empty_title": "Nessuna cartella trovata",
  "library.add_from_library.empty_description": "Non è stata trovata una cartella adatta. Puoi crearne una nuova.",
  "library.duplicate_item.title": "Duplica materiale",
  "library.move_item.title": "Sposta materiale",
  "library.move_item.warning_title": "Attenzione: I dati potrebbero andare persi!",
  "library.move_item.warning_description": "Se questo materiale è già pianificato in un corso, la sua associazione al corso e alle ore di ora di lezione andrà persa!",
  "library.move_item.warning_description_many": "Se i materiali sono già pianificati in un corso, perderanno l’associazione al corso e alle ore di lezione.",
  "library.duplicate_item.new_name": "Nuovo nome",
  "library.duplicate_item.new_topic": "Nuova cartella",
  "library.duplicate_item.new_name_prefix": "Copia di",
  "library.duplicate_item.success": "Il materiale è stato duplicato",
  "library.duplicate_topic.title": "Duplica cartella",
  "library.duplicate_topic.course": "Nuovo corso / Nuova raccolta",
  "library.duplicate_topic.success": "La cartella è stata duplicata.",
  "library.template.create_from_template.tooltip": "Verrà creato un nuovo corso con tutte le cartelle, tutti i materiali e tutte le impostazioni di questa raccolta.",
  "library.folder_tree.empty_state.description": "Le cartelle offrono un ulteriore livello di organizzazione per le tue cartelle.",
  "library.folder_tree.empty_state.cta": "Crea cartella",
  "library.folder.empty_state.title": "Cartella vuota",
  "library.folder.empty_state.description": "\"{{folder}}\" non contiene ancora cartelle. Creane una nuova o sposta qui una cartella esistente.",
  "library.folder.create": "Crea cartella",
  "library.folder.name.label": "Nome della cartella",
  "library.folder.delete": "Elimina cartella",
  "library.folder.delete.folder_not_empty": "Solo cartelle vuote possono essere eliminate.",
  "library.folder.delete.please_delete_subfolders": "Per favore rimuovi tutte le sottocartelle e le cartelle da \"{{folder}}\"",
  "library.folder.delete.are_you_sure": "Sei sicuro di voler eliminare la cartella \"{{folder}}\"? Questa azione è irreversibile.",
  "library.folder.rename": "Rinomina cartella",
  "library.folder.convert_to_template": "Converti in raccolta",
  "library.folder.add_to_course": "Aggiungi al corso",
  "library.folder.add_to_courses.description": "Tutte le sequenze e i materiali in \"{{folder}}\", incluse le sottocartelle ({{count}} sequenze), verranno aggiunti ai corsi selezionati.",
  "library.folder.convert_to_template.description": "Verrà creata una nuova raccolta contenente una copia di tutte le sequenze e i materiali di questa cartella.",
  "library.folder.convert_to_template.name.label": "Nome della raccolta",
  "library.folder.convert_to_template.cta": "Crea raccolta",
  "library.folder.convert_to_template.toast.success": "Raccolta creata",
  "library.collection.create_from_topics.button": "Crea raccolta",
  "library.collection.create_from_topics.title": "Crea raccolta",
  "library.collection.create_from_topics.description": "{{count}} unità verranno copiate come cartelle separate in una raccolta. La struttura delle cartelle della biblioteca non viene mantenuta.",
  "library.collection.create_from_topics.name.label": "Nome della raccolta",
  "library.collection.create_from_topics.cta": "Crea raccolta",
  "library.collection.create_from_topics.toast.success": "Raccolta creata",
  "library.collection.create_from_topics.no_eligible_topics": "Seleziona almeno un’unità. I materiali generici non possono essere aggiunti a una raccolta.",
  "collection.add_content_menu.import_material": "Aggiungi da corso",
  "collection.edit": "Modifica raccolta",
  "collection.rename": "Rinomina raccolta",
  "collection.name_description": "Come deve chiamarsi la raccolta?",
  "collection.archive": "Elimina raccolta",
  "collection.archive_description": "La raccolta verrà eliminata e tutti i membri perderanno l'accesso. Le cartelle e i materiali utilizzati nei corsi rimangono disponibili.",
  "collection.archived_toast": "Raccolta eliminata. La raccolta \"{{collectionName}}\" è stata eliminata.",
  "navigation.collections": "Raccolte",
  "collections.my_title": "Le mie raccolte",
  "collections.shared_title": "Condivise con me",
  "collections.create": "Crea raccolta",
  "collections.my.empty_title": "Ancora nessuna raccolta",
  "collections.my.empty_description": "Crea la tua prima raccolta per condividere cartelle e materiali con i colleghi/colleghe e riutilizzarli nei corsi.",
  "collections.shared.empty_title": "Nessuna raccolta condivisa",
  "collections.shared.empty_description": "Le raccolte a cui i colleghi/colleghe ti invitano appariranno qui.",
  "collections.owner_you": "Tu",
  "collection.name_and_gradient": "Nome e aspetto",
  "collection.gradient.regenerate": "Rigenera",
  "template.sync.success": "Sincronizzazione riuscita!",
  "template.sync.error": "Sincronizzazione non riuscita.",
  "library.file_upload.choose_files": "Scegli file",
  "library.file_upload.drag_here": "Trascina i file qui o",
  "library.file_upload.error": "Il file non può essere caricato.",
  "features.timetable.page_timetable": "Orario didattico",
  "features.timetable.failed_save": "L'orario didattico non è salvato correttamente.",
  "timetable.week_not_loaded": "L'orario didattico per questa settimana non è stato caricato. Riprova o scegli un'altra settimana.",
  "timetable.integration_not_available_title": "WebUntis non raggiungibile - Visualizzazione dell'orario didattico limitata",
  "timetable.integration_not_available_desc1": "Le lezioni pianificate appaiono nella lista",
  "timetable.integration_not_available_desc2": "Le lezioni ancora non pianificate in Teachino non appaiono",
  "timetable.integration_not_available_desc3": "Non appena WebUntis sarà di nuovo disponibile, verrà mostrato automaticamente l’intero orario didattico.",
  "timetable.integration_not_available_desc4": "Dai menu \"Corsi\" e \"Biblioteca\" puoi sempre aprire tutti i materiali",
  "timetable_edit.add_period": "Appuntamento",
  "timetable_edit.create_period_title": "Crea appuntamento",
  "timetable_edit.edit_period_title": "Modifica appuntamento",
  "timetable_edit.period_label": "Descrizione",
  "timetable_edit.period_label_placeholder": "Ad esempio riunione, …",
  "timetable_edit.period_label_error": "Inserisci descrizione",
  "timetable_edit.period_date": "Data",
  "timetable_edit.period_date_time": "Data e ora",
  "timetable_edit.period_date_time_error": "Controlla data e ora",
  "timetable_edit.period_date_error": "Seleziona una data.",
  "timetable_edit.period_time": "Ora",
  "timetable_edit.period_note_loading": "Caricamento nota…",
  "timetable_edit.period_note_placeholder": "Nota per questo giorno di corso",
  "timetable_edit.cancel": "Annulla",
  "timetable_edit.cancel_warning_title": "Conferma cancellazione",
  "timetable_edit.cancel_warning_description": "Conferma che questa ora di lezione non avrà luogo.",
  "timetable_edit.cancel_warning_confirm": "Lezione cancellata",
  "timetable_edit.uncancel": "Ripristina lezione",
  "timetable_edit.uncancel_warning_title": "Ripristina lezione annullata",
  "timetable_edit.uncancel_warning_description": "Ripristinare questa lezione nell’orario?",
  "timetable_edit.remove_warning_title": "Eliminare voce",
  "timetable_edit.remove_warning_description": "Conferma che desideri eliminare questa voce.",
  "timetable_edit.remove_warning_confirm": "Rimuovere voce",
  "timetable.empty_state_header": "Orario didattico e appuntamenti",
  "timetable.empty_state_description": "Qui puoi tenere d'occhio la tua settimana e preparare le tue lezioni.",
  "timetable.empty_state_button": "Inserire orario didattico",
  "timetable.edit": "Modifica orario didattico",
  "timetable.edit.choose": "Scegli un corso per questa lezione",
  "timetable.edit.choose_create": "Crea nuovo corso",
  "agenda.empty.description": "Per questo corso non ci sono appuntamenti nel periodo selezionato. Inserisci un orario didattico o crea una singola lezione.",
  "agenda.empty.date_range": "Periodo:",
  "todo_title": "Da fare",
  "todo_item_placeholder": "Inserisci da fare",
  "todo_move_to_another_date": "Scegli un'altra data",
  "todo_change_course": "Cambia corso",
  "todo_no_course": "Nessun corso",
  "todo_page_overdue": "Da fare in ritardo",
  "todo_add_date": "Aggiungi data",
  "todo_error_fetch": "Errore: non è stato possibile recuperare i compiti dal server",
  "todo_error_edit": "Errore: non è stato possibile modificare il compito",
  "todo_error_delete": "Errore: non è stato possibile eliminare il compito",
  "todo_success_change_date_header": "Data modificata",
  "todo_success_change_date_description": "La data è stata modificata al {{date}}.",
  "course_plan.todo_header": "Compiti per {{date}}",
  "course_plan.note_saved": "Pianificazione salvata!",
  "integration.connect_title": "Collega profili",
  "integration.settings_title": "Integrazioni",
  "integration.settings_remove": "Disconnetti",
  "integration.settings_remove_title": "Disconnetti",
  "integration.settings_remove_description": "La connessione a corsi e orari didattici verrà interrotta. Il Single-Sign-On non sarà più possibile. Se non hai ancora impostato una password, puoi reimpostarla tramite il tuo indirizzo email.",
  "integration.settings_connect": "Collegare",
  "integration.settings_coming_soon_cta": "Ulteriori informazioni",
  "integration.disconnected_notice.title": "Collegamento a {{displayName}} rimosso",
  "integration.disconnected_notice.description": "{{displayName}} non consente più a Teachino di accedere al tuo account: la tua scuola ha disattivato l'integrazione oppure il tuo accesso è stato rimosso. Abbiamo quindi rimosso il collegamento. I tuoi corsi e materiali in Teachino restano disponibili. Non appena avrai di nuovo accesso, potrai ripristinare il collegamento.",
  "integration.disconnected_notice.open_settings": "Apri le integrazioni",
  "integration.disconnected_notice.dismiss": "Ho capito",
  "integration.authenticate.header": "Collega {{displayName}} con Teachino",
  "integration.authenticate.integration_profile": "Profilo {{displayName}}",
  "integration.authenticate.teachino_profile": "Profilo Teachino",
  "integration.authenticate.error_generic": "Si è verificato un errore durante l'accesso. Apri Teachino tramite app.teachino.io o contattaci a hallo@teachino.io",
  "integration.authenticate.student_creation_failed": "Non è stato possibile creare il tuo accesso studente. Apri nuovamente Teachino da WebUntis o contatta il tuo insegnante.",
  "integration.authenticate.redirect_triggered": "Sarai reindirizzato a breve.",
  "integration.authenticate.not_possible_title": "Già collegato a un altro account Teachino",
  "integration.authenticate.not_possible_description": "Questo account {{displayName}} è già collegato a un altro account Teachino e non può essere collegato al tuo account attuale. Puoi uscire e continuare con quello collegato, oppure rimanere nel tuo account attuale.",
  "integration.authenticate.login_conflict_title": "Hai effettuato l’accesso con un altro account Teachino",
  "integration.authenticate.login_conflict_description": "Questo account {{displayName}} è collegato a un account Teachino diverso da quello che stai usando. Per accedere tramite questa integrazione, esci prima dal tuo account Teachino attuale.",
  "integration.authenticate.current_account": "Account attualmente in uso: {{email}}",
  "integration.authenticate.sign_out_and_continue": "Esci e continua con {{displayName}}",
  "integration.authenticate.not_possible_back_link": "Rimani nel mio account attuale",
  "integration.authenticate.cannot_signup": "Sembra che tu abbia già un profilo Teachino. Seleziona \"Utilizzo già Teachino\" e accedi. Successivamente potrai collegare il profilo.",
  "integration.authenticate.signup_conflict_description": "Hai già un account Teachino. Accedi per collegarlo a questa integrazione.",
  "integration.authenticate.create_account": "Crea un nuovo account",
  "integration.authenticate.help": "Per assistenza, contatta hallo@teachino.io",
  "integration.authenticate.sign_up": "Sono nuovo su Teachino",
  "integration.authenticate.log_in": "Utilizzo già Teachino",
  "integration.authenticate.successful": "{{displayName}} e Teachino sono stati collegati!",
  "integration.authenticate.open_teachino_hint": "Apri Teachino su app.teachino.io e accedi con il tuo indirizzo e-mail e la tua password.",
  "integration.authenticate.open_teachino": "Apri Teachino",
  "integration.admininfo.title": "L’integrazione con Teachino è attiva! 👏",
  "integration.admininfo.description": "I docenti ora vedono Teachino in WebUntis e possono lavorare con Teachino.",
  "integration.admininfo.explore_title": "1. Scopri Teachino 👀",
  "integration.admininfo.open_website": "Apri il sito web",
  "integration.admininfo.try_title": "Vuoi provarlo?",
  "integration.admininfo.try_description": "Accedi a WebUntis con un utente con ruolo docente e clicca su Teachino. Al posto di questa pagina vedrai la pianificazione delle lezioni.",
  "integration.admininfo.inform_title": "2. Informa i colleghi 📣",
  "integration.admininfo.inform_description": "Modello di testo da inviare via e-mail o messaggistica",
  "integration.admininfo.mail_text": "Care colleghe e cari colleghi,\nho appena attivato l’integrazione di WebUntis con Teachino. Teachino supporta la creazione di materiali con l’intelligenza artificiale e fornisce agli studenti un feedback con l’IA. Potete provare Teachino da subito. Ulteriori informazioni e una breve guida sono disponibili su https://help.teachino.io/\nCordiali saluti",
  "integration.admininfo.copy_text": "Copia il testo e invialo",
  "integration.admininfo.copied_title": "Testo copiato",
  "integration.admininfo.copied_description": "Ora puoi incollare il testo nel tuo programma di posta e inviarlo.",
  "integration.admininfo.meeting_title": "3. Fissa una videochiamata con Teachino 📆",
  "integration.admininfo.meeting_description": "Saremo felici di presentarti Teachino in una videochiamata e di rispondere a tutte le tue domande.",
  "integration.admininfo.schedule": "Scegli un appuntamento",
  "integration.admininfo.contact": "Contatta il team di Teachino",
  "integration.not_ready.title": "Attiva l’integrazione con Teachino 🚀",
  "integration.not_ready.description": "Compila questo modulo. Fisseremo poi una breve videochiamata per spiegarti le funzioni principali di Teachino e configurare insieme a te il periodo di prova.",
  "integration.not_ready_student.title": "Teachino non è ancora attivo per la tua scuola.",
  "integration.not_ready_student.description": "Non appena il tuo docente attiverà Teachino, qui vedrai materiali didattici e molto altro.",
  "integration.authenticate_untis.description": "Con Teachino puoi preparare le tue lezioni in base al tuo orario didattico WebUntis e trasferire la tua pianificazione nella cartella.",
  "integration.authenticate_digreg.description": "Con Teachino puoi preparare le tue lezioni in base al tuo orario didattico dal Registro Digitale e trasferire la tua pianificazione nella cartella.",
  "integration.authenticate_microsoft.description": "Collega file da OneDrive e pagine da OneNote con Teachino.",
  "integration.authenticate_bip.description": "Collegando Teachino con il BIP consenti l'accesso automatico a Teachino.",
  "integration.authenticate_cgie.description": "Collegando Teachino con il CGIE consenti l'accesso automatico a Teachino e l'attivazione di una licenza gratuita.",
  "integration.settings_connected_with": "Collegato con: {{displayName}}",
  "integration.ical.description": "Importa le voci dell'orario didattico da un feed iCal e collega i nomi delle voci del calendario ai corsi Teachino in questa pagina.",
  "integration.ical.connect_title": "Collega feed iCal",
  "integration.ical.edit_title": "Modifica feed iCal",
  "integration.ical.edit_feed": "Modifica link",
  "integration.ical.save_feed": "Salva feed iCal",
  "integration.ical.modal_description": "Incolla l'URL di sottoscrizione iCal del calendario che desideri mostrare nell'orario didattico.",
  "integration.ical.url_label": "URL iCal",
  "integration.ical.url_placeholder": "https://example.com/calendar.ics",
  "integration.ical.url_required": "Inserisci un URL iCal.",
  "integration.ical.mapping_hint": "Usa esattamente lo stesso nome della voce di calendario per tutte le voci dello stesso corso, in modo che il collegamento del corso funzioni correttamente.",
  "integration.ical.invalid_feed_url": "Impossibile collegare questo feed. Assicurati di aver incollato l'URL di sottoscrizione iCal e non il link della pagina del calendario.",
  "integration.ical.connected_courses.description": "Collega i corsi di Teachino con le voci del calendario presenti nel tuo calendario.",
  "integration.untis.description": "Connetti Teachino con WebUntis per sincronizzare il tuo orario didattico e la cartella. La tua scuola deve attivare l'integrazione in WebUntis. Apri poi WebUntis e clicca su Teachino",
  "integration.edupage.description": "Connetti Teachino con EduPage per importare il tuo orario didattico e collegare le materie EduPage ai tuoi corsi Teachino.",
  "integration.edupage.connect_title": "Collega l'orario didattico EduPage",
  "integration.edupage.edit_title": "Modifica l'orario didattico EduPage",
  "integration.edupage.edit_feed": "Modifica il collegamento EduPage",
  "integration.edupage.save_feed": "Salva l'orario didattico EduPage",
  "integration.edupage.tutorial_step_1": "In EduPage, apri \"Didattica\" → \"Eventi\".",
  "integration.edupage.tutorial_step_2": "In \"Eventi\", seleziona \"Orario didattico\".",
  "integration.edupage.tutorial_step_3": "Seleziona \"Esporta\", quindi \"Attiva Webcal\".",
  "integration.edupage.tutorial_step_4": "Ora viene visualizzato l'URL Webcal. Copialo e incollalo qui sotto.",
  "integration.edupage.tutorial_image_alt": "Finestra di dialogo EduPage per attivare Webcal per l'orario didattico",
  "integration.edupage.url_label": "URL Webcal EduPage",
  "integration.edupage.url_placeholder": "https://la-tua-scuola.edupage.org/webcal?pwd=...",
  "integration.edupage.url_required": "Inserisci il tuo URL Webcal EduPage.",
  "integration.edupage.invalid_feed_url": "Impossibile collegare questo orario didattico EduPage. Verifica di aver incollato l'URL Webcal da EduPage.",
  "integration.edupage.connected_courses.description": "Collega i tuoi corsi Teachino alle materie del tuo orario didattico EduPage.",
  "integration.edupage.external_course": "Materia in EduPage",
  "integration.bip.description": "Per docenti in Austria: Connetti Teachino con il portale educativo.",
  "integration.cgie.description": "Per docenti in Lussemburgo: usa il login IAM del CGIE per utilizzare Teachino gratuitamente.",
  "integration.digreg.description": "Per docenti in Alto Adige: Connetti Teachino con il Registro Digitale per sincronizzare il tuo orario didattico e la cartella. La tua scuola deve attivare l'integrazione nel Registro Digitale.",
  "integration.microsoft.description": "Collega il tuo profilo Microsoft con Teachino per accedere al tuo quaderno OneNote. Puoi collegare singoli team con i corsi in Teachino per accedere ai quaderni di classe.",
  "integration.ical.external_course": "Nome della voce di calendario",
  "integration.teachino.external_course": "Corso in Teachino",
  "integration.untis.external_course": "Lezione in WebUntis",
  "integration.digreg.external_course": "Definizione nel Registro Digitale",
  "integration.microsoft.external_course": "Team in Microsoft Teams",
  "integration.cgie.connect.title": "Registrati su Teachino con IAM",
  "integration.cgie.connect.description": "Nell'ambito del IA Kompass, Teachino è disponibile gratuitamente per tutti gli docenti in Lussemburgo.",
  "integration.cgie.connect.start": "Inizia con Teachino",
  "integration.cgie.connect.login": "Utilizzo già Teachino",
  "integration.cgie.connect.terms_prefix": "Si applicano i",
  "integration.cgie.connect.terms_suffix": "di Teachino nell’ambito della collaborazione tra Teachino e lo SCRIPT. I dati vengono eliminati dopo 24 mesi di inattività.",
  "integration.connect_course.title": "Collega lezione con Teachino",
  "integration.connect_course.description": "Quale corso Teachino desideri collegare con \"{{externalCourseName}}\"?",
  "integration.connect_course.ignore": "{{courseName}} non mostrare più",
  "integration.connect_course.ignore_confirm": "Le lezioni di {{courseName}} spariranno anche dal tuo orario didattico. Puoi annullare l’operazione in qualsiasi momento in «Modifica orario didattico».",
  "integration.connect_course.select": "Scegli corso",
  "integration.connect_course.successful_connect": "Corso collegato!",
  "integration.connect_course.successful_ignore": "Corso nascosto!",
  "integration.connect_course.ignore_title": "Il corso è nascosto.",
  "integration.connect_course.ignore_restore": "{{courseName}} mostra di nuovo",
  "integration.course_connected.description": "{{externalCourseName}} è collegato con {{internalCourseName}} in Teachino.",
  "integration.connect_course.create": "Crea {{courseName}}",
  "integration.connect_course.header": "Come vuoi che appaia {{courseName}} in Teachino?",
  "integration.connect_course.new": "Come nuovo corso",
  "integration.connect_course.connect": "o collegato a un corso esistente",
  "integration.settings.connected_courses.description": "Collega i tuoi corsi da Teachino per sincronizzare i dati.",
  "integration.settings.course_ignored": "Nascosto",
  "integration.settings.remove_course_title": "Rimuovi collegamento",
  "integration.settings.course_not_connected": "Non collegato",
  "integration.settings.course_connect": "Collega corso",
  "integration.export_classregister.title": "Scrivi i contenuti didattici nella cartella",
  "integration.export_classregister.send_to_classregister": "Scrivere nella cartella",
  "integration.export_classregister.send_to_classregister_successfull": "Cartella compilata",
  "integration.export_classregister": "Cartella",
  "integration.export_classregister.copy": "Copia testo",
  "integration.export_classregister.copy_success_title": "Testo copiato negli appunti",
  "onboarding_tutorial.enter_courses_description_1": "Crea un corso per ogni materia e classe che insegni.\nSe insegni due materie in una classe, crea due corsi.",
  "onboarding_tutorial.enter_courses_more_lines": "aggiungi altro corso",
  "onboarding_tutorial.enter_courses_button": "Inizia con Teachino",
  "onboarding_tutorial.enter_courses_extra_note": "Puoi creare altri corsi successivamente e modificare i colori",
  "onboarding_tutorial.enter_courses_placeholder_1": "Geografia",
  "onboarding_tutorial.enter_courses_placeholder_2": "Storia",
  "onboarding_tutorial.enter_courses_placeholder_3": "Storia",
  "feature_course.onboarding.subject.other_lesson_language_label": "Lingua della lezione",
  "feature_course.onboarding.subject.other_lesson_language_placeholder": "Inserisci la lingua della lezione",
  "feature_course.onboarding.subject.default_course_language": "Italiano",
  "feature_course.onboarding.integration.action.import_courses": "Importa corsi",
  "feature_course.onboarding.integration.connecting.title": "Importazione dei corsi in corso …",
  "feature_course.onboarding.integration.connecting.progress": "{{done}} corsi su {{total}} elaborati",
  "feature_course.onboarding.integration.partial_error": "Alcuni corsi non sono stati collegati automaticamente. Puoi collegarli in qualsiasi momento dalla pagina dei corsi.",
  "item_detail.teachino_ai_questions": "Domande",
  "item_detail.teachino_ai_questions.reproduction.title": "Riproduzione",
  "item_detail.teachino_ai_questions.reproduction.description": "Riproduzione di concetti",
  "item_detail.teachino_ai_questions.reorganisation.title": "Riorganizzazione",
  "item_detail.teachino_ai_questions.reorganisation.description": "Spiegazioni, elaborazione e organizzazione autonoma",
  "item_detail.teachino_ai_questions.reflection.title": "Riflessione",
  "item_detail.teachino_ai_questions.reflection.description": "Interpretazione e valutazione, riconoscere relazioni, risolvere problemi",
  "ai_setting.language": "In che lingua l'IA deve generare risultati?",
  "ai_setting.description": "Queste impostazioni influenzano i suggerimenti dell’IA di Teachino. L’IA di Teachino usa queste impostazioni e i materiali.",
  "ai_setting.curriculum_other": "Inserisci il tuo curriculum",
  "ai_setting.age": "Quanti anni hanno alunni/e per cui vengono utilizzati i risultati IA?",
  "ai_settings.age_placeholder": "Età di alunni/e in anni",
  "ai_setting.subject": "Specificare la materia con precisione",
  "ai_setting.curriculum": "Programma scolastico / Curriculum",
  "ai_setting.curriculum_country": "Paese",
  "ai_setting.curriculum_state": "Regione",
  "ai_setting.curriculum_name": "Tipo di scuola",
  "ai_setting.curriculum_description": "Copia il programma di studi, il curriculum principale o scolastico nel campo di testo. L'IA di Teachino si baserà su questo. Il testo può avere fino a 18.000 caratteri e dovrebbe contenere solo le aree pertinenti per anno/materia.",
  "ai_setting.curriculum_placeholder": "Puoi incollare tutto il testo non formattato qui",
  "ai_setting.curriculum_maxlength": "Il programma / Curriculum può essere lungo al massimo {{max_length}} caratteri. Testi più lunghi verranno tagliati.",
  "ai_setting.curriculum.school_type": "Tipo di scuola",
  "ai_setting.curriculum.subject": "Materia",
  "ai_setting.curriculum.class_level": "Classe / Livello",
  "ai_setting.curriculum.disclaimer": "<strong>Il tuo programma non è disponibile?</strong> Nessun problema! Scegli <strong>\"inserisci il tuo curriculum\"</strong>, copia il tuo programma e inseriscilo nel campo di testo appropriato. <strong>Hai bisogno di aiuto o hai altre domande?</strong> Visita la nostra <a class=\"underline text-primary-500\" href=\"https://www.teachino.io/hilfe#faq\" target=\"_blank\">pagina di aiuto</a>.",
  "ai_setting.checkmarks.age": "Età di alunni/e",
  "ai_setting.checkmarks.subject": "Materia",
  "ai_setting.checkmarks.language": "Lingua del corso",
  "ai_setting.checkmarks.curriculum_available": "Curriculum disponibile",
  "ai_setting.cta_settings.description": "Non ci sono impostazioni IA per questo corso. Inserisci età, materia, curriculum, ... per migliorare i risultati.",
  "ai_setting.cta_settings.button": "Inserisci informazioni",
  "ai_setting.cta_curriculum.description": "Per risultati ancora migliori, carica il tuo curriculum.",
  "ai_setting.cta_curriculum.button": "Inserisci curriculum",
  "ai.error.cta": "Ricomincia",
  "ai.name": "Thena – La tua assistenza IA personale",
  "ai.assistant.title": "Assistente IA",
  "material.ai.create.quick_actions_label": "Genera con l’IA:",
  "ai.assistant.new_chat": "Nuova chat",
  "ai.assistant.open": "Apri la chat",
  "ai.assistant.launcher.tooltip": "Apri l'assistente IA",
  "ai.assistant.period_context.date_only": "L'insegnante sta visualizzando la lezione del {{formattedDate}}. I nuovi materiali creati qui devono essere pianificati per il {{planningTargetDate}}.",
  "ai.assistant.period_context.pill_date_only": "{{formattedDate}}",
  "ai.assistant.composer.remove_period_context": "Rimuovi contesto lezione",
  "ai.assistant.generated_material.open_conversation": "Apri nell'assistente",
  "ai.assistant.generated_material.open_when_ready": "Il materiale è in fase di generazione da parte dell’IA. Non appena sarà pronto, potrai aprirlo.",
  "ai.assistant.generated_material.created_in_folder": "Creato nella cartella {{folderName}}",
  "ai.assistant.generated_material.target_folder_label": "Cartella: {{folderName}}",
  "ai.assistant.generated_material.prompt_label": "Prompt di generazione utilizzato",
  "ai.material.approval.tag_create": "Verifica materiale",
  "ai.material.approval.tag_rework": "Rielaborazione da revisionare",
  "ai.material.approval.banner_create_title": "L'IA ha creato questo materiale",
  "ai.material.approval.banner_create_description": "Controlla il contenuto e approva la modifica, oppure modifica il materiale.",
  "ai.material.approval.banner_rework_title": "L'IA ha aggiornato questo materiale",
  "ai.material.approval.banner_rework_description": "Controlla le modifiche e approvale, oppure modifica il materiale.",
  "ai.material.approval.approve_button": "Verificato",
  "ai.assistant.close": "Chiudi",
  "ai.assistant.back_to_start": "Torna all'inizio",
  "ai.assistant.back_to_chat": "Torna alla chat",
  "ai.assistant.mode_fullscreen": "Schermo intero",
  "ai.assistant.mode_sidebar": "Barra laterale",
  "ai.assistant.mode_floating": "Flottante",
  "ai.assistant.display_mode": "Visualizzazione chat",
  "ai.assistant.expand": "Espandi",
  "ai.assistant.collapse": "Riduci",
  "ai.assistant.history.title": "Cronologia chat",
  "ai.assistant.history.recent": "Chat recenti",
  "ai.assistant.history.conversation": "Chat",
  "ai.assistant.history.delete": "Elimina conversazione",
  "ai.assistant.history.show": "Mostra tutto",
  "ai.assistant.history.load_more": "Mostra altro",
  "ai.assistant.history.loading_recent": "Caricamento chat recenti…",
  "ai.assistant.history.just_now": "Adesso",
  "ai.assistant.history.minutes_ago": "{{count}} min fa",
  "ai.assistant.history.hours_ago": "{{count}} h fa",
  "ai.assistant.history.days_ago": "{{count}} g fa",
  "ai.assistant.history.needs_confirmation": "Conferma richiesta",
  "ai.assistant.history.running": "Risposta in corso",
  "ai.assistant.history.unread": "Nuovi messaggi non letti",
  "ai.assistant.suggestions.title": "Suggerimenti",
  "ai.assistant.suggestion.lesson.title": "Pianifica una lezione",
  "ai.assistant.suggestion.lesson.prompt": "Aiutami a pianificare la prossima lezione per questo corso.",
  "ai.assistant.suggestion.material.title": "Crea materiale",
  "ai.assistant.suggestion.material.prompt": "Crea una scheda didattica differenziata per la prossima lezione sul tema: ",
  "ai.assistant.suggestion.material.question": "Su quale tema deve vertere il materiale?",
  "ai.assistant.suggestion.material.suggest_prompt": "Crea una scheda didattica differenziata per la prossima lezione.",
  "ai.assistant.suggestion.support.title": "Supporta gli studenti",
  "ai.assistant.suggestion.support.prompt": "Suggerisci come supportare gli studenti in difficoltà.",
  "ai.assistant.suggestion.reflect.title": "Rifletti sulla lezione",
  "ai.assistant.suggestion.reflect.prompt": "Aiutami a riflettere sulla lezione di oggi e a pianificare i prossimi passi.",
  "ai.assistant.messages.load_earlier": "Carica i messaggi precedenti",
  "ai.assistant.message.copy": "Copia",
  "ai.assistant.message.helpful": "Utile",
  "ai.assistant.message.not_helpful": "Non utile",
  "ai.assistant.message.feedback_received": "Grazie per il tuo feedback.",
  "ai.assistant.message.sending": "Invio in corso",
  "ai.assistant.message.failed": "Invio non riuscito. Il testo è stato ripristinato.",
  "ai.assistant.message.show_more": "Mostra di più",
  "ai.assistant.message.show_less": "Mostra meno",
  "ai.assistant.message.link_redirect_limit": "Non siamo riusciti ad aprire questo link perché contiene troppi reindirizzamenti. Usa l’URL diretto della pagina di destinazione oppure carica il documento.",
  "ai.assistant.attachment.unreadable": "Impossibile leggere il file",
  "ai.assistant.attachment.unreadable_hint": "Il contenuto di questo file non è stato estratto, quindi l'assistente IA non può utilizzarlo. Incolla il testo direttamente oppure carica di nuovo il file come PDF o immagine.",
  "ai.assistant.composer.add_source": "Aggiungi fonte",
  "ai.assistant.composer.attachment_limit": "Puoi aggiungere fino a {{count}} fonti per messaggio.",
  "ai.assistant.composer.remove_material_context": "Rimuovi il contesto del materiale",
  "ai.assistant.composer.placeholder": "Chiedi all'assistente IA…",
  "ai.assistant.course_selection.section_title": "Corsi di quest'anno scolastico",
  "ai.assistant.course_selection.loading": "Caricamento corsi…",
  "ai.assistant.course_selection.error": "Impossibile caricare i corsi",
  "ai.assistant.course_selection.empty": "Nessun corso disponibile",
  "ai.assistant.course_selection.select_course": "Seleziona un corso",
  "ai.assistant.course_selection.continue": "Seleziona un corso per continuare",
  "ai.assistant.course_selection.setup_required": "Configurazione necessaria",
  "ai.assistant.course_selection.owner_setup_required": "La persona responsabile del corso deve completare le impostazioni",
  "ai.assistant.course_setup.banner.description": "Aggiungi materia e classe per risultati migliori",
  "ai.assistant.course_setup.banner.action": "Completa le impostazioni IA",
  "ai.assistant.course_selection.selected": "Corso selezionato",
  "ai.assistant.user_selection.other": "Altro",
  "ai.assistant.user_selection.selected": "Selezionato",
  "ai.assistant.user_selection.other_placeholder": "Inserisci la tua risposta…",
  "ai.assistant.user_selection.submit": "Invia risposta",
  "ai.assistant.topic_question.suggest": "Mostra proposte",
  "ai.assistant.topic_question.subject_label": "Il mio tema",
  "ai.assistant.topic_question.subject_placeholder": "Inserisci un tema…",
  "ai.assistant.topic_question.submit": "Invia il tema",
  "ai.assistant.composer.send": "Invia messaggio",
  "ai.assistant.run.stop": "Interrompi risposta",
  "ai.assistant.stream.connecting": "Connessione in corso",
  "ai.assistant.stream.reconnecting": "Riconnessione in corso",
  "ai.assistant.tool.working": "Elaborazione in corso…",
  "ai.assistant.tool.search_images": "Ricerca di immagini adatte…",
  "ai.assistant.tool.read_product_guidance": "Verifica delle azioni disponibili…",
  "ai.assistant.tool.search_help_center": "Ricerca nel centro assistenza…",
  "ai.assistant.tool.read_help_article": "Lettura dell’articolo di assistenza…",
  "ai.assistant.tool.search_web": "Ricerca sul Web…",
  "ai.assistant.tool.search_wikipedia": "Ricerca su Wikipedia…",
  "ai.assistant.tool.search_youtube": "Ricerca su YouTube…",
  "ai.assistant.tool.load_youtube_transcript": "Lettura della trascrizione video…",
  "ai.assistant.tool.load_webpage": "Lettura della pagina Web…",
  "ai.assistant.tool.list_courses": "Caricamento dei corsi…",
  "ai.assistant.tool.list_course_content": "Lettura dei contenuti del corso…",
  "ai.assistant.tool.search_course_materials": "Ricerca nei materiali del corso…",
  "ai.assistant.tool.load_materials": "Caricamento dei materiali…",
  "ai.assistant.tool.read_course_timetable": "Consultazione dell’orario…",
  "ai.assistant.tool.read_course_planning": "Consultazione della pianificazione…",
  "ai.assistant.tool.read_students": "Caricamento degli studenti…",
  "ai.assistant.tool.read_student_documentation": "Lettura della documentazione degli studenti…",
  "ai.assistant.tool.create_course_materials": "Creazione dei materiali…",
  "ai.assistant.tool.edit_course_material": "Rielaborazione del materiale…",
  "ai.assistant.tool.convert_worksheet": "Conversione della scheda…",
  "ai.assistant.tool.create_course_folders": "Creazione delle cartelle…",
  "ai.assistant.tool.create_todo": "Creazione dell’attività…",
  "ai.assistant.tool.mark_todos_done": "Completamento delle attività…",
  "ai.assistant.tool.add_lesson_note": "Aggiunta della nota di lezione…",
  "ai.assistant.tool.add_period_tags": "Aggiunta dei tag della lezione…",
  "ai.assistant.tool.create_student_documentation": "Creazione della documentazione dello studente…",
  "ai.assistant.tool.set_material_visibility": "Aggiornamento della visibilità del materiale…",
  "ai.assistant.tool.plan_materials_for_date": "Pianificazione dei materiali…",
  "ai.assistant.tool.remove_materials_from_date": "Rimozione dei materiali dalla data…",
  "ai.assistant.tool.move_course_content": "Spostamento del contenuto del corso…",
  "ai.assistant.tool.copy_course_content": "Copia del contenuto del corso…",
  "ai.assistant.tool.request_user_selection": "Preparazione delle opzioni…",
  "ai.assistant.tool.request_course_selection": "Preparazione della selezione del corso…",
  "ai.assistant.action.default_title": "Azione",
  "ai.assistant.action.discarded": "Scartata",
  "ai.assistant.error.response": "Si è verificato un errore. Riprova.",
  "ai.assistant.context.current_course": "Corso attuale",
  "ai.assistant.context.current_folder": "Cartella attuale",
  "ai.assistant.context.current_material": "Materiale attuale",
  "ai.assistant.context.course": "Corso",
  "ai.assistant.context.material": "Materiale",
  "ai.assistant.job.cancel": "Annulla la generazione",
  "ai.assistant.job.cancel_all": "Annulla tutto",
  "ai.assistant.job.review": "Rivedi",
  "ai.assistant.job.stage.create.planning": "Verifica e pianificazione della richiesta",
  "ai.assistant.job.stage.create.creating": "Creazione dei contenuti",
  "ai.assistant.job.stage.create.preparing": "Creazione delle immagini e preparazione del materiale",
  "ai.assistant.job.stage.rework.planning": "Verifica e pianificazione della revisione",
  "ai.assistant.job.stage.rework.creating": "Revisione del materiale",
  "ai.assistant.job.stage.rework.preparing": "Integrazione e preparazione delle modifiche",
  "ai.assistant.job.stage.conversion.planning": "Lettura della scheda di lavoro",
  "ai.assistant.job.stage.conversion.creating": "Conversione degli esercizi",
  "ai.assistant.job.stage.conversion.preparing": "Preparazione del materiale",
  "ai.assistant.job.stage.saving": "Salvataggio del materiale",
  "ai.assistant.job.progress.queued": "In coda",
  "ai.assistant.job.progress.step": "Passaggio {{step}} di {{stepCount}} · {{stage}}",
  "ai.assistant.job.progress.elapsed": "in corso da {{duration}}",
  "ai.assistant.job.progress.patience_hint": "Di solito servono 1–2 minuti. Puoi continuare a lavorare: ti avvisiamo appena il materiale è pronto.",
  "ai.assistant.job.ready.image_omissions": "Pronto – avviso sulle immagini",
  "ai.assistant.job.image_omissions": "Non è stato possibile inserire un’immagine. Il materiale è disponibile.",
  "ai.assistant.job.image_required_missing": "Manca almeno un’immagine richiesta. Il materiale è disponibile.",
  "ai.assistant.job.image_optional_details": "Immagine aggiuntiva omessa – dettagli della ricerca",
  "ai.assistant.job.image_details": "Perché manca l’immagine?",
  "ai.assistant.job.image_reason.no_suitable_candidate": "La ricerca non ha fornito un’immagine adatta e verificata.",
  "ai.assistant.job.image_reason.search_unavailable": "Il servizio immagini non era disponibile durante questa ricerca.",
  "ai.assistant.job.image_reason.verification_unavailable": "Non è stato possibile verificare in modo affidabile l’idoneità dell’immagine.",
  "ai.assistant.job.image_reason.generation_failed": "Non è stato possibile creare o salvare correttamente l’immagine.",
  "ai.assistant.job.image_reason.omitted_from_output": "Un’immagine prevista non è stata inclusa nel materiale finale.",
  "ai.assistant.job.image_reason.not_attempted": "La generazione si è conclusa senza l’immagine richiesta; non è stato registrato alcun tentativo.",
  "ai.assistant.job.ready.title": "Pronto da aprire",
  "ai.assistant.job.failed.title": "Creazione non riuscita",
  "ai.assistant.job.ready.toast": "«{{title}}» è pronto",
  "ai.assistant.job.ready.toast_many": "{{count}} materiali sono pronti",
  "ai.assistant.job.ready.badge_aria_zero": "Nessun materiale completato nell’assistente IA",
  "ai.assistant.job.ready.badge_aria_one": "1 materiale completato nell’assistente IA",
  "ai.assistant.job.ready.badge_aria_many": "{{number}} materiali completati nell’assistente IA",
  "ai.assistant.job.open_material": "Apri materiale",
  "ai.assistant.job.open_preview": "Apri l’anteprima del materiale",
  "ai.personification": "Thena – La tua assistenza IA",
  "ai.you": "Tu",
  "ai.prompt.placeholder": "Come posso aiutarti oggi?",
  "ai.prompt.continue": "Scrivi la tua risposta...",
  "ai.prompt.hint.1": "Traduci il risultato",
  "ai.prompt.hint.1_prompt": "Traduci il risultato in ",
  "ai.prompt.hint.2": "Accorcia il risultato",
  "ai.prompt.hint.2_prompt": "Accorcia il risultato",
  "ai.prompt.hint.3": "Estendi il risultato",
  "ai.prompt.hint.3_prompt": "Estendi il risultato",
  "ai.prompt.hint.4": "Semplifica il risultato",
  "ai.prompt.hint.4_prompt": "Semplifica il risultato al livello A2",
  "ai.prompt.hint.5": "Cos'altro potrei fare?",
  "ai.prompt.hint.5_prompt": "Fai cinque proposte di brevi prompt IA per elaborare il risultato in testo.",
  "ai.tasks.show_more": "mostra di più",
  "ai.tasks.show_less": "Mostra meno",
  "ai.disclaimer": "L'IA può commettere errori. Evita di inserire dati personali.",
  "ai.disclaimer_students": "Questa chat è gestita da Intelligenza Artificiale. Le risposte sono generate dall'IA e possono essere imprecise o errate. Mantieni un atteggiamento critico e verifica le informazioni se necessario. Non condividere dati personali. Buon chat!",
  "ai.area_youtube_error.description": "Thena non è riuscito a leggere i sottotitoli. Per favore, copia i sottotitoli nel campo di testo sottostante affinché Thena possa generare materiali.",
  "ai.area_youtube.title": "IA per Video",
  "ai.area_youtube.description": "Thena legge i sottotitoli dei video e crea materiali collegati. Inserisci semplicemente il link al video. Thena non può ancora leggere i video senza sottotitoli.",
  "ai.area_youtube.label": "Link al video di Youtube",
  "ai.area_youtube.error": "Inserisci un link valido a un video di Youtube.",
  "ai.area_youtube.iframe_error": "Errore durante la visualizzazione del video",
  "ai.area_docs.title": "IA per documenti",
  "ai.area_docs.description": "Thena legge testi nei documenti e crea materiali correlati.",
  "ai.area_docs.types": "File supportati:",
  "ai.area_websites.title": "IA per siti web",
  "ai.area_websites.description": "Thena legge il testo sul sito web e crea materiali correlati.",
  "ai.area_text.title": "IA per testi",
  "ai.area_text.description": "Thena legge il testo inserito e crea materiali correlati. Puoi anche caricare sottotitoli di un video come testo.",
  "ai.area_images.title": "IA per immagini",
  "ai.area_images.description": "Thena riconosce i testi nelle foto, li legge e crea materiali correlati.",
  "ai.course_settings_age_missing.before": "(Suggerimento: puoi inserire l'età dei tuoi studenti nelle",
  "ai.course_settings_age_missing.label": "impostazioni del corso",
  "ai.course_settings_age_missing.after": ", per salvarlo per le future conversazioni. Più dettagli ho sul tuo corso, migliori saranno le mie risposte.) ",
  "onboarding_tutorial.enter_courses_header": "Ultimo passo: crea i corsi",
  "library.title": "Materiali e cartelle",
  "library.new_items": "Nuovi Materiali",
  "library.search_hint": "Inserisci almeno 3 caratteri",
  "library.add_dates": "Data di inizio e fine",
  "library.add_dates_placeholder": "Seleziona data di inizio e fine",
  "library.remove_dates": "Rimuovi intervallo",
  "library.remove_topic": "Eliminare \"{{topic}}\"?",
  "library.remove_course_topic": "Rimuovere \"{{topic}}\" dal corso?",
  "library.remove_item": "Eliminare \"{{item}}\"?",
  "library.remove_topics": "Eliminare {{number}} cartelle?",
  "library.remove_course_topics": "Rimuovere {{number}} cartelle dal corso?",
  "library.remove_items": "Eliminare {{number}} materiali?",
  "library.remove_topic.confirm": "Eliminare {{topic}}",
  "library.remove_course_topic.confirm": "Eliminare {{topic}} dal corso",
  "library.remove_topics.confirm": "Eliminare cartelle",
  "library.remove_course_topics.confirm": "Rimuovere cartelle dal corso",
  "library.remove_item.confirm": "Eliminare {{item}}",
  "library.remove_items.confirm": "Eliminare {{number}} materiali",
  "library.remove_topic_pre": "Vuoi",
  "library.remove_course_topic_pre": "Vuoi",
  "library.remove_topic_post": "cancellare permanentemente? La cartella e tutti i materiali contenuti saranno eliminati irreversibilmente.",
  "library.remove_course_topic_post": "rimuovere dal corso? Tutti i dati di pianificazione andranno persi.",
  "library.remove_item_pre": "Vuoi",
  "library.remove_item_post": "cancellare definitivamente? I materiali saranno eliminati in modo irreversibile.",
  "library.remove_topics.description": "Vuoi eliminare {{number}} cartelle definitivamente? Le cartelle e tutti i materiali contenuti saranno eliminati in modo irreversibile.",
  "library.remove_course_topics.description": "Vuoi rimuovere {{number}} cartelle dal corso?",
  "library.remove_items.description": "Vuoi eliminare in modo definitivo {{number}} materiali? I materiali saranno cancellati in modo irreversibile.",
  "library.remove_topic_force_pre": "La cartella ",
  "library.remove_item_force_pre": "Il materiale ",
  "library.remove_topic_force_post": "è utilizzato nei corsi (aperti) ",
  "library.remove_item_force_post": "è utilizzato nei corsi (aperti) ",
  "library.remove_topic_force_end": ". Vuoi eliminarla insieme a tutti i materiali contenuti e anche rimuovere tutte le pianificazioni correlate in passato e futuro?",
  "library.remove_item_force_end": ". Vuoi eliminare il materiale e rimuovere anche tutte le pianificazioni correlate in passato e futuro?",
  "library.remove_topics_force_pre": "Le cartelle sono utilizzate nei corsi (aperti) ",
  "library.remove_items_force_pre": "I materiali sono utilizzati nei corsi (aperti) ",
  "library.remove_topics_force_end": ". Vuoi eliminarli insieme a tutti i materiali contenuti e anche rimuovere tutte le pianificazioni correlate in passato e futuro?",
  "library.remove_items_force_end": ". Vuoi eliminare i materiali e rimuovere anche tutte le pianificazioni correlate in passato e futuro?",
  "library.remove_item.success_one": "Materiale eliminato",
  "library.remove_item.success_many": "Materiali eliminati",
  "library.topics_autocomplete.placeholder": "Cerca cartella",
  "library.topics_autocomplete.current_course": "Cartelle nel corso",
  "library.topics_autocomplete.all_courses": "Tutte le cartelle",
  "library.topics_autocomplete.create_description": "In quale cartella dovrebbe essere creato il materiale?",
  "library.topics_autocomplete.new_topic": "Nuova cartella",
  "library.topics_autocomplete.back": "Torna alla lista",
  "library.duplicate_items.duplicate_one_description": "Duplica {{item}}",
  "library.duplicate_items.duplicate_many_description": "Duplica {{number}} materiali",
  "library.duplicate_items.confirm": "Duplica nel tema {{topic}}",
  "library.duplicate_items.success": "Materiale duplicato",
  "library.move_items.move_one_description": "Sposta {{item}}",
  "library.move_items.move_many_description": "Sposta {{number}} materiali",
  "library.move_items.confirm": "Sposta nel tema {{topic}}",
  "library.move_items.success": "Materiale spostato",
  "library.add_topic_to_courses": "Aggiungi cartella ai corsi",
  "library.add_topic_to_courses.link": "Aggiungi cartella a più corsi",
  "presentation.title": "Modalità presentazione",
  "presentation.empty.title": "Nessun materiale pianificato",
  "presentation.empty.description": "Una volta pianificata la lezione, puoi presentarla qui su un proiettore o una lavagna digitale. Decidi tu quali sezioni mostrare ad alunni/e.",
  "presentation.empty.material": "Questo materiale è vuoto.",
  "create_item.new_item": "Nuovo materiale",
  "create_item.search_topic": "Scegli cartella",
  "create_item.title_label": "Nome del materiale",
  "upgrade.feature_discovered.dialog_title": "Upgrade necessario",
  "upgrade.feature_discovered.title": "Ottieni tutte le funzionalità",
  "upgrade.feature_discovered.description": "Sottoscrivi una licenza ora e continua a lavorare senza limiti.",
  "upgrade.feature_discovered.cta": "Scopri di più",
  "upgrade.soft_paywall.grace_days_left": "Altri {{days}} giorni di accesso gratuito.",
  "upgrade.soft_paywall.trial_days_left": "Altri {{days}} giorni di prova.",
  "upgrade.feature.ai.perk.collaboration": "Collaborazione nei gruppi disciplinari, teamteaching e sostituzioni",
  "upgrade.feature.storage.title": "Spazio di archiviazione illimitato",
  "upgrade.feature.presentation.title": "Modalità presentazione",
  "upgrade.feature.presentation.description": "Presenta i tuoi materiali in classe sulla lavagna digitale o tramite proiettore.",
  "upgrade.feature.student_evaluation.title": "Valutazione e feedback",
  "upgrade.feature.student_evaluation.description": "Visualizza i risultati per alunno/a e per domanda e fornisci feedback individuali sulle consegne.",
  "upgrade.feature.ipi.title": "Materiali con IA senza limiti",
  "upgrade.feature.ipi.description": "Genera schede interattive, compiti e idee per le lezioni – senza limiti.",
  "upgrade.feature.integration.description": "Collega orario didattico e cartella e mantienili sempre aggiornati.",
  "upgrade.feature.school.perk.training": "Assistenza e formazione del personale docente (webinar gratuiti, supporto individuale su richiesta)",
  "upgrade.feature.school.perk.student_accounts": "Account alunni/e personali con codice di accesso individuale",
  "upgrade.feature.school.perk.cost_relief": "Alleviamento dei costi per gli docenti",
  "upgrade.school.cta": "Richiedi un'offerta",
  "upgrade.buy.cta": "Sottoscrivi licenza Pro",
  "upgrade.buy.trainee.discount": "🌱 I tirocinanti ricevono uno sconto sulla <strong>Licenza per docenti</strong>",
  "upgrade.buy.trainee.cta_two_years": "50% per 2 anni",
  "upgrade.buy.trainee.cta_one_year": "25% per 1 anno",
  "upgrade.buy.payment_cycle.option_multiple": "{{months}} mesi",
  "upgrade.buy.payment_cycle.option_one": "1 mese",
  "upgrade.buy.payment_cycle.price": "{{price}} / mese",
  "upgrade.buy.tag.loved": "Il più amato",
  "upgrade.buy.tag.cheapest": "Risparmia {{percent}}%",
  "upgrade.discover.cta_school": "Richiedi una licenza scolastica",
  "upgrade.discover.cta_school_extend": "Estendi licenza scolastica",
  "upgrade.license_page.title_0": "Le tue licenze attuali",
  "upgrade.license_page.title_1": "La tua licenza attuale",
  "upgrade.license_page.title_many": "Le tue licenze attuali",
  "upgrade.license_page.upgrade.personal_licenses": "Licenza personale",
  "upgrade.license_page.upgrade.tenant_licenses": "Licenza scolastica",
  "upgrade.license_page.license_started_at": "Iniziata il:",
  "upgrade.license_page.license_renews_at": "Rinnovo il:",
  "upgrade.license_page.license_expires_at": "Scade il:",
  "upgrade.license_page.license_expired_at": "Scaduta il:",
  "upgrade.license_page.license_id": "Numero di licenza:",
  "upgrade.license_page.pro_offer_title": "Licenza per docenti",
  "upgrade.license_page.pro_offer_subtitle": "Tutto ciò che ti serve per le lezioni – senza limiti, dalla pianificazione al feedback.",
  "upgrade.license_page.features": "Funzioni incluse",
  "upgrade.license_page.manage": "Gestisci",
  "upgrade.license_page.upgrade_school.title": "Licenza per scuole",
  "upgrade.license_page.upgrade_school.subtitle": "Un sistema condiviso per la didattica digitale in tutta la scuola",
  "upgrade.license_page.free_license_label": "Licenza gratuita",
  "upgrade.license_page.dpa_signed": "DPA firmato",
  "upgrade.license_page.student_data_can_be_managed": "I dati di alunni/e possono essere gestiti",
  "upgrade.license_page.trainee_discount": "🌱 I tirocinanti ricevono uno sconto sulla <strong>Licenza per docenti</strong>",
  "upgrade.license_page.legal_billing": "Il tuo abbonamento si rinnova automaticamente per la durata scelta. Cancellazione fino a 24 ore prima, con effetto alla fine del periodo. <a href=\"/legal/terms\" target=\"_blank\" class=\"underline\">Dettagli nelle condizioni d'uso</a>",
  "upgrade.license_page.school_perk_pro": "Tutto ciò che include la Licenza per docenti per 5 o più docenti",
  "upgrade.feature.files_unlimited": "Spazio di archiviazione illimitato (fino a 50 MB per file)",
  "upgrade.feature.files_restricted": "Spazio di archiviazione di 250 MB",
  "upgrade.feature.daily_changes": "Modifiche giornaliere nell'orario didattico (interruzioni, sostituzioni, vacanze, appuntamenti personali, ...)",
  "upgrade.feature.collaboration_teamteaching": "Teamteaching nei corsi",
  "upgrade.feature.collaboration_course_templates": "Crea e condividi raccolte",
  "upgrade.feature.collaboration_substitutions": "Condividi materiali e piani con le sostituzioni",
  "upgrade.feature.student_access": "Accesso per alunni/e",
  "upgrade.feature.ai_basic": "Suggerimenti IA di base",
  "upgrade.feature.ai_advanced": "Suggerimenti IA avanzati basati su materiali e curriculum/piano scolastico",
  "upgrade.feature.integration_timetable": "Integrazione con orario didattico e cartella",
  "upgrade.feature.presentation": "Modalità presentazione",
  "upgrade.feature.ai_curriculum_title": "Risultati più precisi con riferimento al curriculum",
  "upgrade.feature.ai_curriculum_description": "Con una licenza Pro o una licenza scolastica, puoi caricare un curriculum scolastico o scegliere tra piani di studio predefiniti. Questo renderà i risultati IA più precisi e di alta qualità.",
  "upgrade.plan.teacher_pro": "Insegnante Pro",
  "upgrade.plan.teachino_school": "Licenza per scuole",
  "upgrade.plan.cgie_pro": "Licenza come parte del IA-Kompass del Script.",
  "upgrade.plan.teacher_free": "Gratuita",
  "upgrade.plan.teacher_free_light": "Gratuita",
  "upgrade.plan.school_dpa_only": "DPA firmato",
  "upgrade.plan.type.friends": "Amici & Famiglia di Teachino",
  "upgrade.plan.teachino_school_complete": "Licenza per scuole incl. pacchetto IA",
  "upgrade.plan.teachino_school_trial": "Licenza per scuole - Licenza di prova",
  "upgrade.plan.teachino_school_expired": "Licenza per scuole - Licenza scaduta",
  "upgrade.plan.teachino_school_suedtirol": "Teachino Scuola Alto Adige",
  "upgrade.plan.teachino_pro_ai": "Insegnante Pro incl. pacchetto IA",
  "upgrade.plan.teachino_school_complete_trial": "Licenza per scuole incl. pacchetto IA",
  "upgrade.plan.teacher_pro_trial": "Licenza per docenti",
  "upgrade.plan.teacher_pro_beta": "Amici & Famiglia di Teachino",
  "upgrade.plan.type.paid": "Pagata",
  "upgrade.plan.type.free": "Gratuita",
  "upgrade.plan.type.trial": "Prova gratuita",
  "upgrade.plan.type.expired": "Licenza scaduta",
  "upgrade.upgrade_required.title": "Aggiornamento necessario!",
  "upgrade.upgrade_required.description": "Questa funzione è disponibile solo con la Licenza per docenti.",
  "upgrade.upgrade_required.description_2": "Aggiorna ora e goditi tutte le funzionalità!",
  "upgrade.page.pricing_heading": "Scegli la durata",
  "upgrade.usp.3": "Appuntamenti personali, To-do & vacanze",
  "upgrade.feature.personal_planning.description": "Gestisci appuntamenti personali, to-do e vacanze nella tua pianificazione.",
  "upgrade.page.feature.storage.description": "Spazio di archiviazione illimitato per tutti i tuoi materiali didattici.",
  "upgrade.page.feature.student_share.description": "Condividi l'accesso a Teachino con alunni/e tramite link o codice QR.",
  "upgrade.page.feature.class_register.description": "Trasferisci i contenuti didattici pianificati direttamente nella cartella (WebUntis/Registro digitale).",
  "upgrade.usp.4": "Integrazione con WebUntis",
  "upgrade.plan.cta": "Aggiorna ora",
  "difusion.teacher_dashboard.title": "Dashboard insegnante",
  "difusion.teacher_dashboard.select_class": "Seleziona una classe",
  "difusion.teacher_dashboard.students": "Alunni/e",
  "difusion.teacher_dashboard.reload": "Ricarica",
  "difusion.teacher_dashboard.export_csv": "Esporta CSV",
  "difusion.teacher_dashboard.try_leo": "Prova LEO",
  "difusion.teacher_dashboard.loading_classes": "Caricamento classi…",
  "difusion.teacher_dashboard.loading_students": "Caricamento alunni/e…",
  "difusion.teacher_dashboard.error": "Errore",
  "difusion.teacher_dashboard.invalid_session": "Sessione non valida. Accedi di nuovo.",
  "difusion.teacher_dashboard.load_students_error": "Errore durante il caricamento di alunni/e",
  "difusion.teacher_dashboard.no_classes": "Nessuna classe disponibile",
  "difusion.teacher_dashboard.no_students": "Nessun alunno/a trovato per questa classe",
  "difusion.teacher_dashboard.surname": "COGNOME",
  "difusion.teacher_dashboard.name": "NOME",
  "difusion.teacher_dashboard.status": "STATO",
  "difusion.teacher_dashboard.completed_conversations": "CONVERSAZIONI COMPLETATE",
  "difusion.teacher_dashboard.last_activity": "ULTIMA ATTIVITÀ",
  "difusion.teacher_dashboard.chat_history": "CRONOLOGIA CHAT",
  "difusion.teacher_dashboard.class_id": "ID classe",
  "difusion.teacher_dashboard.status.not_started": "Non iniziato",
  "difusion.teacher_dashboard.status.in_progress": "In corso",
  "difusion.teacher_dashboard.status.completed": "Completato",
  "difusion.teacher_dashboard.class_fallback": "Classe {{number}}",
  "embed.error.no_auth": "Accesso non riuscito",
  "embed.error.no_account": "Per favore, apri Teachino tramite il menu principale (a sinistra) per iniziare. Una volta registrato, vedrai i materiali pianificati della lezione qui.",
  "embed.error.no_course_mapping": "Il materiale di questa lezione è visibile solo per gli docenti che annoverano o sostituiscono questa lezione.",
  "embed.error.no_course_found": "Per questo corso non sono stati ancora rilasciati materiali in Teachino.",
  "embed.error.no_course_found_description": "Con Teachino, gli insegnanti possono preparare le lezioni digitalmente e rendere disponibili i materiali.",
  "embed.student.course_list.title": "Seleziona il tuo corso",
  "embed.student.course_list.description": "Hai accesso a questi corsi in Teachino.",
  "embed.student.course_list.change_course": "Cambia corso",
  "embed.student.session_expired.title": "Il tuo accesso è scaduto",
  "embed.student.session_expired.description": "Accedi di nuovo tramite il Registro Digitale. Dopo tornerai direttamente ai tuoi corsi.",
  "embed.student.session_expired.action": "Accedi tramite il Registro Digitale",
  "embed.student.session_expired.description_eduplaces": "Accedi di nuovo tramite Eduplaces. Dopo tornerai direttamente ai tuoi corsi.",
  "embed.student.session_expired.action_eduplaces": "Accedi tramite Eduplaces",
  "embed.student.session_expired.description_untis": "Accedi di nuovo tramite WebUntis. Dopo tornerai direttamente ai tuoi corsi.",
  "embed.student.session_expired.action_untis": "Accedi tramite WebUntis",
  "embed.course.day_empty": "Per questa data non sono stati rilasciati materiali.",
  "embed.error_generic.title": "Non è stato possibile stabilire una connessione con WebUntis.",
  "embed.error_generic.help": "Puoi accedere sempre alla tua biblioteca. Se il calendario di WebUntis non viene caricato, puoi disconnettere dalla scheda Profilo > Integrazione e inserire l'orario didattico manualmente per continuare la pianificazione delle lezioni.",
  "embed.error.continue": "Continua con Teachino",
  "period.item_context.remove": "Rimuovi il materiale dal giorno",
  "period.open_period": "Apri lezione",
  "period.start_presentation": "Avvia presentazione",
  "template.tag.topic": "Questa cartella è parte di una raccolta.",
  "template.tag.item": "Questo materiale è parte di una raccolta.",
  "template.topic.updates_available": "Aggiornamenti disponibili per questa cartella.",
  "template.topic.sync_topic_info.title": "Aggiorna cartella",
  "template.topic.sync_topic_info.description": "Aggiorna la cartella (nome, obiettivi, ecc.). Non aggiunge nuovi materiali.",
  "template.topic.sync_new_items.title": "Aggiungi nuovi materiali",
  "template.topic.sync_new_items.description": "Aggiunge nuovi materiali dalla raccolta. I materiali aggiunti manualmente non vengono modificati.",
  "template.item.updates_available": "Aggiornamenti disponibili per questo materiale.",
  "template.item.sync_item_info.title": "Aggiorna materiale",
  "template.item.sync_item_info.description": "Aggiorna il materiale (nome, ecc.).",
  "template.item.sync_new_snippets.title": "Aggiungi o aggiorna nuovi materiali",
  "template.item.sync_new_snippets.description": "Aggiunge nuovi materiali e aggiorna quelli esistenti dalla raccolta. I materiali aggiunti manualmente non vengono modificati.",
  "collaboration.cannot_edit_item": "Modifica non consentita.",
  "collaboration.use_topic.button": "Copia la cartella nella libreria",
  "collaboration.use_topic.button_short": "Copia cartella",
  "collaboration.use_item.button": "Copia materiale",
  "collaboration.use_topic.choose_course": "Scegli corso",
  "collection.material_banner.title": "Questo materiale fa parte di una raccolta.",
  "collection.material_banner.description": "Copialo in un corso per utilizzarlo.",
  "collection.material_banner.copy_to_course": "Copia nel corso",
  "collection.copy_multiple_folders.dialog_description": "Scegli le cartelle da « {{collection}} » da copiare in un corso.",
  "collection.origin_notice.folder_from": "Cartella da {{collectionName}}",
  "collection.origin_notice.material_from": "Materiale da {{collectionName}}",
  "collection.origin_notice.open_folder": "Apri la cartella nella raccolta",
  "collection.origin_notice.edit_material": "Modifica il materiale nella raccolta",
  "collection.origin_notice.new_version_available": "Nuova versione disponibile",
  "material_card.also_used_in_course": "Usato anche in {{courseName}}",
  "collaboration.add_from_library.successfull": "Cartella copiata",
  "collaboration.add_from_library.successfull_text": "La cartella e i materiali sono stati duplicati e aggiunti alla raccolta.",
  "collaboration.join_external_course.title": "Teamteaching",
  "collaboration.join_external_course.title_substitution": "Sostituzione",
  "collaboration.join_external_course.description": "{{ownerName}} sta già pianificando {{courseName}} con Teachino.",
  "collaboration.join_external_course.cta": "Unisciti all'insegnamento in team nel corso {{courseName}}",
  "collaboration.join_external_course.cta_substitution": "Assumi la sostituzione in {{courseName}}",
  "collaboration.join_external_course.not_join": "Desidero pianificare il corso da solo",
  "courses.empty_title": "Ancora nessun corso",
  "courses.empty_description": "I corsi rappresentano le tue classi e materie dell'anno scolastico attuale. Ad esempio \"10A Geografia\". Crea un corso per iniziare la pianificazione.",
  "video.modal.close": "Chiudi video",
  "video.modal.title": "Spiegazione video",
  "pathfindr.pdfsplitter.choose_pages": "Scegli pagine",
  "pathfindr.pdfsplitter.select_max_pages": "Seleziona fino a Y pagine.",
  "pathfindr.pdfsplitter.x_of_y_pages_selected": "X di Y pagine selezionate",
  "iframe.open_teachino": "Apri Teachino",
  "iframe.redirecting": "Apertura di Teachino…",
  "iframe.open_teachino_hint": "Teachino si apre in una nuova scheda.",
  "iframe.not_activated_hint": "L'integrazione WebUntis non è ancora attivata per la tua scuola. Puoi comunque usare Teachino, ma il tuo account verrà collegato a WebUntis solo dopo l'attivazione dell'integrazione.",
  "download.webview_not_possible": "Il download non è possibile in questa app. Apri Teachino nel browser.",
  "link.webview_not_possible": "L'apertura dei link non è possibile in questa app. Apri Teachino nel browser.",
  "ai_powered_by_teachino": "Chat IA da",
  "student_ai.home_view.empty_state.title": "Nessun esercizio IA disponibile ancora",
  "student_ai.home_view.empty_state.description": "Non appena crei un esercizio IA o te ne viene assegnato uno, apparirà qui.",
  "student_ai.home_view.title": "IA Studente di Teachino",
  "student_ai.assignment_view.title": "Esercizio IA Studente di Teachino",
  "student_ai.assignments": "Esercizi IA",
  "student_ai.banner.title": "Esercizi IA: Utilizza l'intelligenza artificiale con i tuoi alunni/e ✨",
  "student_ai.banner.description": "Insegna conoscenze specifiche del tema e competenze IA in un ambiente sicuro e conforme alla privacy con i nuovi esercizi IA.",
  "student_ai.banner.cta": "Vai alla IA per alunni/e",
  "student_ai.assignments.create_assignment": "Crea esercizio IA",
  "student_ai.assignments.share_assignment": "QR-Code e Link",
  "student_ai.assignments.start": "Inizia",
  "student_ai.assignments.stop": "Ferma",
  "student_ai.assignments.start_hint": "Clicca per avviare l'esercizio IA",
  "student_ai.assignments.stop_hint": "Esercizio IA in corso. Clicca per fermare",
  "student_ai.assignments.hint_assignment_inactive_before_cta": "Questo esercizio non è avviato.",
  "student_ai.assignments.hint_assignment_inactive_cta": "Avvia l'esercizio",
  "student_ai.assignments.hint_assignment_inactive_after_cta": "affinché alunni ed alunne possano chattare con l'IA.",
  "student_ai.assignments.hint_assignment_active": "I tuoi studenti possono ora chattare con l'IA. Possono scansionare il codice QR o diffondere il link.",
  "student_ai.create_assignment.title": "Crea esercizio IA",
  "student_ai.edit_assignment.title": "Modifica esercizio IA",
  "student_ai.duplicate_assignment.title": "Duplica esercizio IA",
  "student_ai.create_assignment.title.placeholder": "Esercizio IA del {{date}}",
  "student_ai.create_assignment.description": "Incarico per alunni ed alunne",
  "student_ai.create_assignment.system_prompt": "Comportamento del IA (Prompt di sistema)",
  "student_ai.delete_assignment.title": "Elimina esercizio IA",
  "student_ai.delete_assignment.description": "Sei sicuro di voler eliminare l'esercizio IA \"{{assignment}}\"? Questo passaggio non può essere annullato",
  "student_ai.share_assignment.scan_code": "Scansiona il codice per avviare l'esercizio IA",
  "student_ai.template.import": "Usa con i miei alunni ed alunne",
  "student_ai.template.created_by_teachino": "Creato da Teachino",
  "student_ai.template.import_from_teachino": "Scopri tutti gli esercizi IA",
  "student_ai.create.edit_system_prompt": "Modifica prompt",
  "editor.image_selector.upload": "Carica immagine",
  "editor.image_selector.search": "Cerca immagine",
  "editor.image_selector.generate": "Genera immagine con IA",
  "editor.image_selector.ai.prompt_label": "Inserisci una descrizione dell'immagine",
  "editor.image_selector.ai.prompt_placeholder": "Inserisci qui il prompt per l'immagine generata da IA",
  "editor.image_selector.ai.style": "Stile",
  "editor.image_selector.ai.style.realistic": "Realistico",
  "editor.image_selector.ai.style.artistic": "Artistico",
  "editor.image_selector.ai.style.cartoon": "Cartoon",
  "editor.image_selector.ai.style.sketch": "Schizzo",
  "editor.image_selector.ai.style.watercolor": "Acquerello",
  "editor.image_selector.ai.style.minimalist": "Minimalista",
  "editor.image_selector.ai.author_name": "Generato da IA",
  "editor.image_selector.ai.cta": "Genera immagine",
  "editor.image_selector.search.label": "Parola chiave",
  "editor.image_selector.libraries.empty": "Nessuna libreria immagini disponibile",
  "editor.image_selector.libraries.recent": "Usate di recente",
  "editor.image_selector.libraries.all": "Tutte le librerie",
  "editor.image_selector.ai.results": "Immagini generate",
  "editor.image_selector.tab.upload": "Carica immagine",
  "editor.image_selector.tab.search": "Cerca immagine",
  "editor.image_selector.tab.ai": "Genera IA",
  "editor.image_selector.ai.paywall.title": "Genera immagini con l'IA per i tuoi materiali",
  "editor.image_selector.ai.paywall.description": "Descrivi ciò di cui hai bisogno e crea immagini personalizzate direttamente nell'editor dei materiali. Sottoscrivi una licenza per sbloccare la generazione di immagini con IA.",
  "editor.image_selector.tab.loading": "L'immagine sarà salvata",
  "editor.tools.list.bulleted_list.name": "Elenco puntato",
  "editor.tools.list.ordered_list.name": "Elenco numerato",
  "editor.tools.details.name": "Elenco pieghevole",
  "editor.tools.callout.name": "Nota",
  "editor.tools.callout.color": "Colore",
  "editor.tools.table.name": "Tabella",
  "editor.tools.table.add_row_below": "Aggiungi riga sotto",
  "editor.tools.table.add_row_above": "Aggiungi riga sopra",
  "editor.tools.table.add_header_row": "Riga di intestazione",
  "editor.tools.table.add_column_left": "Aggiungi colonna a sinistra",
  "editor.tools.table.add_column_right": "Aggiungi colonna a destra",
  "editor.tools.table.add_header_column": "Colonna di intestazione",
  "editor.tools.table.delete_row": "Elimina riga",
  "editor.tools.table.delete_column": "Elimina colonna",
  "editor.tools.table.delete": "Elimina tabella",
  "editor.tools.text_color.name": "Colore testo",
  "editor.tools.text_color_background.name": "Colore & Sfondo",
  "editor.tools.highlight.name": "Evidenzia",
  "editor.tools.align_left.name": "Allinea a sinistra",
  "editor.tools.align_center.name": "Allinea al centro",
  "editor.tools.align_right.name": "Allinea a destra",
  "editor.tools.align_justify.name": "Giustifica",
  "editor.tools.mathematics.name": "Formula",
  "editor.tools.bold.name": "Grassetto",
  "editor.tools.italic.name": "Corsivo",
  "editor.tools.underline.name": "Sottolineato",
  "editor.tools.strike.name": "Barrato",
  "editor.tools.code.name": "Codice",
  "editor.tools.clear_format.name": "Rimuovi formattazione",
  "editor.tools.image": "Immagine",
  "editor.tools.image.caption.label": "Didascalia",
  "editor.tools.image.caption.placeholder": "Descrivi l'immagine",
  "editor.tools.image.source": "[Fonte]",
  "editor.tools.file": "File",
  "editor.tools.link": "Link",
  "editor.tools.heading.name": "Titolo",
  "editor.tools.heading.prose": "Testo fluente",
  "editor.tools.heading.heading_1": "Titolo 1",
  "editor.tools.heading.heading_2": "Titolo 2",
  "editor.tools.heading.heading_3": "Titolo 3",
  "keyboard.modifier.windows": "Ctrl",
  "keyboard.modifier.mac": "command",
  "keyboard.shift": "Maiusc",
  "student_ai.upgrade_banner_before": "Con la licenza gratuita per docenti puoi provare l'IA studenti in anteprima. Ti piace? Allora ",
  "student_ai.upgrade_banner_cta": "ottieni ora la licenza Pro",
  "student_ai.upgrade_banner_after": "🏅, per condividere gli esercizi facilmente con i tuoi alunni/e.",
  "material.default_name": "Materiale senza nome",
  "material.ai": "IA",
  "material.ai_edit.suggestion_3_question": "In quale lingua vuoi tradurre il materiale?",
  "material.ai_edit.suggestion_3_other": "Altra lingua",
  "material.ai_edit.suggestion_3_placeholder": "Inserisci una lingua…",
  "material.ai.create.suggestion_1_question": "Su quale tema deve vertere la scheda di lavoro?",
  "material.ai.create.suggestion_1_no_topic": "Crea una scheda di lavoro.",
  "material.ai.create.suggestion_2_question": "Su quale tema deve vertere lo svolgimento della lezione?",
  "material.ai.create.suggestion_2_no_topic": "Crea lo svolgimento di una lezione.",
  "material.ai.create.suggestion_3_question": "Su quale tema deve vertere l'esercizio interattivo?",
  "material.ai.create.suggestion_3_no_topic": "Crea un esercizio interattivo.",
  "material.ai.create.suggestion_4_question": "Su quale tema deve vertere l'introduzione alla lezione?",
  "material.ai.create.suggestion_4_no_topic": "Crea un'introduzione motivante e orientata agli studenti.",
  "material.ai_state.reworking": "L’IA sta rielaborando il materiale…",
  "material.details": "Dettagli",
  "material.empty_state": "Realizza la tua idea: inizia a scrivere, chiedi all'IA o aggiungi blocchi.",
  "material.create": "Crea materiale",
  "material.edit_details.title": "Dettagli del materiale",
  "material.details_dialog.duration_placeholder": "es. 30",
  "material.details_dialog.duration_invalid": "Inserisci un numero intero tra 1 e {{max}} minuti oppure lascia il campo vuoto.",
  "material.edit_details.topic_description": "Ogni materiale appartiene a una cartella. Questo ti aiuta a trovarlo più facilmente dopo e fornisce più contesto all'IA.",
  "material.edit_details.duration_description": "Quanti minuti sono necessari in aula per questo materiale?",
  "material.edit_details.more": "Altre azioni",
  "material.edit_details.material_duplicate": "Duplica materiale",
  "material.edit_details.material_delete": "Elimina materiale",
  "material.share.courses_with_material": "Corsi con questo materiale",
  "material.share.add_to_more_courses": "Aggiungi materiale a più corsi",
  "material.share.empty.no_courses_available.title": "Crea un corso per condividere il materiale con alunni/e.",
  "material.share.empty.no_courses_available.description": "I corsi corrispondono alle tue classi e materie. Ad esempio: 8A Geografia.",
  "material.share.empty.courses_available_empty.title": "Aggiungi il materiale a un corso esistente o crea un nuovo corso.",
  "material.share.new_course": "Crea corso e condividi materiale",
  "material.share.added_to_course": "Materiale aggiunto al corso",
  "material.editor.teacher_note.title": "Nota per docenti",
  "material.editor.teacher_note.placeholder": "Le note sono visibili solo per te. Puoi anche conservare fogli di soluzione qui.",
  "material.editor.teacher_note.convert_to_teacher_note": "Mostra solo a me",
  "material.editor.teacher_note.remove_from_teacher_note": "Mostra a tutti",
  "material.editor.activity.ai_feedback": "Con feedback IA",
  "material.editor.assignment_open_question.title": "Domanda",
  "material.editor.assignment_open_question.assignment_tag": "Compito",
  "material.editor.assignment_open_question.your_answer": "La tua risposta",
  "material.editor.assignment_open_question.check": "Consegna",
  "material.editor.assignment_open_question.redo": "Rivedi la risposta",
  "material.editor.assignment_open_question.get_hint": "Ottieni suggerimento",
  "material.editor.assignment_open_question.hint": "Suggerimento",
  "material.editor.assignment_open_question.confirm": "Conferma",
  "material.editor.assignment_open_question.guidance": "Criteri per il feedback IA sui contenuti",
  "material.editor.assignment_open_question.generate_guidance": "Genera con IA",
  "material.editor.assignment_open_question.generate_guidance_empty": "Inserisci una domanda di almeno 10 caratteri per generare criteri di feedback adeguati.",
  "material.editor.assignment_open_question.generate_guidance_disabled": "Aggiungi prima una domanda",
  "material.editor.assignment_open_question.generate_guidance_error": "Impossibile generare i criteri di feedback. Riprova.",
  "material.editor.assignment_open_question.guidance_placeholder": "Lo studente elenca...",
  "material.editor.assignment_open_question.guidance_example": "Definisci criteri per forma, lunghezza e contenuto e, se necessario, aggiungi una risposta modello. L’IA li usa per valutazione, feedback e feed forward.",
  "material.assignment_open_question.answer_placeholder": "Digita la tua risposta",
  "material.assignment_open_question.answer_reset": "Reimposta",
  "material.assignment_open_question.get_feedback": "Ottieni feedback",
  "material.assignment_open_question.feedback": "Feedback dell'IA",
  "material.assignment_open_question.feedback.empty_state": "Nessun feedback disponibile",
  "material.assignment_open_question.status.not_answered": "Non risposto",
  "material.assignment_open_question.status.incorrect": "Risposta non corretta",
  "material.assignment_open_question.status.partially": "Risposta parzialmente corretta",
  "material.assignment_open_question.status.correct": "Risposta completamente corretta",
  "material.assignment_open_question.status.started": "In corso",
  "material.assignment_open_question.status.not_started": "Non iniziato",
  "material.assignment_open_question.summary.started": "In corso",
  "material.assignment_open_question.summary.correct": "Completamente corretto",
  "material.assignment_open_question.summary.partially": "Parzialmente corretto",
  "material.assignment_open_question.summary.incorrect": "Non corretto",
  "material.assignment_open_question.loading": "L'IA sta leggendo la risposta e fornirà un feedback a breve.",
  "material.assignment_open_question.ai_disclaimer": "Il feedback viene generato dall'IA. L'IA può commettere errori.\nNon inserire dati personali.",
  "material.assignment_open_question.question_placeholder": "Digita una domanda o un incarico",
  "material.assignment_open_question.attempt": "Tentativo",
  "material.assignment_open_question.answer.empty_state": "Nessuna risposta",
  "material.assignment_open_question.answer_paste_block": "Per favore, digita la tua risposta invece di copiarla.",
  "material.assignment_open_question.answer_paste_block_teacher": "Alunni/e possono solo digitarla, copia e incolla è consentito solo per docenti.",
  "speech_to_text.microphone": "Microfono",
  "speech_to_text.default_microphone": "Microfono predefinito",
  "speech_to_text.start_recording": "Registra risposta",
  "speech_to_text.stop_recording": "Ferma registrazione",
  "speech_to_text.transcribing": "Trascrizione in corso...",
  "speech_to_text.microphone_denied": "L'accesso al microfono è stato negato. Consenti l'accesso al microfono nelle impostazioni del browser.",
  "speech_to_text.transcription_error": "Trascrizione vocale non riuscita. Riprova o digita la risposta.",
  "image_to_text.upload_image": "Carica immagine (estrai testo)",
  "image_to_text.extraction_error": "Estrazione del testo dall'immagine non riuscita. Riprova o digita la risposta.",
  "image_to_text.file_too_large": "L'immagine è troppo grande (max. 5 MB). Si prega di utilizzare un'immagine più piccola.",
  "material.student.your_are_logged_in_as": "Hai effettuato l'accesso come {{name}}",
  "material.student.click_logout_description": "Clicca su \"Disconnetti\" per uscire. In questo modo le tue risposte verranno eliminate da questo computer. Il tuo docente potrà comunque continuare ad accedervi.",
  "material.editor.image.set_size_small": "Riduci dimensione",
  "material.editor.image.set_size_large": "Aumenta dimensione",
  "material.editor.image.size_small": "Piccola",
  "material.editor.image.size_medium": "Media",
  "material.editor.image.size_large": "Grande",
  "material.editor.image.replace": "Sostituisci immagine",
  "material.editor.image.replace_preview": "In \"Modifica\" puoi scegliere, caricare o anche generare un'immagine alternativa con IA.",
  "material.change_topic": "Cambia cartella",
  "library.material.courses.title": "Corsi",
  "library.material.courses.loading": "Caricamento corsi...",
  "library.material.courses.empty": "Questo materiale non è associato a nessun corso",
  "material.rename.success": "Materiale rinominato!",
  "material.icon_change.success": "Nuovo simbolo salvato!",
  "material.download": "Scarica",
  "material.editor.image.expand": "Ingrandisci immagine",
  "material.preview": "Anteprima",
  "material.open_link": "Apri link",
  "material.copy_link": "Copia link",
  "material.editor.link.save": "Salva link",
  "material.editor.link.label": "Link",
  "material.editor.link.title": "Titolo del link",
  "material.editor.link.title_placeholder": "Aggiungi titolo",
  "material.editor.link.description": "Descrizione del link",
  "material.editor.link.description_placeholder": "Aggiungi descrizione",
  "material.editor.link.add": "Inserisci link",
  "material.editor.link.edit_url": "Modifica link",
  "material.editor.link.convert_to_preview": "Converti in anteprima",
  "material.editor.link.reload_preview": "Ricarica anteprima",
  "material.editor.link.convert_to_url": "Converti in URL",
  "material.bulk.cta": "Carica file",
  "material.bulk_create.title": "Carica file",
  "material.bulk_create.files": "File",
  "material.bulk_create.hint_1": "💡 Suggerimento: Con {{cmdAll}} puoi selezionare tutti i file in una cartella.",
  "material.bulk_create.hint_2": "Per cliccare su più file, tieni premuto {{cmdMultiSelect}}.",
  "material.bulk_create.success": "Materiali creati!",
  "material.bulk_create.pending_uploads": "{{count}} in attesa",
  "material.bulk_create.cancel_uploads.title": "Annullare i caricamenti?",
  "material.bulk_create.cancel_uploads.message": "Chiudendo questa finestra verranno annullati tutti i caricamenti in corso. Vuoi continuare?",
  "material.bulk_create.cancel_uploads.confirm": "Sì, annulla",
  "material.bulk_create.cancel_uploads.keep_uploading": "No, continua a caricare",
  "material.external_content.header": "Scegli documento",
  "material.external_content.empty": "Nessun documento trovato",
  "material.external_content.recent": "Documenti usati di recente",
  "material.share.cta": "Condividi",
  "material.share.cta_long": "Condividi materiale con gli studenti",
  "material.share_with_teachers.menu_label": "Condividi con docenti",
  "material.share_with_teachers.title": "Condividi il materiale con altri docenti",
  "material.share_with_teachers.description": "Chiunque abbia questo link può visualizzare il materiale e copiarlo nei propri corsi.",
  "material.share_with_teachers.hint": "Il link è accessibile pubblicamente. Le risposte e i dati di alunni/e non vengono condivisi.",
  "material.share_with_teachers.deactivate": "Disattiva il link",
  "material.share_with_teachers.deactivated_title": "Link disattivato",
  "material.share_with_teachers.deactivated_description": "Il link precedente non funziona più. Nessuno può più visualizzare o copiare il materiale tramite questo link. I materiali già copiati non vengono toccati.",
  "material.share_with_teachers.create_new_link": "Crea un nuovo link",
  "shared_material.title": "Materiale condiviso",
  "shared_material.subtitle": "Un docente ha condiviso questo materiale con te",
  "shared_material.use_material": "Usa il materiale",
  "shared_material.use_material_hint": "Copia il materiale in uno dei tuoi corsi per modificarlo e utilizzarlo.",
  "shared_material.no_courses": "Non hai ancora un corso in cui copiare il materiale. Crea prima un corso.",
  "shared_material.not_available.title": "Materiale non disponibile",
  "shared_material.not_available.description": "Il link non è valido o è stato disattivato.",
  "material.rename_dialog.title": "Nome del materiale",
  "material.rename_dialog.description": "Dai un nome al tuo materiale per fornire abbastanza contesto all'IA.",
  "material.rename_dialog.placeholder": "Inserisci nome",
  "material.rename_dialog.error": "Inserisci un nome più lungo.",
  "material.chat.send": "Invia",
  "material.chat.age_select.label": "Età di alunni ed alunne",
  "material.chat.language_select.label": "Lingua di alunni ed alunne",
  "interactive_assignment.overview.title": "Ripartizione per {{courseName}}",
  "interactive_assignment.overview.table.name": "Nome",
  "interactive_assignment.number_of_students_one": "Un alunno/a",
  "interactive_assignment.number_of_students_many": "{{number}} alunni/e",
  "interactive_assignment.overview.legend": "Legenda",
  "interactive_assignment.overview.legend.incorrect": "Non corretto",
  "interactive_assignment.overview.user_interview.title": "Usi compiti interattivi con feedback IA: grazie!",
  "interactive_assignment.overview.user_interview.description": "Hai già raccolto risposte da diversi studenti. Partecipa a una breve intervista utente e dicci cosa funziona bene e cosa dovremmo migliorare.",
  "interactive_assignment.overview.user_interview.cta": "Partecipa all'intervista",
  "ipi.prompt.cta": "Generare materiale",
  "ipi.material.done": "Fatto! Clicca su Modifica per adattare il materiale o condividilo con i tuoi studenti.",
  "ipi.hints": "Esempi",
  "ipi.hint": "Esempio:",
  "ipi.hints.1.title": "Foglio di lavoro interattivo sul cambiamento climatico",
  "ipi.hints.1.prompt": "Crea un foglio di lavoro sugli effetti del cambiamento climatico con enfasi sui fenomeni meteorologici estremi.",
  "ipi.hints.3.title": "Introduzione alla lezione sulla macchina a vapore",
  "ipi.hints.3.prompt": "Crea un'introduzione alla lezione sul funzionamento delle macchine a vapore.",
  "ipi.hints.4.title": "Testo informativo con domande di comprensione sul turismo in Alto Adige",
  "ipi.hints.4.prompt": "Scrivi un testo informativo sugli impatti del turismo su un luogo, prendendo come esempio l'Alto Adige nel contesto della geografia. Aggiungi tre domande aperte.",
  "ipi.loading.title": "Il tuo materiale è in fase di creazione",
  "ipi.loading.subtitle": "Questo richiede circa un minuto",
  "ipi.loading.1": "Creazione della struttura del tuo materiale",
  "ipi.loading.2": "Testi, attività e immagini vengono combinati",
  "ipi.loading.3": "Generazione dei compiti interattivi",
  "ipi.loading.4": "Puoi modificare e completare il materiale finito a tuo piacimento.",
  "ipi.loading.5": "Successivamente puoi stamparlo o condividerlo tramite link con i tuoi alunni/e.",
  "ipi.loading.6": "Il materiale viene salvato in una cartella del corso.",
  "ipi.loading.material_ready": "Il tuo materiale è pronto.",
  "ipi.loading.view_material": "Visualizza il materiale",
  "ipi.convert_worksheet.title": "Converti foglio di lavoro",
  "ipi.convert_worksheet.convert_button": "Converti",
  "ipi.convert_worksheet.description": "Carica un foglio di lavoro (PDF, immagine o documento) e l'IA lo convertirà in materiale Teachino interattivo.",
  "ipi.convert_worksheet.ai_prompt": "Converti questo foglio di lavoro caricato in materiale Teachino interattivo.",
  "ipi.progress.validating": "Convalida dell'input in corso...",
  "ipi.progress.generating": "Creazione del materiale con {{images}} immagini...",
  "ipi.progress.integrating": "Integrazione di {{questions}} compiti interattivi…",
  "ipi.progress.finalizing": "Finalizzazione del materiale...",
  "ipi.topic_select.title": "Scegli una cartella per l’IA",
  "ipi.material.name_placeholder": "Nuovo materiale",
  "ipi.add_source": "Fonte",
  "ipi.add_source.loading": "Caricamento in corso...",
  "ipi.add_source.upload_file": "Carica file",
  "ipi.add_source.add_link": "Inserisci link",
  "ipi.add_source_description": "Scegli un link, un video, un file o una cartella come fonte per l’IA.",
  "ipi.longer_prompt.hint": "Inserisci almeno 6 caratteri per avviare l'IA. Usa gli esempi per ispirarti.",
  "ipi.disclaimer": "L’IA crea il materiale in base alle tue indicazioni (testo, fonte, cartella). Non inserire dati personali. L’IA può commettere errori.",
  "ai_assistant.rework_pending_review": "Una revisione esistente di questo materiale è ancora in attesa di revisione o in fase di applicazione. Approvala o scartala prima di avviarne un'altra.",
  "image_generation.disclaimer": "La descrizione viene elaborata con l'IA. Per favore non inserire dati personali.",
  "course.current_course": "Corso attuale",
  "course.current_collection": "Raccolta attuale",
  "course.all_courses": "Tutti i corsi",
  "course.all_materials": "Tutti i materiali",
  "course.materials.empty.title": "Crea il tuo primo materiale!",
  "course.materials.empty.description": "Scegli un suggerimento IA oppure fai clic su Nuovo per iniziare in autonomia.",
  "course.materials.empty.manual_description": "Fai clic su Nuovo per creare il tuo primo materiale.",
  "course.materials.empty.ai_primary_cta": "Inizia con l'assistente IA",
  "course.materials.empty.ai_primary_prompt": "Crea un materiale adatto al mio corso.",
  "course.materials.empty.ai_cta_description": "Descrivi cosa ti serve – l'assistente IA crea un materiale adatto al tuo corso.",
  "course.materials.empty.ai_cta_action": "Apri assistente",
  "course.materials.empty.convert_description": "Carica un foglio di lavoro e trasformalo in materiale interattivo.",
  "course.materials.empty.convert_action": "Carica foglio di lavoro",
  "course.materials.empty.manual_hint": "Puoi anche creare, importare o caricare materiali manualmente tramite Nuovo.",
  "course.materials.empty.guest.title": "Nessun materiale ancora",
  "course.materials.empty.guest.description": "In questo corso non è ancora stato creato alcun materiale.",
  "course.materials.empty.guest.collection_description": "In questa raccolta non è ancora stato creato alcun materiale.",
  "course.materials.used_in_courses_label": "Utilizzato nei corsi:",
  "course.add_content_menu.create_material": "Crea materiale",
  "course.add_content_menu.create_folder": "Crea cartella",
  "course.add_content_menu.reuse_section": "Riutilizza",
  "course.add_content_menu.add_from_course_or_collection": "Aggiungi materiale da un altro corso / raccolta",
  "course.add_existing_empty_title": "Nessun altro corso disponibile",
  "course.add_existing_empty_description": "Crea o ripristina un altro corso per visualizzare i materiali esistenti qui.",
  "course.add_existing_empty_materials_title": "Nessun materiale in questa cartella",
  "course.add_existing_empty_materials_description": "Seleziona un'altra cartella per visualizzarne i materiali.",
  "course.all_folders_copied": "Tutte le cartelle copiate",
  "course.copy_all_folders.button": "Copia tutte le cartelle",
  "course.copy_all_folders.confirm_title": "Copiare tutte le cartelle?",
  "course.copy_all_folders.confirm_message": "{{count}} cartelle verranno copiate in questo corso.",
  "course.copy_all_folders.partial_success": "Copiate {{copied}} di {{total}} cartelle",
  "course.copy_all_folders.success": "Tutte le cartelle copiate",
  "course.copy_multiple_folders.button": "Copia cartelle…",
  "course.copy_multiple_folders.confirm": "Copia {{count}} cartelle nel corso",
  "course.copy_multiple_folders.select_course": "Seleziona corso…",
  "course.copy_multiple_folders.dialog_description": "Scegli le cartelle da « {{course}} » da copiare in « {{destinationCourse}} ».",
  "course.copy_multiple_folders.dialog_title": "Copia nel corso",
  "course.copy_multiple_folders.material_count": "{{count}} materiali",
  "course.copy_multiple_folders.partial_success": "Copiate {{copied}} di {{total}} cartelle",
  "course.copy_multiple_folders.select_all": "Seleziona tutte",
  "course.copy_multiple_folders.selection_count": "{{selected}} di {{total}} selezionate",
  "course.copy_multiple_folders.success": "{{count}} cartelle copiate",
  "course.archived_courses": "Corsi eliminati",
  "course.recently_updated_materials": "Aggiornati di recente",
  "course.export.date": "Data",
  "course.export.materials_and_notes": "Materiali e note",
  "course.export.class_register": "Cartella",
  "course.export.year_plan": "Esporta pianificazione annuale",
  "course.export.calendar_days": "Esporta ore e contenuti",
  "course.export.dialog.title": "Stampa ed esporta",
  "course.export.dialog.student_codes.title": "Codici di accesso di alunni/e",
  "course.export.dialog.student_codes.description": "Stampa le schede di accesso con i nomi e i codici personali di tutti/e gli/le alunni/e del corso.",
  "course.export.dialog.student_codes.unavailable": "Questa esportazione è disponibile dopo aver aggiunto alunni/e al corso.",
  "course.export.dialog.year_plan.title": "Pianificazione annuale",
  "course.export.dialog.year_plan.description": "Esporta le cartelle e i relativi periodi pianificati in un file CSV.",
  "course.export.dialog.year_plan.unavailable": "Questa esportazione è disponibile dopo aver aggiunto cartelle e materiali al corso.",
  "course.export.dialog.calendar.title": "Ore e contenuti (Cartella)",
  "course.export.dialog.calendar.description": "Esporta le ore pianificate, i materiali, le note e le voci della cartella in un file CSV.",
  "course.export.dialog.calendar.unavailable": "Questa esportazione è disponibile dopo aver pianificato le lezioni.",
  "course.export.dialog.grading.title": "Panoramica valutazioni",
  "course.export.dialog.grading.description": "Esporta la panoramica delle valutazioni di tutti gli studenti come file CSV.",
  "course.export.dialog.grading.unavailable": "Questa esportazione è disponibile dopo aver aggiunto studenti al corso.",
  "course.export.grading_overview": "Esporta panoramica valutazioni",
  "course.export.from": "Da",
  "course.export.to": "A",
  "course.edit_course": "Modifica corso",
  "course.archive_course": "Elimina corso",
  "course.archive_course_message": "Eliminare \"{{courseName}}\"?",
  "course.archived_toast": "Corso eliminato. Il corso \"{{courseName}}\" è stato eliminato.",
  "course.import_material_from_course": "Materiale da corso o raccolta",
  "course.import_material_from_course_dialog": "Aggiungi materiale da un corso o una raccolta",
  "course.import_material_from_x": "Aggiungi materiale da \"{{course}}\"",
  "course.import_from_course.destination_hint": "I materiali verranno copiati in « {{courseName}} », cartella « {{folderName}} ».",
  "chatbot.chatbots": "Chatbot",
  "chatbot.custom_chatbots": "Chatbot personalizzati",
  "chatbot.custom_chatbot": "Chatbot personalizzato",
  "chatbot.create_new": "Crea nuovo chatbot",
  "chatbot.rename": "Rinomina chatbot",
  "chatbot.edit": "Modifica chatbot",
  "chatbot.delete": "Elimina chatbot",
  "chatbot.delete_confirm": "Vuoi davvero eliminare \"{{title}}\"?",
  "chatbot.customizable": "Personalizzabile individualmente",
  "chatbot.name_label": "Nome del chatbot",
  "chatbot.how_should_answer": "Come dovrebbe rispondere il chatbot?",
  "chatbot.purpose": "A cosa serve questo chatbot?",
  "chatbot.start_without_template": "Inizia senza modello",
  "chatbot.start_chat": "Avvia chat IA",
  "chatbot.ai_instructions": "Impostazioni di base per l'IA",
  "chatbot.additional_info": "Informazioni aggiuntive per l'IA",
  "chatbot.internal_notes": "Note interne per l'utilizzo",
  "chatbot.no_info": "Nessuna informazione fornita",
  "chatbot.no_ai_settings": "Nessuna impostazione IA ancora",
  "chatbot.enter_message": "Inserisci messaggio...",
  "chatbot.legacy.title": "Chat IA esistenti",
  "chatbot.legacy.description": "Scegli una chat esistente per precompilare i campi. Copia le vecchie chat IA nei tuoi corsi entro il 30/07/2026.",
  "chatbot.context.description": "Contenuti a cui il chatbot deve avere accesso.",
  "chatbot.context.no_sources": "Nessuna fonte aggiunta",
  "chatbot.context.no_sources_hint": "Aggiungi file o link a cui l'IA deve avere accesso.",
  "chatbot.context.add_file": "File",
  "chatbot.context.add_link": "Link",
  "chatbot.description.student_hint": "Viene mostrato ad alunni/e prima che inizino la chat.",
  "chatbot.prompt.teacher_only_hint": "Solo tu vedi questa istruzione – controlla il comportamento dell'IA.",
  "chatbot.title.student_visible_hint": "Il nome del chatbot che vedono alunni/e.",
  "chatbot.context.sources_label": "Fonti e materiali",
  "chatbot.hello_message": "Ciao! Come posso aiutarti oggi?",
  "chatbot.explain_simple": "Puoi spiegarmi l'argomento in termini semplici?",
  "chatbot.step_by_step": "Certo. Affrontiamo l'argomento passo dopo passo.",
  "chatbot.no_custom_chatbots_empty_state": "Nessun chatbot personalizzato ancora. Crea un nuovo chatbot tramite \"Nuovo...\".",
  "folder.folder_copied": "Cartella copiata",
  "folder.delete_folder": "Elimina cartella",
  "folder.delete_folder_confirm": "Vuoi davvero eliminare la cartella?",
  "folder.remove_from_course": "Rimuovi dal corso",
  "folder.remove_from_course_confirm": "Vuoi davvero rimuovere la cartella da questo corso?",
  "folder.folder_removed_from_course": "Cartella rimossa dal corso",
  "folder.select_course_for_copy": "Seleziona il corso in cui copiare la cartella.",
  "material.no_materials_found": "Nessun materiale trovato",
  "material.material_copied": "Materiale copiato",
  "material.material_moved": "Materiale spostato",
  "material.delete_material_confirm": "Vuoi davvero eliminare questo materiale?",
  "material.copy_destination": "Dove deve essere copiato il materiale?",
  "material.move_destination": "Dove deve essere spostato il materiale?",
  "material.visible_for_sus": "Visibile ad alunni ed alunne",
  "material.not_visible_for_sus": "Materiale non visibile ad alunni/e",
  "generic.ok": "Ok",
  "generic.new": "Nuovo...",
  "generic.new_short": "Nuovo",
  "generic.rename": "Rinomina",
  "generic.help": "Aiuto",
  "generic.website": "Sito web",
  "generic.webinar": "Webinar",
  "generic.image": "Immagine",
  "generic.europathek": "EUROPATHEK",
  "generic.no_images_found": "Nessuna immagine trovata",
  "generic.scan_qr_code": "Scansiona codice QR",
  "generic.add_source": "Aggiungi fonte",
  "generic.try_different_search": "Prova con un altro termine di ricerca",
  "generic.name_and_color": "Nome e colore",
  "generic.change_name_color": "Cambia nome e colore",
  "ipi.describe_what_to_create": "Descrivi cosa deve creare l'IA...",
  "ipi.placeholder.example_photosynthesis": "Una scheda di lavoro sulla fotosintesi con immagini e domande aperte",
  "ipi.placeholder.example_faust": "Un esercizio IA sul Faust di Goethe",
  "ipi.placeholder.example_past_simple": "Un testo lacunare interattivo sul Past Simple",
  "ipi.ideas_for_you": "Idee per te",
  "ipi.generate_ideas": "Genera idee",
  "ipi.generate_new_ideas": "Nuove idee",
  "ipi.choose_idea": "Usa prompt",
  "ipi.ideas_generating": "Le idee per te sono in fase di generazione",
  "ipi.ai_assistance": "Assistenza IA",
  "ipi.enter_details": "Inserisci dettagli",
  "ipi.context_files": "File di contesto",
  "ipi.description_students": "Descrizione per alunni/e",
  "ipi.description_teacher": "Descrizione per il/la docente",
  "ipi.llm_instructions": "Descrizione per il chatbot",
  "ipi.loading": "Caricamento",
  "feature_flags.title": "Feature Flags 🧪",
  "course.ai_instructions_description": "L'IA utilizza queste informazioni per adattare i materiali al tuo insegnamento.",
  "course.additional_info_description": "ad es. se l'IA deve dare del tu o del lei ad alunni/e, nonché informazioni che devono essere considerate per ogni materiale",
  "course.display_question": "Come deve essere visualizzato il corso?",
  "course.archive_description": "Elimina il corso. I materiali verranno conservati per gli anni scolastici futuri.",
  "course.archive_info": "Il corso non verrà più visualizzato per la pianificazione. I materiali possono ancora essere accessibili tramite la voce di menu \"Corsi eliminati\" nella biblioteca.",
  "course_list.loading": "Caricamento elenco corsi…",
  "course_list.error.load_failed": "Impossibile caricare l'elenco dei corsi.",
  "course_list.error.reorder": "Impossibile riordinare il corso.",
  "course_list.error.update_school_year": "Impossibile aggiornare l'anno scolastico.",
  "course_list.error.create_course": "Impossibile creare il corso.",
  "course_list.error.connect_course": "Impossibile collegare il corso.",
  "course_list.error.hide_course": "Impossibile nascondere il corso.",
  "course_list.error.failed_create_school_year": "Impossibile creare l'anno scolastico.",
  "course_list.error.failed_update_school_year": "Impossibile aggiornare l'anno scolastico.",
  "course_list.error.school_year_overlap": "Questo anno scolastico si sovrappone a uno esistente. Modifica le date e salva di nuovo.",
  "course_list.new_school_year": "Nuovo anno scolastico",
  "course_list.create_school_year": "Crea anno scolastico",
  "course_list.edit_school_year": "Modifica anno scolastico",
  "course_list.delete_school_year": "Elimina anno scolastico",
  "course_list.delete_school_year.title": "Elimina anno scolastico",
  "course_list.delete_school_year.message": "Eliminare \"{{schoolYearName}}\"?",
  "course_list.delete_school_year.success": "Anno scolastico eliminato. \"{{schoolYearName}}\" è stato eliminato.",
  "course_list.delete_school_year_blocked.info_title": "L'anno scolastico contiene corsi",
  "course_list.delete_school_year_blocked.info_message": "Elimina prima tutti i corsi di questo anno scolastico. Poi potrai eliminare l'anno scolastico.",
  "course_list.hide_course": "Nascondi corso",
  "course_list.connect_course": "Collega corso",
  "course_list.add_course": "Aggiungi corso",
  "course_list.empty_school_year.title": "Nessun corso",
  "course_list.empty_school_year.description": "Non ci sono corsi in questo anno scolastico.",
  "course_list.empty.description": "Crea un corso per iniziare.",
  "course_list.connect_dialog.description": "Scegli il corso Teachino da collegare a questo corso esterno.",
  "course_list.external_course": "Corso esterno",
  "course_list.external_course_from": "da {{integrationName}}",
  "course_list.teachino_course": "Corso Teachino",
  "course_list.select_course": "Seleziona un corso",
  "course_list.connect_existing": "Collega a un corso esistente",
  "course_list.statistics.students": "studenti",
  "course_list.statistics.folders": "cartelle",
  "course_list.statistics.materials": "materiali",
  "course_list.menu.open": "Apri",
  "course_list.open_course_aria": "Apri corso",
  "course_list.school_year.description": "Scegli l'anno scolastico a cui appartiene questo corso.",
  "course_list.select_school_year": "Seleziona un anno scolastico",
  "course_list.school_year.start_date": "Data di inizio",
  "course_list.school_year.end_date": "Data di fine",
  "course_list.school_year.end_date_after_start": "La data di fine deve essere successiva alla data di inizio.",
  "course_list.school_year.name_placeholder": "es. {{startYear}}/{{endYear}}",
  "course_list.school_year.course_count_zero": "{{number}} corsi",
  "course_list.school_year.course_count_one": "{{number}} corso",
  "course_list.school_year.course_count_many": "{{number}} corsi",
  "course_list.school_year.drag_blocked": "I corsi non possono essere trascinati in un altro anno scolastico. Modifica l'anno scolastico nelle impostazioni del corso.",
  "course_list.school_year.change_hint": "Cambiare l'anno scolastico elimina l'orario didattico di questo corso.",
  "course_list.school_year.change_title": "Spostare il corso in {{schoolYear}}?",
  "course_list.school_year.change_message": "L'orario didattico di «{{courseName}}» verrà eliminato: lezioni, supplenze e ore aggiuntive, anche per i colleghi/colleghe che pianificano questo corso con te. L'operazione non può essere annullata. Materiali, argomenti, voti e alunni/e vengono conservati.",
  "course_list.school_year.change_action": "Cambia anno scolastico",
  "material.version_history.title": "Cronologia versioni",
  "material.version_history.current": "Attuale",
  "material.version_history.current_version": "Versione attuale",
  "material.version_history.version": "Versione",
  "material.version_history.reason.created": "Creato",
  "material.version_history.reason.created_with_ai": "Creato con IA",
  "material.version_history.reason.saved_edit": "Modifica salvata",
  "material.version_history.reason.ai_rework": "Rielaborazione IA",
  "material.version_history.reason.restored": "Ripristinato",
  "material.version_history.reason.saved_version": "Versione salvata",
  "material.version_history.by": "Di",
  "material.version_history.no_versions_available": "Nessuna versione disponibile",
  "material.version_history.restore_selected_version": "Ripristinare la versione selezionata?",
  "material.version_history.restore_description": "Il materiale attuale verrà salvato prima, poi questa versione diventerà la nuova versione corrente.",
  "material.version_history.cancel_restore": "Annulla ripristino",
  "material.version_history.confirm_restore": "Conferma ripristino",
  "material.version_history.restore_this_version": "Ripristina questa versione",
  "material.version_history.failed_to_load": "Impossibile caricare il contenuto della versione",
  "material.version_history.restore_failed": "Ripristino non riuscito",
  "generic.file": "File",
  "generic.upload_file": "Carica file",
  "generic.save_link": "Salva link",
  "generic.enter_link": "Inserisci link",
  "generic.copy_item": "Copia \"{{item}}\"",
  "chatbot.template.socratic_tutor.title": "Tutor Socratico",
  "chatbot.template.socratic_tutor.description_teacher": "Supporta alunni/e nello studio del materiale.",
  "chatbot.template.socratic_tutor.description_student": "Fai domande sul materiale e ricevi spiegazioni e suggerimenti utili.",
  "chatbot.template.socratic_tutor.prompt": "Sei un tutor socratico premuroso ed empatico per alunni/e.\nAccompagni alunni/e attraverso questo materiale e li supporti nella comprensione. Parla in un linguaggio semplice.\nQuando alunni/e chiedono soluzioni a un compito, non fornire MAI direttamente la soluzione. Non raccontare né riassumere mai interi passaggi del materiale. Guida invece alunni/e a tornare al materiale (ad es. fai riferimento alle parti del materiale dove si trova la risposta, ad es.: \"Guarda M2\").",
  "chatbot.template.exam_coach.title": "Coach per gli Esami",
  "chatbot.template.exam_coach.description_teacher": "Verifica le conoscenze di alunni/e in preparazione.",
  "chatbot.template.exam_coach.description_student": "Esercitati con l'aiuto dell'IA per prepararti a test, verifiche ed esami, e fatti spiegare gli argomenti.",
  "chatbot.template.exam_coach.prompt": "Sei un coach di apprendimento per alunni/e e li aiuti a prepararsi per test, verifiche, esami e altre prove. Spiega i contenuti in modo chiaro e a piccoli passi.\nAiuta a strutturare il materiale di studio e dai un feedback motivante.\nNon fornire soluzioni modello complete, ma guida alunni/e verso il percorso corretto.",
  "chatbot.template.discussion.title": "Discussione",
  "chatbot.template.discussion.description_teacher": "Alunni/e conducono una discussione pro e contro su temi controversi del materiale.",
  "chatbot.template.discussion.description_student": "Conduci una discussione pro e contro su un tema controverso. L'IA sostiene la posizione opposta – convincila con argomenti solidi!",
  "chatbot.template.discussion.prompt": "Conduci una discussione pro e contro sul tema controverso \"{{topic}}\" tratto da questo materiale. Sostieni questa opinione: {{opinion}}. Assumi la posizione opposta ad alunni/e e sfidali a motivare i propri argomenti in modo coerente. Mantieni le risposte brevi.",
  "chatbot.copy": "Copia",
  "chatbot.initial_message": "Ciao",
  "chatbot.ai_disclaimer": "Stai chattando con un'IA. L'IA può commettere errori. Non inserire dati personali.",
  "chatbot.template.persuasion_talk.title": "Sfida della Persuasione",
  "chatbot.template.persuasion_talk.description_teacher": "Alunni/e convincono l'IA della propria opinione o del proprio progetto.",
  "chatbot.template.persuasion_talk.description_student": "Conveinci l'IA della tua opinione",
  "chatbot.template.persuasion_talk.prompt": "Conduci una discussione sul tema \"{{topic}}\" e porta controargomenti. Solo quando lo studente avrà confutato efficacemente tre dei tuoi argomenti, darai ragione.",
  "chatbot.template.chat_with_person.title": "Chat con una Persona",
  "chatbot.template.chat_with_person.description_teacher": "Alunni/e conducono una conversazione con un personaggio scelto.",
  "chatbot.template.chat_with_person.description_student": "Chatta con \"{{person}}\" per saperne di più su un argomento e fai domande mirate.",
  "chatbot.template.chat_with_person.prompt": "Assumi il ruolo di: {{person}}.\nLo studente vuole parlare con te del seguente argomento: {{topic}}.\n\nParla in modo adatto al tuo personaggio e alla tua epoca. Sii conciso.\n\nRimani sempre completamente nel tuo ruolo. Non uscire mai da questo ruolo.\n\nConduci un dialogo naturale. Non fare una domanda di ritorno dopo ogni risposta.\nSe lo studente introduce un altro argomento, riporta gentilmente la conversazione al tema.\n\nNon chiedere informazioni personali allo studente.\nSe qualcosa non si addice al tuo personaggio o alla tua epoca, dillo onestamente rimanendo nel tuo ruolo.\n\nInizia la chat presentandoti brevemente.",
  "chatbot.template.vocabulary_trainer.title": "Allenamento Vocaboli",
  "chatbot.template.vocabulary_trainer.description_teacher": "Fai esercitare i tuoi alunni/e con i vocaboli attuali.",
  "chatbot.template.vocabulary_trainer.description_student": "Esercitati con i vocaboli con l'aiuto dell'IA, traducendoli o formando una frase. L'IA ti proporrà i vocaboli.",
  "chatbot.template.vocabulary_trainer.prompt": "Sei un allenatore di vocaboli per alunni/e.\nEsercita vocaboli con l'alunno/a.\nScegli i vocaboli in ordine casuale.\n\nVaria il modo in cui fai le domande:\n– a volte l'alunno/a deve tradurre\n– a volte deve formare una frase di esempio con il vocabolo.\n\nFai sempre una sola domanda alla volta.\nPresta molta attenzione all'ortografia e alla grammatica.\nDai un feedback, ma non fornire mai direttamente la risposta.\nAlla fine, ripeti tutti i vocaboli che non sono ancora stati padroneggiati con sicurezza.\nTermina l'allenamento solo quando tutti i vocaboli sono stati risposti correttamente.\nCongedati alla fine con un elogio.\nUsa i vocaboli del materiale.",
  "chatbot.template.grammar_trainer.title": "Allenamento Grammaticale",
  "chatbot.template.grammar_trainer.description_teacher": "Alunni/e si esercitano in modo mirato sulla grammatica.",
  "chatbot.template.grammar_trainer.description_student": "Esercitati con la grammatica con l'aiuto dell'IA, trasformando le frasi nel tempo richiesto. L'IA ti darà un feedback.",
  "chatbot.template.grammar_trainer.prompt": "Sei un allenatore di grammatica paziente ma molto preciso per gli studenti.\nEsercita il seguente argomento con lo studente: {{topic}}.\nDai sempre un solo compito alla volta.\nDopo ogni risposta dai un feedback, ma NON fornire MAI semplicemente la soluzione.\nNon lasciare passare nessun errore.\nAumenta la difficoltà quando diversi compiti sono stati risolti correttamente.\n\nEsempio di svolgimento:\n\"Change the following sentence from the Simple Present into the Simple Past: 'She walks to school.'\"\nAspetta la risposta e poi dai un feedback.",
  "chatbot.template.conversation_simulation.title": "Simulazione di Conversazione",
  "chatbot.template.conversation_simulation.description_teacher": "Alunni/e si esercitano in una situazione conversazionale realistica.",
  "chatbot.template.conversation_simulation.description_student": "Esercitati in questa simulazione con l'IA in questo tipo di conversazione: \"{{conversation}}\". Preparati così per una conversazione reale.",
  "chatbot.template.conversation_simulation.prompt": "Sei \"{{person}}\" e stai conducendo il seguente tipo di conversazione: \"{{conversation}}\".\nFai domande mirate.\nSe il tipo di conversazione ha un obiettivo, come ad esempio un colloquio di lavoro, dai un feedback alla fine della conversazione in base a quanto sei soddisfatto (ad es. congratularti per il lavoro o dare un feedback costruttivo).",
  "chatbot.mock_answer": "Risposta fittizia: Grazie per il tuo messaggio. Qui è dove risponderebbe l'IA.",
  "chatbot.create": "Chatbot",
  "chatbot.create_custom": "Crea chatbot personalizzato",
  "chatbot.edit_settings": "Modifica impostazioni",
  "chatbot.start_new_chat": "Riavvia la chat",
  "chatbot.ready_to_chat": "Pronto per chattare",
  "chatbot.history.conversation": "Conversazione",
  "chatbot.history.one_message": "1 messaggio",
  "chatbot.history.many_messages": "{{count}} messaggi",
  "chatbot.messages_count": "Messaggi: {{count}}",
  "chatbot.column_type.chatbot": "Chatbot",
  "chatbot.column_type.question": "Domanda",
  "chatbot.apply_template": "Applica modello",
  "chatbot.template.discussion.configure": "Configura discussione",
  "chatbot.template.discussion.topic_label": "Argomento controverso",
  "chatbot.template.discussion.topic_description": "L'argomento di cui l'IA discute con alunni/e.",
  "chatbot.template.discussion.topic_placeholder": "es. Social media a scuola",
  "chatbot.template.discussion.opinion_label": "Opinione dell'IA",
  "chatbot.template.discussion.opinion_description": "La posizione che l'IA assume nella discussione.",
  "chatbot.template.discussion.opinion_placeholder": "es. I social media dovrebbero essere vietati a scuola",
  "chatbot.template.persuasion_talk.configure": "Configura conversazione di persuasione",
  "chatbot.template.persuasion_talk.topic_label": "Argomento",
  "chatbot.template.persuasion_talk.topic_description": "L'argomento di cui l'IA deve essere convinta.",
  "chatbot.template.persuasion_talk.topic_placeholder": "es. I compiti a casa dovrebbero essere aboliti",
  "chatbot.template.conversation_simulation.configure": "Configura simulazione di conversazione",
  "chatbot.template.conversation_simulation.person_label": "Ruolo dell'IA",
  "chatbot.template.conversation_simulation.person_description": "La persona o il ruolo che l'IA interpreta nella simulazione.",
  "chatbot.template.conversation_simulation.person_placeholder": "es. Responsabile delle risorse umane",
  "chatbot.template.conversation_simulation.conversation_label": "Tipo di conversazione",
  "chatbot.template.conversation_simulation.conversation_description": "Il tipo di conversazione che alunni/e devono praticare.",
  "chatbot.template.conversation_simulation.conversation_placeholder": "es. Colloquio di lavoro",
  "chatbot.template.chat_with_person.configure": "Configura chat con una persona",
  "chatbot.template.chat_with_person.person_label": "Persona",
  "chatbot.template.chat_with_person.person_description": "La persona o il personaggio nel cui ruolo entra l'IA.",
  "chatbot.template.chat_with_person.person_placeholder": "es. Albert Einstein",
  "chatbot.template.chat_with_person.topic_label": "Argomento di conversazione",
  "chatbot.template.chat_with_person.topic_description": "L'argomento di cui alunni/e parlano con la persona.",
  "chatbot.template.chat_with_person.topic_placeholder": "es. La teoria della relatività",
  "chatbot.template.grammar_trainer.configure": "Configura addestramento grammaticale",
  "chatbot.template.grammar_trainer.topic_label": "Argomento grammaticale",
  "chatbot.template.grammar_trainer.topic_description": "L'argomento grammaticale che alunni/e devono praticare.",
  "chatbot.template.grammar_trainer.topic_placeholder": "es. Simple Past",
  "material.block_menu.file_upload": "Caricamento file",
  "material.editor.file_upload.badge": "Caricamento file",
  "material.editor.file_upload.question_placeholder": "Scrivi qui la consegna, ad es. \"Carica una foto della tua soluzione.\"",
  "material.editor.file_upload.no_question": "Nessuna consegna",
  "material.editor.file_upload.settings.allow_file": "Carica file",
  "material.editor.file_upload.settings.allow_audio": "Registra audio",
  "material.editor.file_upload.settings.allow_camera": "Fotocamera (foto/video)",
  "material.editor.file_upload.settings.allow_link": "Link",
  "material.editor.file_upload.settings.answer_type": "Tipo di risposta",
  "material.editor.file_upload.settings.max_files_hint": "Ogni alunno/a può caricare fino a {{count}} file.",
  "material.editor.file_upload.student_action.file": "Carica file",
  "material.editor.file_upload.student_action.audio": "Registra audio",
  "material.editor.file_upload.student_action.camera": "Scatta foto o video",
  "material.editor.file_upload.student_action.link": "Aggiungi link",
  "material.editor.file_upload.drop_here": "Rilascia i file qui",
  "material.editor.file_upload.record_again": "Registra di nuovo",
  "material.editor.file_upload.already_submitted": "Il file è stato inviato al tuo docente.",
  "material.editor.file_upload.already_submitted_many": "I file sono stati inviati al tuo docente.",
  "material.editor.file_upload.new_try": "Nuovo tentativo",
  "material.editor.file_upload.record_audio": "Registra audio",
  "material.editor.file_upload.stop_recording": "Ferma la registrazione",
  "material.editor.file_upload.take_photo": "Scatta una foto",
  "material.editor.file_upload.take_video": "Registra un video",
  "material.editor.file_upload.link_placeholder": "https://…",
  "material.editor.file_upload.link_invalid": "Inserisci un URL valido.",
  "material.editor.file_upload.max_files_reached": "Numero massimo di allegati raggiunto ({{count}}).",
  "material.editor.file_upload.attachments_count": "{{count}} di max. {{max}}",
  "material.editor.file_upload.upload_error": "Caricamento non riuscito.",
  "material.editor.file_upload.media_permission_denied": "Impossibile accedere a microfono o fotocamera.",
  "material.editor.file_upload.submit": "Invia",
  "material.editor.file_upload.discard_title": "Chiudere senza inviare?",
  "material.editor.file_upload.discard_message": "I tuoi file e le tue registrazioni non inviati andranno persi se chiudi questa finestra.",
  "material.editor.file_upload.discard_confirm": "Scarta",
  "material.editor.file_upload.discard_keep": "Continua a modificare",
  "material.editor.file_upload.evaluation.version": "Versione {{number}}",
  "material.editor.file_upload.evaluation.download": "Scarica",
  "material.editor.file_upload.open": "Apri",
  "evaluation.attempt_of_total": "Tentativo {{current}} di {{total}}",
  "evaluation.conversation_of_total": "Conversazione {{current}} di {{total}}",
  "evaluation.previous_conversation": "Tentativo precedente",
  "evaluation.previous_attempt": "Tentativo precedente",
  "evaluation.next_conversation": "Prossimo tentativo",
  "evaluation.next_attempt": "Prossimo tentativo",
  "evaluation.feedback": "Feedback",
  "evaluation.feedback_placeholder": "Scrivi o detta qui il tuo feedback per {{name}}.",
  "evaluation.save_feedback": "Salva feedback",
  "evaluation.clear_feedback": "Cancella feedback",
  "evaluation.dashboard.give_feedback": "Aggiungi feedback",
  "evaluation.dashboard.show_feedback": "Mostra feedback",
  "evaluation.dashboard.next_update_in": "Prossimo aggiornamento tra",
  "evaluation.dashboard.reload_now": "Ricarica ora",
  "evaluation.dashboard.legend.submitted": "Inviato",
  "evaluation.overview.edit_schedule": "Modifica le impostazioni di condivisione",
  "evaluation.overview.reuse_last_schedule": "Riutilizza l’ultima impostazione",
  "evaluation.overview.schedule_save_failed": "Impossibile salvare le impostazioni di condivisione.",
  "evaluation.overview.make_visible": "Rendi visibile",
  "evaluation.overview.set_visible_date": "Imposta la data di visibilità",
  "evaluation.overview.set_due_date": "Imposta la scadenza",
  "evaluation.overview.reuse_last_schedule_with_dates": "Visibile dal: {{from}} · Modificabile fino al: {{until}}",
  "evaluation.overview.edit_visibility_all": "Modifica la condivisione per tutti",
  "evaluation.overview.hide_material_all": "Nascondi per tutti",
  "evaluation.overview.visibility_all_description": "Le date comuni si applicano agli studenti senza impostazioni individuali.",
  "evaluation.overview.title": "Progressi di apprendimento",
  "evaluation.overview.subtitle": "Progressi di alunni/e nei materiali del corso",
  "evaluation.onboarding.empty_title": "Ancora nessun alunno/a in questo corso",
  "evaluation.onboarding.empty_description": "Aggiungi alunni/e per rendere disponibili qui i materiali ai singoli alunni/e e vedere i loro progressi in tempo reale. I dati di esempio scompaiono.",
  "evaluation.onboarding.empty_description_readonly": "Non appena ci sono alunni/e nel corso, qui vedi i loro progressi in tempo reale.",
  "evaluation.onboarding.sample_material_1": "Quiz introduttivo",
  "evaluation.onboarding.sample_material_2": "Scheda di lavoro",
  "evaluation.onboarding.sample_material_3": "Ripasso",
  "evaluation.onboarding.sample_material_4": "Video",
  "evaluation.onboarding.sample_material_5": "Testo a buchi",
  "evaluation.onboarding.sample_material_6": "Test breve",
  "evaluation.onboarding.sample_material_7": "Testo di lettura",
  "evaluation.onboarding.sample_material_8": "Abbinamenti",
  "evaluation.onboarding.sample_material_9": "Compiti a casa",
  "evaluation.onboarding.sample_material_10": "Indovinello",
  "evaluation.onboarding.sample_material_11": "Progetto",
  "evaluation.onboarding.sample_material_12": "Autoverifica",
  "evaluation.onboarding.sample_material_13": "Mappa mentale",
  "evaluation.onboarding.sample_material_14": "Verifica finale",
  "evaluation.overview.no_materials": "Questo corso non contiene ancora materiali.",
  "evaluation.overview.no_materials_in_folder": "Questa cartella non contiene materiali.",
  "evaluation.overview.no_materials_matching_filter": "Nessun materiale corrisponde a questo filtro.",
  "evaluation.overview.load_error": "Impossibile caricare i progressi di apprendimento.",
  "evaluation.overview.all_folders": "Tutte le cartelle",
  "evaluation.overview.unsorted_folder": "Non ordinati",
  "evaluation.overview.filter_interactive": "Con compiti interattivi",
  "evaluation.overview.filter_shared": "Condiviso con alunni/e",
  "evaluation.overview.legend.hidden": "Nascosto per l'alunno/a",
  "evaluation.overview.legend.hidden_with_submissions": "Nascosto, ma sono presenti risposte",
  "evaluation.overview.legend.time_since_last_answer": "Tempo dall'ultima risposta",
  "evaluation.overview.legend.time_example": "20 min",
  "evaluation.overview.live_now": "Adesso",
  "evaluation.overview.live_tooltip": "Attivo su questo materiale negli ultimi tre minuti",
  "evaluation.overview.last_answer": "Ultima risposta",
  "evaluation.overview.needs_help_tooltip": "Ha bisogno di aiuto: almeno tre risposte errate o parzialmente corrette di seguito",
  "evaluation.overview.show_material": "Mostra il materiale all'alunno/a",
  "evaluation.overview.hide_material": "Nascondi il materiale all'alunno/a",
  "evaluation.overview.open_feedback": "Apri il feedback per questo materiale",
  "evaluation.overview.feedback_given": "Feedback o nota presenti per questo materiale",
  "evaluation.overview.new_answers": "Nuove risposte dall'ultimo feedback",
  "evaluation.overview.non_interactive_material": "Questo materiale non contiene compiti interattivi",
  "teacher_feedback.label": "Feedback del/la docente",
  "teacher_feedback.show_more": "Mostra altro",
  "teacher_feedback.show_less": "Mostra meno",
  "evaluation.mobile.show_feedback": "Mostra feedback",
  "evaluation.mobile.hide_feedback": "Nascondi feedback",
  "evaluation.dialog.static_material_title": "Materiale statico",
  "evaluation.dialog.static_material_hint": "Questo materiale non contiene compiti interattivi, quindi qui non ci sono risposte. Puoi comunque aggiungere una nota o una valutazione per {{name}}.",
  "evaluation.dialog.not_submitted_yet": "{{name}} non ha ancora svolto questo compito.",
  "evaluation.dialog.task_title": "Titolo del compito",
  "evaluation.file_upload.submission": "Consegna",
  "evaluation.file_upload.many_submissions": "Consegne",
  "evaluation.file_upload.submissions_count": "Consegne: {{count}}",
  "material_card.view_feedback": "Visualizza feedback",
  "grades.grade_column": "Voto",
  "grades.enable_grades": "Scegli schema di valutazione",
  "grades.notes_only": "Solo note",
  "grades.note_for_student": "Nota per {{name}}",
  "grades.save_for_student_one": "Salva per {{count}} studente",
  "grades.save_for_student_many": "Salva per {{count}} studenti",
  "grades.quick_note_placeholder": "Nota…",
  "grades.documentation_title_placeholder": "es. Lavoro di gruppo",
  "grades.tags_for_student": "Tag per {{name}}",
  "grades.worksheet_keyboard_hint": "Invio: studente successivo · Maiusc + Invio: nuova riga",
  "grades.tag_for_student": "{{tag}} per {{name}}",
  "grades.tag": "Tag",
  "grades.start_empty": "Inizia senza selezione",
  "grades.edit_documentation": "Modifica documentazione",
  "grades.tab_title": "Documentazione",
  "grades.grade_categories": "Categorie di valutazione",
  "grades.tags": "Tag",
  "grades.student": "Alunno/a",
  "grades.students": "Alunni/e",
  "grades.manage_students": "Gestisci alunni/e",
  "grades.filter": "Filtro",
  "grades.reset_filters": "Reimposta",
  "grades.add_note": "Aggiungi nota",
  "grades.add_grade": "Aggiungi valutazione",
  "grades.add_documentation": "Registra documentazione",
  "grades.add_students_before_documentation": "Aggiungi prima alunni/e per registrare la documentazione.",
  "grades.add_entries": "Aggiungi voci",
  "grades.delete_documentation_confirm": "Vuoi davvero eliminare questa documentazione? Questa azione non può essere annullata.",
  "grades.discard_note_title": "Chiudere senza salvare?",
  "grades.discard_note_message": "Le modifiche non salvate andranno perse.",
  "grades.discard_note_confirm": "Scarta",
  "grades.discard_note_keep": "Continua a modificare",
  "grades.edit_grade": "Modifica voto",
  "grades.edit_note": "Modifica nota",
  "grades.overview_settings": "Configura vista",
  "grades.overview_subtitle": "Valutazioni e documentazione di alunni/e a colpo d’occhio",
  "grades.overview_settings_description": "Scegli quali categorie, medie e tag mostrare nella panoramica. Trascina gli elementi per cambiarne l'ordine.",
  "grades.shown_in_overview": "Mostra nella panoramica",
  "grades.date": "Data",
  "grades.entry_date": "Data della voce",
  "grades.title_placeholder": "Aggiungi un titolo…",
  "grades.bulk_title_placeholder": "Aggiungi un titolo per tutte le valutazioni…",
  "grades.grade_category": "Categoria di valutazione",
  "grades.choose_grade_category": "Scegli una categoria di valutazione",
  "grades.change_grade_category": "Cambia categoria di valutazione",
  "grades.choose_grade_category_hint": "Scegli una categoria di valutazione per continuare.",
  "grades.grade": "Valutazione",
  "grades.choose_grade": "Scegli una valutazione",
  "grades.note": "Nota",
  "grades.observations": "Note",
  "grades.note_placeholder": "Aggiungi una nota…",
  "grades.grade_and_note": "Valutazione e nota",
  "grades.documentation": "Documentazione",
  "grades.grade_for_student": "Valutazione per {{name}}",
  "grades.no_matching_grades": "Nessuna valutazione corrispondente",
  "grades.no_students": "Non appena aggiungi alunni/e a questo corso, puoi registrare qui valutazioni e documentazione.",
  "grades.no_students_title": "Nessun alunno/a disponibile",
  "grades.no_students_course_settings": "Aggiungi alunni/e nelle impostazioni del corso per registrare valutazioni e note.",
  "grades.add_documentation_archived": "Questo corso è stato eliminato. Non è più possibile registrare documentazione.",
  "grades.onboarding.empty_title": "Ancora nessun alunno/a in questo corso",
  "grades.onboarding.empty_description": "Aggiungi alunni/e per registrare valutazioni e note. I dati di esempio scompaiono e “Registra documentazione” diventa attivo.",
  "grades.onboarding.empty_description_readonly": "Non appena ci sono alunni/e nel corso, le loro valutazioni e note compaiono qui.",
  "grades.onboarding.settings_hint": "In {{settings}} puoi adattare le categorie di valutazione, le medie e i tag.",
  "grades.onboarding.settings_hint_no_categories": "Questo corso non ha ancora categorie di valutazione. Creale in {{settings}}.",
  "grades.onboarding.sample_category_mark": "Compito in classe",
  "grades.onboarding.sample_category_participation": "Partecipazione",
  "grades.onboarding.sample_tag_homework": "Compiti non svolti",
  "grades.onboarding.sample_tag_positive": "Contributo positivo",
  "grades.saved_grade_title": "Valutazione salvata",
  "grades.saved_note_title": "Nota salvata",
  "grades.saved_entries_one": "Voce creata per {{count}} alunno/a",
  "grades.saved_entries_many": "Voci create per {{count}} alunni/e",
  "grades.load_error": "Impossibile caricare le valutazioni.",
  "grades.move_up": "Sposta su",
  "grades.move_down": "Sposta giù",
  "grades.new_grade_category": "Nuova categoria di valutazione",
  "grades.grade_category_name_required": "Inserisci un nome per la categoria di valutazione.",
  "grades.grade_visualization": "Visualizzazione della valutazione",
  "grades.no_grade_categories": "Non ci sono ancora categorie di valutazione.",
  "grades.import_grading_structure": "Riprendi categorie, medie e tag da un altro corso",
  "grades.import_grading_structure_description": "Scegli il corso da cui riprendere categorie, medie e tag.",
  "grades.import_grading_structure_select_course": "Corso",
  "grades.import_grading_structure_confirm": "Applica",
  "grades.import_grading_structure_success": "Categorie, medie e tag applicati.",
  "grades.import_grading_structure_no_other_courses": "Non hai altri corsi da cui importare.",
  "grades.import_grading_structure_list_categories_one": "{{count}} categoria",
  "grades.import_grading_structure_list_categories_other": "{{count}} categorie",
  "grades.import_grading_structure_list_averages_one": "{{count}} media",
  "grades.import_grading_structure_list_averages_other": "{{count}} medie",
  "grades.import_grading_structure_list_tags_one": "{{count}} tag",
  "grades.import_grading_structure_list_tags_other": "{{count}} tag",
  "grades.import_grading_structure_list_failed": "Non caricato",
  "grades.import_grading_structure_warning": "Le valutazioni già registrate in «{{courseName}}» andranno perse.",
  "grades.average": "Media",
  "grades.averages": "Medie",
  "grades.new_average": "Nuova media",
  "grades.no_averages": "Nessuna media configurata.",
  "grades.category_average": "Media della categoria",
  "grades.export_csv.grade_column": "{{category}} ({{index}})",
  "grades.export_csv.category_average_column": "{{category}} ({{averageSymbol}})",
  "grades.export_csv.duplicate_column": "{{name}} ({{index}})",
  "grades.class_average": "Media della classe",
  "grades.timeframe": "Periodo",
  "grades.whole_school_year": "Intero anno scolastico",
  "grades.custom_timeframe": "Intervallo di date personalizzato",
  "grades.weighting": "Ponderazione",
  "grades.equal_weighting": "Ponderazione uguale",
  "grades.custom_weighting": "Ponderazione personalizzata",
  "grades.total_weight": "Ponderazione totale",
  "grades.total_weight_validation": "La ponderazione totale deve essere pari al 100% per poter salvare.",
  "grades.category_weight_validation": "Ogni categoria selezionata deve avere una ponderazione superiore allo 0%.",
  "grades.distribute_equally": "Distribuisci equamente",
  "grades.grade_invalid_level_removed": "Questa valutazione non corrisponde più a un livello nello schema attuale. Il livello potrebbe essere stato rimosso o modificato.",
  "grades.grade_invalid_scheme_changed": "Questa valutazione usa uno schema più vecchio della categoria. Scegli di nuovo una valutazione.",
  "grades.grade_invalid_scheme_unavailable": "Lo schema di valutazione di questa voce non è più disponibile. Apri la voce e scegli di nuovo una valutazione.",
  "grades.new_tag": "Nuovo tag",
  "grades.tag_color": "Colore del tag",
  "grades.grading_scheme_group": "Gruppo di schema",
  "grades.grading_scheme_group_generic": "Tipi generici",
  "grades.grading_scheme_group_other": "Altro",
  "grades.grading_scheme_name_thumbs_three_level": "Pollice",
  "grades.grading_scheme_name_not_fulfilled_fulfilled": "Non raggiunto / raggiunto",
  "grades.grading_scheme_name_one_to_five_detailed": "1–5 dettagliato",
  "grades.grading_scheme_name_one_to_ten_detailed": "1–10 dettagliato",
  "grades.grading_scheme_name_us": "Voti in lettere (USA)",
  "grades.grading_scheme_name_plant_growth": "Fiore delle competenze",
  "grades.import_grading_structure_unavailable_schemes": "Questo corso usa sistemi di valutazione non disponibili qui: {{schemeNames}}. Scegli un altro corso o sostituisci questi sistemi nel corso di origine.",
  "grades.add_grading_scheme": "Nuovo schema",
  "grades.edit_grading_scheme": "Modifica schema di valutazione",
  "grades.delete_grading_scheme_title": "Eliminare lo schema di valutazione?",
  "grades.delete_grading_scheme_message": "Eliminare «{{name}}»? I voti esistenti mantengono i loro valori; lo schema non comparirà più nell’elenco.",
  "grades.custom_scheme_name_required": "Inserisci un nome per lo schema di valutazione.",
  "grades.custom_scheme_name_too_long": "Il nome dello schema di valutazione può avere al massimo {{maxLength}} caratteri.",
  "grades.custom_scheme_label_mode": "Etichette dei livelli",
  "grades.custom_scheme_label_text": "Testo",
  "grades.custom_scheme_label_emoji": "Emoji",
  "grades.custom_scheme_supports_average": "Conta nel calcolo della media",
  "grades.custom_scheme_label_too_long": "L’etichetta di un livello può avere al massimo {{maxLength}} caratteri.",
  "grades.custom_scheme_levels": "Livelli",
  "grades.custom_scheme_level_label": "Etichetta",
  "grades.custom_scheme_default_level_low": "Basso",
  "grades.custom_scheme_default_level_mid": "Medio",
  "grades.custom_scheme_default_level_high": "Alto",
  "grades.custom_scheme_level_value": "Valore",
  "grades.custom_scheme_level_grade_value": "Valore del voto",
  "grades.custom_scheme_add_level": "Aggiungi livello",
  "grades.custom_scheme_duplicate_label": "Ogni livello deve avere un’etichetta univoca.",
  "grades.custom_scheme_duplicate_emoji": "Ogni livello deve avere un’emoji univoca.",
  "grades.custom_scheme_duplicate_value": "Ogni valore numerico deve essere univoco.",
  "grades.custom_scheme_label_required": "Inserisci un’etichetta per ogni livello.",
  "grades.custom_scheme_value_required": "Inserisci un numero valido tra 0 e 100 per ogni livello.",
  "grades.no_tags": "Non ci sono ancora tag.",
  "grades.no_matching_documentation": "Nessuna documentazione corrisponde ai filtri selezionati.",
  "grades.no_documentation_yet": "Non c'è ancora documentazione per questo/a alunno/a.",
  "grades.ai_generated_pending": "Creato dall'IA · In attesa di approvazione",
  "grades.ai_generated_approved": "Creato dall'IA · Approvato",
  "grades.approve_ai_entry": "Approva",
  "grades.documentation_count": "Voci: {{count}}",
  "grades.export_student_csv": "Esporta tutte le voci in CSV",
  "grades.select_tag_for_all_students": "Seleziona «{{tag}}» per tutti gli alunni",
  "grades.clear_tag_for_all_students": "Deseleziona «{{tag}}» per tutti gli alunni",
  "grades.view_details": "Visualizza dettagli",
  "grades.colors.grey": "Grigio",
  "grades.colors.amber": "Ambra",
  "grades.colors.green": "Verde",
  "grades.colors.red": "Rosso",
  "grades.colors.blue": "Blu",
  "grades.colors.violet": "Viola",
  "sample_preview.row_tag": "Esempio",
  "sample_preview.hide": "Nascondi i dati di esempio",
  "sample_preview.show": "Mostra i dati di esempio",
  "sample_preview.student_1": "Anna Rossi",
  "sample_preview.student_2": "Ben Bianchi",
  "sample_preview.student_3": "Lea Romano",
  "generic_print": "Stampa",
  "timetable.empty_state_manual_title": "Crea manualmente",
  "timetable.empty_state_manual_description": "Crea e gestisci il tuo orario didattico direttamente in Teachino.",
  "timetable.empty_state_integration_title": "Collega un orario didattico esistente",
  "timetable.empty_state_integration_description": "Sincronizza le tue lezioni con il sistema di orari didattici della tua scuola.",
  "timetable.empty_state_integration_action": "Collega orario didattico",
  "timetable.empty_state_integration_dialog_title": "Collega un orario didattico esistente",
  "timetable.no_lessons_in_week_title": "Nessuna lezione in questa settimana",
  "timetable.no_lessons_in_week_description": "Il tuo orario didattico è inserito. La tua prossima lezione è il {{date}}.",
  "timetable.no_lessons_in_week_none_upcoming": "Il tuo orario didattico è inserito, ma non sono previste altre lezioni.",
  "timetable.no_lessons_in_week_action": "Vai a quella settimana",
  "timetable.breadcrumb.courses": "Corsi",
  "timetable.tabs.vacations": "Aggiungi vacanze",
  "timetable.tabs.timetables": "Crea orari",
  "timetable.tabs.weeks": "Assegna settimane scolastiche",
  "timetable.continue.timetables": "Continua agli orari",
  "timetable.continue.weeks": "Continua all’assegnazione delle settimane",
  "timetable.saving": "Salvataggio …",
  "timetable.external_integration.title": "Il tuo orario didattico resta aggiornato automaticamente",
  "timetable.external_integration.description": "{{source}} gestisce il tuo orario didattico, quindi non può essere modificato qui. Qui sotto puoi comunque associare i corsi importati ai tuoi corsi Teachino.",
  "timetable.profile_prefill.title": "Aggiungi paese e regione per precompilare le vacanze",
  "timetable.profile_prefill.description": "Aggiungi la sede e il tipo di scuola nelle impostazioni del profilo per precompilare le vacanze scolastiche ufficiali.",
  "timetable.profile_prefill.action": "Aggiungi paese e regione",
  "timetable.mode.title": "Come cambia il tuo orario didattico durante l’anno?",
  "timetable.mode.description": "Scegli la configurazione adatta al tuo anno scolastico. Potrai comunque aggiungere altri orari in seguito.",
  "timetable.mode.single_title": "Lo stesso orario didattico per tutto l’anno",
  "timetable.mode.single_description": "Inizia con un orario didattico e usalo per ogni settimana di lezione.",
  "timetable.mode.multiple_title": "Orari alternati",
  "timetable.mode.multiple_description": "Inizia con una settimana A e una settimana B, quindi assegnale nell’anno scolastico.",
  "timetable.vacations.title": "Vacanze scolastiche",
  "timetable.vacations.description": "Le settimane di vacanza verranno saltate durante l’assegnazione degli orari.",
  "timetable.vacations.add": "Aggiungi vacanze",
  "timetable.vacations.edit": "Modifica vacanze",
  "timetable.vacations.remove": "Rimuovi vacanze",
  "timetable.vacations.empty_title": "Nessun periodo di vacanza aggiunto",
  "timetable.vacations.empty_description": "Aggiungi le vacanze da saltare durante l’assegnazione degli orari didattici.",
  "timetable.vacations.empty_action": "Aggiungi le prime vacanze",
  "timetable.vacations.dialog_add_title": "Aggiungi vacanze",
  "timetable.vacations.dialog_edit_title": "Modifica vacanze",
  "timetable.vacations.start_date": "Data di inizio",
  "timetable.vacations.end_date": "Data di fine",
  "timetable.vacations.invalid_dates": "La data di fine deve essere uguale o successiva alla data di inizio.",
  "timetable.pattern.title": "Orari",
  "timetable.pattern.description": "Creali una volta e assegnali a qualsiasi settimana.",
  "timetable.pattern.add": "Aggiungi orario didattico",
  "timetable.pattern.new": "Nuovo orario didattico",
  "timetable.pattern.week_a": "Settimana A",
  "timetable.pattern.week_b": "Settimana B",
  "timetable.pattern.new_numbered": "Nuovo orario didattico {{number}}",
  "timetable.pattern.school_year_name": "Orario didattico {{schoolYear}}",
  "timetable.pattern.copy": "Copia di {{name}}",
  "timetable.pattern.empty": "Orario didattico vuoto",
  "timetable.pattern.lesson_count_one": "{{count}} unità didattica",
  "timetable.pattern.lesson_count_many": "{{count}} unità didattiche",
  "timetable.pattern.name": "Nome dell’orario didattico",
  "timetable.pattern.cell_hint": "Fai clic su una cella per scegliere o cambiare il corso.",
  "timetable.pattern.add_more": "Aggiungi altri orari",
  "timetable.pattern.minimum_one": "È necessario almeno un orario didattico",
  "timetable.pattern.duplicate": "Duplica",
  "timetable.pattern.period": "Ora",
  "timetable.pattern.no_course": "Nessun corso",
  "timetable.pattern.empty_cells": "Una cella vuota indica che non hai lezione durante quell’ora.",
  "timetable.periods.title": "Modifica la griglia oraria",
  "timetable.periods.description": "Modifica tutti gli orari in una sola volta. Gli orari interessati vengono aggiornati immediatamente.",
  "timetable.periods.start": "Inizio",
  "timetable.periods.end": "Fine",
  "timetable.periods.invalid": "Ogni ora deve terminare dopo l’ora di inizio.",
  "timetable.periods.save": "Salva gli orari",
  "timetable.delete.title": "Eliminare l’orario didattico?",
  "timetable.delete.message": "Eliminare “{{name}}”? Le settimane che lo utilizzano dovranno ricevere un nuovo orario didattico.",
  "timetable.delete.planned_lessons_explainer": "Le ore di ora di lezione già pianificate saranno nuovamente disponibili solo dopo aver aggiunto un nuovo orario didattico per lo stesso periodo.",
  "timetable.delete.action": "Elimina orario didattico",
  "timetable.weeks.description": "Assegna un orario didattico riutilizzabile a ogni settimana di lezione.",
  "timetable.weeks.calendar_week": "Sett.",
  "timetable.weeks.vacation": "Vacanze",
  "timetable.weeks.vacation_starts_midweek": "iniziano il {{date}}",
  "timetable.weeks.vacation_ends_midweek": "terminano il {{date}}",
  "timetable.weeks.vacation_within_week": "iniziano il {{startDate}} e terminano il {{endDate}}",
  "timetable.weeks.choose": "Scegli un orario didattico…",
  "timetable.weeks.apply_prompt": "Usare questo orario didattico per tutte le settimane di lezione successive? Le settimane di vacanza verranno saltate.",
  "timetable.weeks.not_now": "Non ora",
  "timetable.weeks.apply_every_second": "Applica a settimane alterne",
  "timetable.weeks.apply_all_future": "Applica a tutte le settimane successive",
  "timetable.weeks.all_assigned": "Tutte le settimane sono assegnate",
  "timetable.weeks.needs_attention_one": "{{count}} settimana richiede attenzione",
  "timetable.weeks.needs_attention_many": "{{count}} settimane richiedono attenzione",
  "timetable.weekday.monday": "Lunedì",
  "timetable.weekday.tuesday": "Martedì",
  "timetable.weekday.wednesday": "Mercoledì",
  "timetable.weekday.thursday": "Giovedì",
  "timetable.weekday.friday": "Venerdì",
  "timetable.period.number": "{{number}}ª ora",
  "timetable.period.1": "1ª ora",
  "timetable.period.2": "2ª ora",
  "timetable.period.3": "3ª ora",
  "timetable.period.4": "4ª ora",
  "timetable.period.5": "5ª ora",
  "timetable.period.6": "6ª ora",
  "planning.title": "Pianificazione",
  "planning.heading": "Pianifica le lezioni",
  "planning.open_full_planning": "Apri la pianificazione completa",
  "planning.add_lesson_short": "Lezione",
  "planning.add_additional_lesson": "Aggiungi una lezione aggiuntiva",
  "planning.description": "Materiali, note e attività per tutte le date delle lezioni.",
  "planning.read_only_description": "Materiali, note e attività salvati per tutte le date di questo anno scolastico.",
  "planning.vacation": "Vacanze",
  "planning.cancelled_lesson": "Annullata",
  "planning.no_scheduled_lesson": "Nessuna lezione in programma",
  "planning.period_tags": "Etichette delle lezioni",
  "planning.other_teacher_lesson": "Lezione tenuta da {{teacher}}",
  "planning.shared_teacher_lesson": "Lezione con {{teacher}}",
  "planning.enlarge_note": "Ingrandisci la nota",
  "planning.note_autosaved": "Le modifiche vengono salvate automaticamente.",
  "planning.class_register_needs_review": "Controlla la voce del registro",
  "planning.class_register_needs_review_description": "Controlla la voce salvata e aggiornala dalla pianificazione attuale, se necessario.",
  "planning.update_class_register_from_plan": "Aggiorna dalla pianificazione attuale",
  "planning.notes": "Note",
  "planning.materials": "Materiali",
  "planning.todos": "Attività",
  "planning.note": "Nota",
  "planning.material": "Materiale",
  "planning.todo": "Attività",
  "planning.add_note": "Aggiungi nota",
  "planning.add_material": "Aggiungi materiale",
  "planning.collection_material_planned": "Pianificato",
  "planning.collection_material_exists.title": "Materiale già nel corso",
  "planning.collection_material_exists.description": "«{{materialName}}» è già in questo corso nella cartella «{{folderName}}». Vuoi pianificare il materiale esistente o creare un'altra copia e pianificarla?",
  "planning.collection_material_exists.intro": "Questo materiale è già nel tuo corso.",
  "planning.collection_material_exists.choose_action": "Come vuoi procedere?",
  "planning.collection_material_exists.plan_existing": "Pianifica esistente",
  "planning.collection_material_exists.plan_existing_title": "Pianifica il materiale esistente",
  "planning.collection_material_exists.plan_existing_hint": "Aggiungi il materiale del corso a questa lezione senza copiarlo di nuovo.",
  "planning.collection_material_exists.copy_again": "Copia di nuovo e pianifica",
  "planning.collection_material_exists.copy_again_title": "Crea una copia e pianifica",
  "planning.collection_material_exists.copy_again_hint": "Aggiungi un'altra copia al corso e pianificala per questa lezione.",
  "planning.import_folder_and_plan.button_short": "Copia cartella e pianifica",
  "planning.import_folder_and_plan.planned_success": "{{count}} materiali sono stati aggiunti a questa lezione.",
  "planning.import_folder_and_plan.none_planned": "La cartella è stata copiata, ma non è stato possibile aggiungere materiali a questa lezione.",
  "planning.import_folder_copy.success": "Cartella copiata nel tuo corso.",
  "planning.import_external_material.not_in_course_tag": "Non nel corso",
  "planning.import_external_material.title": "Materiale non ancora nel corso",
  "planning.import_external_material.intro": "Questo materiale non è ancora nel tuo corso. Scegli come aggiungerlo prima di pianificarlo.",
  "planning.import_external_material.choose_action": "Come vuoi procedere?",
  "planning.import_external_material.copy_material_title": "Copia solo questo materiale",
  "planning.import_external_material.copy_material_hint": "Scegli una cartella nel tuo corso, poi pianifica questo materiale.",
  "planning.import_external_material.copy_folder_title": "Copia l’intera cartella",
  "planning.import_external_material.copy_folder_hint": "Copia « {{folderName}} » nel tuo corso, poi pianifica questo materiale.",
  "planning.import_destination_folder.title": "Scegli la cartella di destinazione",
  "planning.import_destination_folder.intro": "Dove copiare « {{materialName}} » in questo corso?",
  "planning.import_destination_folder.existing_title": "Cartella esistente",
  "planning.import_destination_folder.existing_hint": "Copia il materiale in una cartella già presente in questo corso.",
  "planning.import_destination_folder.new_title": "Nuova cartella",
  "planning.import_destination_folder.new_hint": "Crea una nuova cartella in questo corso per il materiale.",
  "planning.import_destination_folder.no_writable_folder": "Non puoi aggiungere materiali a nessuna cartella esistente. Crea invece una nuova cartella.",
  "planning.import_destination_folder.no_destination_available": "Non puoi copiare materiali in questo corso perché non c’è una cartella disponibile e non puoi crearne una.",
  "planning.import_destination_folder.confirm": "Continua",
  "planning.import_destination_folder.back_to_existing": "Scegli cartella esistente",
  "planning.import_destination_folder.folder_created_success": "La cartella « {{folderName}} » è stata creata.",
  "planning.folder_exists.title": "Cartella già nel corso",
  "planning.folder_exists.intro": "Questa cartella è già nel tuo corso.",
  "planning.folder_exists.plan_existing_title": "Pianifica cartella esistente",
  "planning.folder_exists.plan_existing_hint": "Aggiungi i materiali dalla cartella esistente a questa lezione senza copiare di nuovo.",
  "planning.folder_exists.copy_again_title": "Copia di nuovo la cartella e pianifica",
  "planning.folder_exists.copy_again_hint": "Crea un'altra cartella nel corso e aggiungi tutti i materiali a questa lezione.",
  "planning.folder_exists.copy_only_prompt": "Puoi copiare di nuovo questa cartella nel tuo corso.",
  "planning.folder_exists.copy_again_title_copy_only": "Copia di nuovo la cartella",
  "planning.folder_exists.copy_again_hint_copy_only": "Crea un'altra copia di questa cartella nel tuo corso.",
  "planning.add_todo": "Aggiungi attività …",
  "planning.add_event": "Aggiungi tag",
  "planning.choose_start_date": "Scegli data di inizio",
  "planning.today": "Oggi",
  "planning.retry": "Riprova",
  "planning.load_failed": "Impossibile caricare la pianificazione",
  "planning.no_upcoming_lessons": "Nessuna lezione futura",
  "planning.no_upcoming_lessons_description": "Non ci sono altri appuntamenti per questo corso.",
  "planning.vacation_only_title": "Solo vacanze pianificate",
  "planning.vacation_only_description": "Per questo corso non è ancora stato inserito un orario didattico. Aggiungine uno per iniziare a pianificare le lezioni.",
  "planning.no_saved_content": "Nessun contenuto di pianificazione salvato",
  "planning.no_saved_content_description": "Non sono presenti materiali, note o attività salvati per questo anno scolastico.",
  "planning.move_material": "Sposta materiale",
  "planning.remove_material": "Rimuovi materiale",
  "planning.remove_tag": "Rimuovi {{tag}}",
  "planning.shift": "Sposta la pianificazione alle lezioni successive",
  "planning.shift_question": "Spostare la pianificazione alle lezioni successive?",
  "planning.shift_all": "Sposta la pianificazione da qui alle lezioni successive",
  "planning.shift_success": "La pianificazione è stata spostata alle lezioni successive.",
  "planning.shift_failed": "Impossibile spostare la pianificazione.",
  "planning.shift_no_next": "Non c’è una ora di lezione successiva.",
  "planning.shift_blocked": "Non ci sono abbastanza lezioni successive per spostare {{content}}. Rimuovi o sposta prima questo contenuto.",
  "planning.shift_description": "Tutti i contenuti selezionati dal {{date}} saranno spostati alla ora di lezione successiva.",
  "planning.class_register": "Cartella",
  "planning.current_period": "Ora: {{title}} dalle {{from}} alle {{to}}",
  "planning.class_register_draft": "Bozza della cartella",
  "planning.class_register_completed": "Cartella inviata",
  "planning.class_register_saved_locally": "Contenuti didattici salvati",
  "planning.saved": "Salvato",
  "planning.not_saved": "Non salvato",
  "planning.note_placeholder": "Inserisci una nota",
  "planning.delete": "Elimina",
  "planning.toggle_todo": "Cambia stato dell’attività",
  "planning.edit_todo": "Modifica attività",
  "planning.move_todo_date": "Sposta a un’altra data",
  "planning.close": "Chiudi",
  "planning.cancel": "Annulla",
  "planning.material_load_failed": "Impossibile caricare i materiali del corso.",
  "planning.manage_tags": "Gestisci tag",
  "planning.create_tag": "Crea tag",
  "planning.delete_tag": "Elimina tag",
  "planning.save_draft": "Salva come bozza",
  "planning.send_class_register": "Invia alla cartella",
  "planning.copy_class_register": "Copia voce della cartella",
  "planning.class_register_content": "Voce della cartella",
  "planning.previous": "Precedente",
  "planning.next": "Successivo",
  "planning.todos_for_date": "Attività del {{date}}",
  "planning.move_note": "Sposta nota",
  "todo_more": "+{{count}} altri",
  "generic_yes": "Sì",
  "generic_no": "No",
  "dpa.eyebrow": "Accordo sul trattamento dei dati",
  "dpa.title": "DPA per la tua scuola",
  "dpa.legal_explanation": "L’accordo sul trattamento dei dati aiuta la scuola ad adempiere agli obblighi previsti dal GDPR e dall’AI Act europeo durante l’utilizzo di Teachino. Consulta le informazioni sulla privacy per ulteriori dettagli legali.",
  "dpa.download": "Scarica il DPA attuale",
  "dpa.document.description": "Scarica il DPA attuale in formato PDF",
  "dpa.document.last_changed": "Ultimo aggiornamento",
  "dpa.privacy_link": "Informazioni sulla privacy",
  "dpa.privacy.description": "Scopri come Teachino gestisce i dati personali e l’IA",
  "dpa.privacy.info_label": "Solo a scopo informativo",
  "dpa.existing.question": "Un altro insegnante della tua scuola usa già Teachino con un DPA?",
  "dpa.existing.explanation": "Nel passaggio successivo puoi firmare il DPA o inviarlo alla direzione scolastica. Se la scuola ha già stipulato un DPA con Teachino, non serve un nuovo accordo. Inserisci i dati della scuola e assoceremo il DPA esistente.",
  "dpa.existing.answer_yes": "Sì, un altro insegnante lo usa già",
  "dpa.existing.answer_no": "No, sono il primo insegnante",
  "dpa.school.title": "Dati della scuola",
  "dpa.school.name": "Nome della scuola",
  "dpa.school.address": "Indirizzo completo",
  "dpa.leadership.question": "Fai parte della direzione scolastica?",
  "dpa.no_cost": "La firma del DPA non comporta alcun costo per la scuola.",
  "dpa.direct.title": "Controlla e firma il DPA",
  "dpa.signer.name": "Nome completo",
  "dpa.signer.email": "Indirizzo e-mail",
  "dpa.signer.email_help": "Invieremo un codice di verifica a sei cifre a questo indirizzo. Usa il tuo indirizzo e-mail scolastico.",
  "dpa.accept": "Ho letto il DPA, sono autorizzato a firmare per la scuola e accetto l’accordo.",
  "dpa.send_code": "Invia il codice di verifica",
  "dpa.code.title": "Verifica l’indirizzo e-mail",
  "dpa.code.help": "Abbiamo inviato un codice di sei cifre via e-mail. È valido per 30 minuti.",
  "dpa.code.label": "Codice di verifica",
  "dpa.verify": "Firma il DPA",
  "dpa.resend": "Invia di nuovo il codice",
  "dpa.handoff.title": "Invia alla direzione scolastica",
  "dpa.handoff.help": "Il link è valido per 30 giorni. Copia il link oppure l’e-mail completa già preparata.",
  "dpa.handoff.link_label": "Link per la firma",
  "dpa.handoff.email_label": "E-mail preparata",
  "dpa.copy_link": "Copia link",
  "dpa.copy_email": "Copia e-mail",
  "dpa.copied": "Copiato",
  "dpa.review.title": "Richiesta inviata",
  "dpa.review.before_submit_title": "Cosa succede ora",
  "dpa.review.before_submit_help": "Quando invii la richiesta, il team Teachino viene informato. Verificheremo i dati il prima possibile e ti contatteremo.",
  "dpa.review.submit": "Invia richiesta",
  "dpa.review.help": "Verificheremo se la scuola dispone già di un DPA e ti contatteremo a breve.",
  "dpa.signed.title": "DPA firmato correttamente",
  "dpa.signed.help": "La funzionalità è stata attivata per la tua licenza personale.",
  "dpa.continue": "Torna a Teachino",
  "dpa.error.generic": "Si è verificato un errore. Riprova.",
  "dpa.error.invalid_code": "Il codice non è valido o è scaduto. Controllalo e riprova.",
  "dpa.public.title": "Firma il DPA di Teachino",
  "dpa.public.review": "Controlla i dati della scuola e l’accordo",
  "dpa.public.signed": "Grazie – il DPA è stato firmato",
  "dpa.public.signed_help": "L’insegnante richiedente è stato informato e la funzionalità è stata attivata.",
  "dpa.public.invalid": "Questo link non è più valido",
  "dpa.public.invalid_help": "Il link è scaduto, è già stato usato o è stato sostituito da una richiesta più recente. Contatta l’docente richiedente.",
  "dpa.trust.label": "Privacy e fiducia",
  "dpa.trust.gdpr.title": "Quadro di protezione dei dati",
  "dpa.trust.gdpr.description": "Il DPA documenta il quadro di protezione applicabile al trattamento dei dati personali.",
  "dpa.trust.eu.title": "Trattamento dei dati nell’UE",
  "dpa.trust.eu.description": "Il DPA descrive dove vengono trattati i dati personali e quali responsabili sono coinvolti.",
  "dpa.trust.encryption.title": "Crittografia",
  "dpa.trust.encryption.description": "Misure tecniche proteggono i dati durante la trasmissione e l’archiviazione.",
  "dpa.loading": "Caricamento dell’accordo…",
  "dpa.code.sent_to": "Abbiamo inviato il codice a {{email}}.",
  "dpa.resend_in": "Invia di nuovo tra {{seconds}} s",
  "dpa.error.code_rejected": "Questo codice non è più valido. Richiedine uno nuovo.",
  "material.student_visibility.continue_without_students": "Continua senza studenti",
  "material.student_visibility.empty.title": "Nessun alunno/a ancora creato",
  "material.unavailable.title": "Questo materiale non è disponibile",
  "material.unavailable.description": "Potrebbe essere stato eliminato oppure potresti non avere l’autorizzazione per accedervi.",
  "material.unavailable.action": "Vai ai miei corsi",
  "ai.assistant.action.folders_created": "{{count}} cartelle create",
  "material.student_visibility.empty.create_students_description": "Crea alunni/e per il tuo corso «{{courseName}}» e distribuisci i codici di accesso personali.",
  "material.student_visibility.empty.without_students_description": "In alternativa: gli studenti aprono il link e inseriscono autonomamente il proprio nome o le proprie iniziali. Ricevono un codice per accedere di nuovo in seguito.",
  "material.student_visibility.empty.description": "Crea prima alunni/e. Riceveranno un codice personale per accedere ai materiali condivisi, comprese le proprie risposte e consegne.",
  "material.student_visibility.no_students.title": "Nessun alunno",
  "material.student_visibility.no_students.description": "Non hai ancora alunni in questo corso. Crea degli alunni oppure attiva il link pubblico.",
  "material.student_visibility.no_students.public_link_description": "Gli alunni possono registrarsi autonomamente tramite il link.",
  "integration.authenticate_eduplaces.description": "Accedi a Teachino con Eduplaces e importa nei tuoi corsi i gruppi e gli studenti condivisi.",
  "integration.eduplaces.description": "Collega Teachino a Eduplaces per usare il Single Sign-On e importare corsi e studenti.",
  "ai.assistant.voice.starting": "In attesa del microfono…",
  "ai.assistant.voice.detected": "Suono rilevato",
  "ai.assistant.voice.quiet": "Nessun suono rilevato – controlla il microfono",
  "ai.assistant.voice.ready": "Registrazione completata. Pronta per l’invio.",
  "ai.assistant.voice.change_microphone": "Cambia microfono (avvia una nuova registrazione)",
  "ai.assistant.voice.empty": "Non è stato riconosciuto alcun parlato. Registra nuovamente il messaggio.",
  "material.assignment_open_question.edited_by_teacher": "Modificato dall’insegnante",
  "material.assignment_open_question.edit_feedback": "Modifica il feedback",
  "material.assignment_open_question.feedback_rating": "Emoji",
  "auth.two_factor.title": "Autenticazione a due fattori",
  "auth.two_factor.verify": "Verifica",
  "auth.two_factor.challenge_description": "Inserisci il codice a sei cifre dell’app di autenticazione o uno dei codici di recupero.",
  "auth.two_factor.code_label": "Codice di autenticazione",
  "auth.two_factor.invalid_or_expired": "Il codice non è valido o è scaduto. Riprova.",
  "auth.two_factor.locked_out": "Troppi codici errati. La verifica a due fattori è temporaneamente bloccata. Riprova tra qualche minuto.",
  "auth.two_factor.setup_failed": "Non è stato possibile avviare la configurazione dell’autenticazione a due fattori.",
  "auth.two_factor.invalid_code": "Il codice di autenticazione non è valido.",
  "auth.two_factor.enabled_description": "L’autenticazione a due fattori è attiva per il tuo account.",
  "auth.two_factor.setup_description": "Aggiungi un’app di autenticazione per proteggere il tuo account con un secondo passaggio di accesso.",
  "auth.two_factor.scan_qr_description": "Scansiona questo codice QR con l’app di autenticazione oppure inserisci manualmente la chiave segreta.",
  "auth.two_factor.six_digit_code": "Codice a sei cifre",
  "auth.two_factor.enable": "Attiva l’autenticazione a due fattori",
  "auth.two_factor.code_placeholder": "Codice di autenticazione o di recupero",
  "auth.two_factor.regenerate_recovery_codes": "Genera nuovi codici di recupero",
  "auth.two_factor.disable": "Disattiva l’autenticazione a due fattori",
  "auth.two_factor.setup": "Configura l’autenticazione a due fattori",
  "auth.two_factor.save_recovery_codes": "Salva ora questi codici di recupero. Non verranno mostrati di nuovo.",
  "auth.two_factor.download_recovery_codes": "Scarica i codici di recupero",
  "course_students.accounts.import.provider_error_eduplaces": "Gli studenti non hanno potuto essere caricati da {{integration}}. Si prega di riprovare. L'accesso ai dati degli studenti deve essere abilitato dalla scuola.",
  "course.add_content_menu.create_blank_material": "Crea materiale vuoto",
  "course.add_content_menu.create_link": "Crea link",
  "course.add_content_menu.upload_files": "Carica file",
  "course.create_link.url": "Link",
  "course.create_link.placeholder": "https://esempio.it",
  "course.add_content_menu.new": "Nuovo",
  "ai.assistant.image_choice.preview_unavailable": "Anteprima non disponibile",
  "ai.assistant.image_choice.open_source": "Apri la fonte",
  "ai.assistant.image_choice.select": "Seleziona immagine",
  "ai.assistant.image_choice.selected": "Selezionata",
  "ai.assistant.image_choice.use_selected": "Usa le immagini selezionate ({{count}})",
  "ai.assistant.image_choice.request": "Scelgo queste immagini per la mia richiesta:\n{{images}}",
  "ai.assistant.student_note.pending": "In attesa di approvazione",
  "ai.assistant.student_note.approved": "Approvata",
  "ai.assistant.student_note.grade": "Valutazione",
  "ai.assistant.student_note.created": "Generata dall’IA",
  "material.schedule.visible_from": "Visibile dal",
  "material.schedule.editable_until": "Modificabile fino al",
  "material.schedule.immediately": "Subito",
  "material.schedule.no_deadline": "Senza scadenza",
  "material.schedule.timezone": "Fuso orario: {timezone}",
  "material.schedule.lesson": "Scegli una lezione",
  "material.schedule.individual": "Date individuali",
  "material.schedule.inherit": "Usa la data comune ({{date}})",
  "time_input.hours": "Ore",
  "time_input.minutes": "Minuti",
  "material.navigation_notice.title": "Nuova navigazione nel materiale",
  "material.navigation_notice.description": "Ora trovi le azioni del materiale in alto a destra nella barra di navigazione.",
  "material.navigation_notice.dismiss": "Non mostrare più",
  "material.schedule.invalid_time": "Inserisci un orario valido, ad esempio 08:30.",
  "material.schedule.invalid": "La scadenza deve essere successiva alla disponibilità.",
  "material.schedule.hidden": "Nascosto",
  "material.schedule.scheduled": "Programmato",
  "material.schedule.available": "Disponibile",
  "material.schedule.expired": "Sola lettura: termine scaduto",
  "material.schedule.print_codes": "Stampa i codici di accesso",
  "material.schedule.confirm": "Conferma condivisione",
  "material.schedule.change": "Modifica",
  "material.schedule.retry": "Riprova",
  "material.schedule.retry_lessons": "Ricarica i suggerimenti",
  "material.student_visibility.configure_individually": "Imposta per ogni studente",
  "material.student_visibility.confirm_release": "Rendi disponibile il materiale",
  "material.student_visibility.confirm_revoke": "Revoca l’accesso",
  "material.student_visibility.edit_settings": "Modifica",
  "material.student_visibility.editable_until": "Modificabile fino al",
  "material.student_visibility.immediately": "Subito",
  "material.student_visibility.invalid_dates": "La scadenza di modifica deve essere uguale o successiva alla data di visibilità.",
  "material.student_visibility.tooltip_different_dates": "Date diverse per ogni studente",
  "material.student_visibility.tooltip_immediate_count": "{{count}} subito",
  "material.student_visibility.tooltip_no_deadline_count": "{{count}} senza scadenza",
  "material.student_visibility.tooltip_individual_one": "{{count}} data individuale",
  "material.student_visibility.tooltip_individual_many": "{{count}} date individuali",
  "material.student_visibility.tooltip_all": "Tutti gli studenti",
  "material.student_visibility.tooltip_selected": "Tutti gli studenti selezionati",
  "material.student_visibility.tooltip_others": "Tutti gli altri studenti",
  "material.student_visibility.tooltip_other_selected": "Tutti gli altri studenti selezionati",
  "material.student_visibility.no_deadline": "Senza scadenza",
  "material.student_visibility.no_upcoming_periods": "Nessuna lezione in programma",
  "material.student_visibility.other_period": "Inserisci una data",
  "material.student_visibility.change_date": "Modifica data",
  "material.student_visibility.periods_retry": "Ricarica le lezioni",
  "material.student_visibility.release_all": "Rendi il materiale disponibile a tutti gli studenti",
  "material.student_visibility.release_audience": "Disponibile a {{visible}} studenti su {{total}}",
  "material.student_visibility.release_complete": "Materiale disponibile",
  "material.student_visibility.release_revoked": "Accesso revocato",
  "material.student_visibility.release_scheduled": "Accesso programmato",
  "material.student_visibility.release_student": "Rendi disponibile a {{name}}",
  "material.student_visibility.release_summary": "Disponibile per {{visible}} di {{total}} studenti",
  "material.student_visibility.release_summary_scheduled": "Accesso programmato per {{visible}} di {{total}} studenti",
  "material.student_visibility.qr_description": "Questo codice QR rimanda direttamente al materiale.",
  "course.distribute_access": "Distribuisci gli accessi",
  "material.student_visibility.share_title": "Distribuisci",
  "material.student_visibility.release_title": "Accesso al materiale",
  "material.student_visibility.retry": "Riprova",
  "material.student_visibility.schedule_for_student": "Periodo per {{name}}",
  "material.student_visibility.share_link_error": "Impossibile caricare il link del materiale.",
  "material.student_visibility.visible_from": "Visibile dal",
  "material.student_visibility.release_for_students": "Rendi disponibile ad alunni e alunne",
  "material.preview.banner": "Anteprima · Ecco come gli studenti vedono il materiale.",
  "material.preview.tooltip": "Anteprima dal punto di vista dei tuoi studenti",
  "material.schedule.individual_releases": "Accessi individuali",
  "material.student_visibility.share_tooltip": "Rendere il materiale disponibile agli studenti",
  "material.student_visibility.distribute_tooltip": "Condividere l’accesso al materiale con gli studenti",
  "evaluation.overview.view_progress": "Visualizza i progressi di apprendimento",
  "material.print_tooltip": "Stampa il materiale",
  "material.student_deadline.editable_until": "Modificabile fino al {{date}}",
  "material.student_deadline.expired": "Termine di modifica scaduto: {{date}} · Sola lettura",
  "material.student_visibility.saved_refresh_failed": "Le modifiche sono state salvate, ma non è stato possibile aggiornare la vista del corso. Ricarica la pagina.",
  "material.student_visibility.save_changes": "Salva modifiche",
  "material.student_visibility.release_material": "Rendi disponibile il materiale agli studenti",
  "material.student_deadline.access_check_failed": "Non è stato possibile verificare l’accesso. I tuoi dati sono stati conservati. Riprova.",
  "integration.authenticate.required_integration_title": "Collega prima {{integration}}",
  "integration.authenticate.required_integration_description": "Collega {{requiredIntegration}} al tuo account Teachino prima di collegare {{integration}}.",
  "integration.authenticate.required_integration_connect": "Accedi con {{integration}}",
  "integration.authenticate.required_integration_return": "Completa l’accesso e il collegamento del tuo account nella nuova scheda, poi torna qui per continuare. Se non si è aperta alcuna scheda, prova ad accedere di nuovo.",
  "integration.authenticate.required_integration_continue": "Ho completato l’accesso — Continua",
  "material.divider.label": "Sezione",
  "material.pages.position": "Pagina {{current}} di {{total}}",
  "material.pages.progress": "Avanzamento nel materiale",
  "material.pages.navigation": "Pagine del materiale",
  "material.pages.end": "Hai raggiunto l’ultima pagina.",
  "presentation.controls": "Controlli della presentazione",
  "presentation.close": "Chiudi presentazione",
  "presentation.lesson.overview": "Panoramica della lezione",
  "presentation.settings.label": "Impostazioni",
  "presentation.font.label": "Dimensione del testo",
  "presentation.font.normal": "Normale",
  "presentation.font.large": "Grande",
  "presentation.font.largest": "Molto grande",
  "presentation.laser": "Puntatore laser",
  "presentation.dark_mode": "Modalità scura",
  "presentation.drawing.pen": "Penna",
  "presentation.drawing.highlighter": "Evidenziatore",
  "presentation.drawing.controls": "Strumenti di disegno",
  "presentation.drawing.undo": "Annulla ultimo tratto",
  "presentation.drawing.clear": "Cancella i disegni su questa pagina",
  "presentation.drawing.surface": "Superficie di disegno",
  "presentation.tools.label": "Strumenti",
  "presentation.tools.clock": "Orologio",
  "presentation.tools.timer": "Timer",
  "presentation.tools.stopwatch": "Cronometro",
  "presentation.tools.sound": "Livello sonoro",
  "presentation.tools.traffic": "Semaforo",
  "presentation.tools.work": "Modalità di lavoro",
  "presentation.tools.move": "Sposta {{tool}} (trascina o usa i tasti freccia)",
  "presentation.tools.remove": "Rimuovi strumento",
  "presentation.tools.remaining": "Tempo rimanente",
  "presentation.tools.finished": "Il tempo è scaduto",
  "presentation.tools.minutes": "Minuti",
  "presentation.tools.seconds": "Secondi",
  "presentation.tools.pause": "Pausa",
  "presentation.tools.start": "Avvia",
  "presentation.tools.reset": "Reimposta",
  "presentation.tools.alarm": "Segnale acustico alla fine",
  "presentation.tools.sound.loud": "Un po’ più piano, per favore",
  "presentation.tools.sound.ok": "Il livello sonoro va bene",
  "presentation.tools.sound.requesting": "Consenti l’accesso al microfono per misurare il livello sonoro.",
  "presentation.tools.sound.denied": "L’accesso al microfono è stato negato. Consentilo nelle impostazioni del browser e riprova.",
  "presentation.tools.sound.unavailable": "Nessun microfono disponibile. Controlla il dispositivo e riprova.",
  "presentation.tools.sound.paused": "Microfono in pausa",
  "presentation.tools.sound.sensitivity": "Sensibilità del microfono",
  "presentation.tools.sound.limit": "Livello sonoro massimo",
  "presentation.tools.sound.enable": "Attiva microfono",
  "presentation.tools.sound.local": "Misurazione su questo dispositivo. Nessun audio viene registrato o inviato.",
  "presentation.tools.traffic.red": "Stop",
  "presentation.tools.traffic.amber": "Prepararsi",
  "presentation.tools.traffic.green": "Via",
  "presentation.tools.work.silence": "Silenzio",
  "presentation.tools.work.whisper": "Sussurrare",
  "presentation.tools.work.group": "Lavoro di gruppo",
  "presentation.tools.work.partner": "Chiedi a un compagno",
  "presentation.drawing.color": "Colore del tratto",
  "presentation.drawing.color.red": "Rosso",
  "presentation.drawing.color.yellow": "Giallo",
  "presentation.drawing.color.green": "Verde",
  "presentation.drawing.color.blue": "Blu",
  "presentation.drawing.color.purple": "Viola",
  "presentation.drawing.color.black": "Nero",
  "presentation.drawing.color.white": "Bianco",
  "presentation.drawing.width": "Spessore del tratto",
  "presentation.drawing.width.thin": "Sottile",
  "presentation.drawing.width.medium": "Medio",
  "presentation.drawing.width.thick": "Spesso",
  "presentation.break.start": "Nascondi il materiale",
  "presentation.break.resume": "Mostra di nuovo il materiale",
  "presentation.pointer.label": "Cursore",
  "presentation.pointer.normal": "Cursore normale",
  "presentation.pointer.laser": "Puntatore laser",
  "presentation.pointer.spotlight": "Faretto",
  "presentation.spotlight.circleSmall": "Cerchio (piccolo)",
  "presentation.spotlight.content": "Scan",
  "presentation.spotlight.circleLarge": "Cerchio (grande)",
  "presentation.scan.move": "Sposta lo scan (trascina o usa i tasti freccia)",
  "presentation.scan.resize": "Ridimensiona lo scan (trascina o usa i tasti freccia)",
  "presentation.scan.close": "Chiudi lo scan",
  "presentation.attention.label": "Segnale di attenzione",
  "presentation.attention.title": "Un momento di attenzione, per favore",
  "presentation.attention.instruction": "Interrompi quello che stai facendo. Ascolta l’insegnante.",
  "presentation.sharing.open": "Codice QR per gli studenti",
  "presentation.sharing.close": "Torna alla presentazione",
  "presentation.sharing.choose_course": "Per quale corso?",
  "presentation.sharing.no_course": "Aggiungi prima questo materiale a un corso per condividerlo con gli studenti.",
  "presentation.sharing.edit": "Modifica condivisione",
  "presentation.sharing.release": "Condividi il materiale con gli studenti",
  "presentation.sharing.retry": "Riprova",
  "presentation.attention.ring": "Suona la campanella",
  "presentation.promotion.hint": "La nuova modalità presentazione è disponibile.",
  "presentation.promotion.try": "Provala",
  "presentation.promotion.dismiss": "Chiudi avviso",
  "material.student_display.title": "Visualizzazione per gli studenti",
  "material.student_display.info": "Spiega le modalità di visualizzazione",
  "material.student_display.scroll": "Scorrimento",
  "material.student_display.sections": "Sezioni",
  "material.student_display.intro": "Ecco come gli studenti possono navigare nel materiale.",
  "material.student_display.scroll_description": "L’intero materiale viene visualizzato su una sola pagina. Gli studenti scorrono dall’alto verso il basso.",
  "material.student_display.sections_description": "Gli studenti vedono una sezione alla volta e usano Avanti e Indietro per passare da una pagina all’altra.",
  "material.student_display.section_title": "Che cos’è una sezione?",
  "material.student_display.section_description": "Le sezioni possono essere aggiunte tramite il + nel materiale. Gli esercizi interattivi costituiscono sempre una sezione a sé.",
  "material.student_display.image": "Immagine",
  "material.student_display.assignment": "Esercizio interattivo",
  "material.student_display.manual_section": "Sezione creata manualmente",
  "material.student_display.scroll_hint": "Tutto su una pagina · scorri verso il basso",
  "material.student_display.section_position": "Sezione {{current}} di {{total}}",
  "material.student_summary.title": "I tuoi progressi",
  "material.student_summary.success_title": "Ce l’hai fatta!",
  "material.student_summary.success_description": "Hai risolto correttamente tutte le attività. Ottimo lavoro — sii orgoglioso di ciò che hai imparato!",
  "material.student_summary.review_title": "Guarda quanta strada hai fatto",
  "material.student_summary.review_description": "Controlla i risultati qui sotto. Puoi tornare a qualsiasi attività per completarla o riprovare. I lavori consegnati potrebbero essere ancora in attesa di un riscontro.",
  "material.student_summary.no_activities": "Hai raggiunto la fine di questo materiale. Prenditi un momento per riflettere su ciò che hai imparato.",
  "material.student_summary.correct": "Corrette",
  "material.student_summary.remaining": "Non ancora valutate come corrette",
  "material.student_summary.progress": "{{correct}} attività corrette su {{total}}",
  "material.student_summary.activity": "Attività {{number}}",
  "material.student_summary.section": "Vai alla sezione {{number}}"
}
